import nr, { useEffect as cc, useState as Nr, useRef as Gi, useId as Qx, useMemo as fh } from "react";
import { coreTheme as Qd, iqTheme as tw, getThemeValueByKey as Bn } from "@statsbomb/kitbag-themes";
import { Typography as Gn, useRect as nw, Tooltip as t0 } from "@statsbomb/kitbag-components";
import { useTheme as Dt } from "styled-components";
var ye = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function n0(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Su = { exports: {} }, Ai = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lh;
function ew() {
  if (lh)
    return Ai;
  lh = 1;
  var t = nr, e = Symbol.for("react.element"), i = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, h, d) {
    var _, y = {}, m = null, T = null;
    d !== void 0 && (m = "" + d), h.key !== void 0 && (m = "" + h.key), h.ref !== void 0 && (T = h.ref);
    for (_ in h)
      o.call(h, _) && !u.hasOwnProperty(_) && (y[_] = h[_]);
    if (l && l.defaultProps)
      for (_ in h = l.defaultProps, h)
        y[_] === void 0 && (y[_] = h[_]);
    return { $$typeof: e, type: l, key: m, ref: T, props: y, _owner: s.current };
  }
  return Ai.Fragment = i, Ai.jsx = f, Ai.jsxs = f, Ai;
}
var Ei = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hh;
function rw() {
  return hh || (hh = 1, process.env.NODE_ENV !== "production" && function() {
    var t = nr, e = Symbol.for("react.element"), i = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), _ = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), S = Symbol.iterator, b = "@@iterator";
    function M(A) {
      if (A === null || typeof A != "object")
        return null;
      var F = S && A[S] || A[b];
      return typeof F == "function" ? F : null;
    }
    var I = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(A) {
      {
        for (var F = arguments.length, U = new Array(F > 1 ? F - 1 : 0), Q = 1; Q < F; Q++)
          U[Q - 1] = arguments[Q];
        H("error", A, U);
      }
    }
    function H(A, F, U) {
      {
        var Q = I.ReactDebugCurrentFrame, dt = Q.getStackAddendum();
        dt !== "" && (F += "%s", U = U.concat([dt]));
        var _t = U.map(function(ft) {
          return String(ft);
        });
        _t.unshift("Warning: " + F), Function.prototype.apply.call(console[A], console, _t);
      }
    }
    var B = !1, k = !1, W = !1, K = !1, q = !1, tt;
    tt = Symbol.for("react.module.reference");
    function X(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === o || A === u || q || A === s || A === d || A === _ || K || A === T || B || k || W || typeof A == "object" && A !== null && (A.$$typeof === m || A.$$typeof === y || A.$$typeof === f || A.$$typeof === l || A.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      A.$$typeof === tt || A.getModuleId !== void 0));
    }
    function j(A, F, U) {
      var Q = A.displayName;
      if (Q)
        return Q;
      var dt = F.displayName || F.name || "";
      return dt !== "" ? U + "(" + dt + ")" : U;
    }
    function et(A) {
      return A.displayName || "Context";
    }
    function nt(A) {
      if (A == null)
        return null;
      if (typeof A.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof A == "function")
        return A.displayName || A.name || null;
      if (typeof A == "string")
        return A;
      switch (A) {
        case o:
          return "Fragment";
        case i:
          return "Portal";
        case u:
          return "Profiler";
        case s:
          return "StrictMode";
        case d:
          return "Suspense";
        case _:
          return "SuspenseList";
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case l:
            var F = A;
            return et(F) + ".Consumer";
          case f:
            var U = A;
            return et(U._context) + ".Provider";
          case h:
            return j(A, A.render, "ForwardRef");
          case y:
            var Q = A.displayName || null;
            return Q !== null ? Q : nt(A.type) || "Memo";
          case m: {
            var dt = A, _t = dt._payload, ft = dt._init;
            try {
              return nt(ft(_t));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var yt = Object.assign, Tt = 0, Pt, gt, St, Nt, Wt, Gt, ee;
    function re() {
    }
    re.__reactDisabledLog = !0;
    function qr() {
      {
        if (Tt === 0) {
          Pt = console.log, gt = console.info, St = console.warn, Nt = console.error, Wt = console.group, Gt = console.groupCollapsed, ee = console.groupEnd;
          var A = {
            configurable: !0,
            enumerable: !0,
            value: re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: A,
            log: A,
            warn: A,
            error: A,
            group: A,
            groupCollapsed: A,
            groupEnd: A
          });
        }
        Tt++;
      }
    }
    function zn() {
      {
        if (Tt--, Tt === 0) {
          var A = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: yt({}, A, {
              value: Pt
            }),
            info: yt({}, A, {
              value: gt
            }),
            warn: yt({}, A, {
              value: St
            }),
            error: yt({}, A, {
              value: Nt
            }),
            group: yt({}, A, {
              value: Wt
            }),
            groupCollapsed: yt({}, A, {
              value: Gt
            }),
            groupEnd: yt({}, A, {
              value: ee
            })
          });
        }
        Tt < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Xn = I.ReactCurrentDispatcher, He;
    function kt(A, F, U) {
      {
        if (He === void 0)
          try {
            throw Error();
          } catch (dt) {
            var Q = dt.stack.trim().match(/\n( *(at )?)/);
            He = Q && Q[1] || "";
          }
        return `
` + He + A;
      }
    }
    var Ft = !1, bn;
    {
      var ie = typeof WeakMap == "function" ? WeakMap : Map;
      bn = new ie();
    }
    function Be(A, F) {
      if (!A || Ft)
        return "";
      {
        var U = bn.get(A);
        if (U !== void 0)
          return U;
      }
      var Q;
      Ft = !0;
      var dt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var _t;
      _t = Xn.current, Xn.current = null, qr();
      try {
        if (F) {
          var ft = function() {
            throw Error();
          };
          if (Object.defineProperty(ft.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ft, []);
            } catch (on) {
              Q = on;
            }
            Reflect.construct(A, [], ft);
          } else {
            try {
              ft.call();
            } catch (on) {
              Q = on;
            }
            A.call(ft.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (on) {
            Q = on;
          }
          A();
        }
      } catch (on) {
        if (on && Q && typeof on.stack == "string") {
          for (var ut = on.stack.split(`
`), jt = Q.stack.split(`
`), Rt = ut.length - 1, bt = jt.length - 1; Rt >= 1 && bt >= 0 && ut[Rt] !== jt[bt]; )
            bt--;
          for (; Rt >= 1 && bt >= 0; Rt--, bt--)
            if (ut[Rt] !== jt[bt]) {
              if (Rt !== 1 || bt !== 1)
                do
                  if (Rt--, bt--, bt < 0 || ut[Rt] !== jt[bt]) {
                    var rn = `
` + ut[Rt].replace(" at new ", " at ");
                    return A.displayName && rn.includes("<anonymous>") && (rn = rn.replace("<anonymous>", A.displayName)), typeof A == "function" && bn.set(A, rn), rn;
                  }
                while (Rt >= 1 && bt >= 0);
              break;
            }
        }
      } finally {
        Ft = !1, Xn.current = _t, zn(), Error.prepareStackTrace = dt;
      }
      var In = A ? A.displayName || A.name : "", fo = In ? kt(In) : "";
      return typeof A == "function" && bn.set(A, fo), fo;
    }
    function no(A, F, U) {
      return Be(A, !1);
    }
    function hn(A) {
      var F = A.prototype;
      return !!(F && F.isReactComponent);
    }
    function Kn(A, F, U) {
      if (A == null)
        return "";
      if (typeof A == "function")
        return Be(A, hn(A));
      if (typeof A == "string")
        return kt(A);
      switch (A) {
        case d:
          return kt("Suspense");
        case _:
          return kt("SuspenseList");
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case h:
            return no(A.render);
          case y:
            return Kn(A.type, F, U);
          case m: {
            var Q = A, dt = Q._payload, _t = Q._init;
            try {
              return Kn(_t(dt), F, U);
            } catch {
            }
          }
        }
      return "";
    }
    var sr = Object.prototype.hasOwnProperty, xn = {}, Vr = I.ReactDebugCurrentFrame;
    function ur(A) {
      if (A) {
        var F = A._owner, U = Kn(A.type, A._source, F ? F.type : null);
        Vr.setExtraStackFrame(U);
      } else
        Vr.setExtraStackFrame(null);
    }
    function We(A, F, U, Q, dt) {
      {
        var _t = Function.call.bind(sr);
        for (var ft in A)
          if (_t(A, ft)) {
            var ut = void 0;
            try {
              if (typeof A[ft] != "function") {
                var jt = Error((Q || "React class") + ": " + U + " type `" + ft + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[ft] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw jt.name = "Invariant Violation", jt;
              }
              ut = A[ft](F, ft, Q, U, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Rt) {
              ut = Rt;
            }
            ut && !(ut instanceof Error) && (ur(dt), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Q || "React class", U, ft, typeof ut), ur(null)), ut instanceof Error && !(ut.message in xn) && (xn[ut.message] = !0, ur(dt), C("Failed %s type: %s", U, ut.message), ur(null));
          }
      }
    }
    var dn = Array.isArray;
    function oe(A) {
      return dn(A);
    }
    function cr(A) {
      {
        var F = typeof Symbol == "function" && Symbol.toStringTag, U = F && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return U;
      }
    }
    function Va(A) {
      try {
        return Te(A), !1;
      } catch {
        return !0;
      }
    }
    function Te(A) {
      return "" + A;
    }
    function eo(A) {
      if (Va(A))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", cr(A)), Te(A);
    }
    var On = I.ReactCurrentOwner, $e = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fr, lr, Ue;
    Ue = {};
    function Zr(A) {
      if (sr.call(A, "ref")) {
        var F = Object.getOwnPropertyDescriptor(A, "ref").get;
        if (F && F.isReactWarning)
          return !1;
      }
      return A.ref !== void 0;
    }
    function Jr(A) {
      if (sr.call(A, "key")) {
        var F = Object.getOwnPropertyDescriptor(A, "key").get;
        if (F && F.isReactWarning)
          return !1;
      }
      return A.key !== void 0;
    }
    function Qr(A, F) {
      if (typeof A.ref == "string" && On.current && F && On.current.stateNode !== F) {
        var U = nt(On.current.type);
        Ue[U] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', nt(On.current.type), A.ref), Ue[U] = !0);
      }
    }
    function ti(A, F) {
      {
        var U = function() {
          fr || (fr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
        };
        U.isReactWarning = !0, Object.defineProperty(A, "key", {
          get: U,
          configurable: !0
        });
      }
    }
    function ni(A, F) {
      {
        var U = function() {
          lr || (lr = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
        };
        U.isReactWarning = !0, Object.defineProperty(A, "ref", {
          get: U,
          configurable: !0
        });
      }
    }
    var ei = function(A, F, U, Q, dt, _t, ft) {
      var ut = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: A,
        key: F,
        ref: U,
        props: ft,
        // Record the component responsible for creating this element.
        _owner: _t
      };
      return ut._store = {}, Object.defineProperty(ut._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ut, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Q
      }), Object.defineProperty(ut, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: dt
      }), Object.freeze && (Object.freeze(ut.props), Object.freeze(ut)), ut;
    };
    function Za(A, F, U, Q, dt) {
      {
        var _t, ft = {}, ut = null, jt = null;
        U !== void 0 && (eo(U), ut = "" + U), Jr(F) && (eo(F.key), ut = "" + F.key), Zr(F) && (jt = F.ref, Qr(F, dt));
        for (_t in F)
          sr.call(F, _t) && !$e.hasOwnProperty(_t) && (ft[_t] = F[_t]);
        if (A && A.defaultProps) {
          var Rt = A.defaultProps;
          for (_t in Rt)
            ft[_t] === void 0 && (ft[_t] = Rt[_t]);
        }
        if (ut || jt) {
          var bt = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
          ut && ti(ft, bt), jt && ni(ft, bt);
        }
        return ei(A, ut, jt, dt, Q, On.current, ft);
      }
    }
    var ri = I.ReactCurrentOwner, ro = I.ReactDebugCurrentFrame;
    function ae(A) {
      if (A) {
        var F = A._owner, U = Kn(A.type, A._source, F ? F.type : null);
        ro.setExtraStackFrame(U);
      } else
        ro.setExtraStackFrame(null);
    }
    var hr;
    hr = !1;
    function ii(A) {
      return typeof A == "object" && A !== null && A.$$typeof === e;
    }
    function io() {
      {
        if (ri.current) {
          var A = nt(ri.current.type);
          if (A)
            return `

Check the render method of \`` + A + "`.";
        }
        return "";
      }
    }
    function Ja(A) {
      {
        if (A !== void 0) {
          var F = A.fileName.replace(/^.*[\\\/]/, ""), U = A.lineNumber;
          return `

Check your code at ` + F + ":" + U + ".";
        }
        return "";
      }
    }
    var oo = {};
    function ao(A) {
      {
        var F = io();
        if (!F) {
          var U = typeof A == "string" ? A : A.displayName || A.name;
          U && (F = `

Check the top-level render call using <` + U + ">.");
        }
        return F;
      }
    }
    function so(A, F) {
      {
        if (!A._store || A._store.validated || A.key != null)
          return;
        A._store.validated = !0;
        var U = ao(F);
        if (oo[U])
          return;
        oo[U] = !0;
        var Q = "";
        A && A._owner && A._owner !== ri.current && (Q = " It was passed a child from " + nt(A._owner.type) + "."), ae(A), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', U, Q), ae(null);
      }
    }
    function uo(A, F) {
      {
        if (typeof A != "object")
          return;
        if (oe(A))
          for (var U = 0; U < A.length; U++) {
            var Q = A[U];
            ii(Q) && so(Q, F);
          }
        else if (ii(A))
          A._store && (A._store.validated = !0);
        else if (A) {
          var dt = M(A);
          if (typeof dt == "function" && dt !== A.entries)
            for (var _t = dt.call(A), ft; !(ft = _t.next()).done; )
              ii(ft.value) && so(ft.value, F);
        }
      }
    }
    function Qa(A) {
      {
        var F = A.type;
        if (F == null || typeof F == "string")
          return;
        var U;
        if (typeof F == "function")
          U = F.propTypes;
        else if (typeof F == "object" && (F.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        F.$$typeof === y))
          U = F.propTypes;
        else
          return;
        if (U) {
          var Q = nt(F);
          We(U, A.props, "prop", Q, A);
        } else if (F.PropTypes !== void 0 && !hr) {
          hr = !0;
          var dt = nt(F);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", dt || "Unknown");
        }
        typeof F.getDefaultProps == "function" && !F.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function oi(A) {
      {
        for (var F = Object.keys(A.props), U = 0; U < F.length; U++) {
          var Q = F[U];
          if (Q !== "children" && Q !== "key") {
            ae(A), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Q), ae(null);
            break;
          }
        }
        A.ref !== null && (ae(A), C("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function co(A, F, U, Q, dt, _t) {
      {
        var ft = X(A);
        if (!ft) {
          var ut = "";
          (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (ut += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var jt = Ja(dt);
          jt ? ut += jt : ut += io();
          var Rt;
          A === null ? Rt = "null" : oe(A) ? Rt = "array" : A !== void 0 && A.$$typeof === e ? (Rt = "<" + (nt(A.type) || "Unknown") + " />", ut = " Did you accidentally export a JSX literal instead of a component?") : Rt = typeof A, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Rt, ut);
        }
        var bt = Za(A, F, U, dt, _t);
        if (bt == null)
          return bt;
        if (ft) {
          var rn = F.children;
          if (rn !== void 0)
            if (Q)
              if (oe(rn)) {
                for (var In = 0; In < rn.length; In++)
                  uo(rn[In], A);
                Object.freeze && Object.freeze(rn);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              uo(rn, A);
        }
        return A === o ? oi(bt) : Qa(bt), bt;
      }
    }
    function ai(A, F, U) {
      return co(A, F, U, !0);
    }
    function ts(A, F, U) {
      return co(A, F, U, !1);
    }
    var ns = ts, es = ai;
    Ei.Fragment = o, Ei.jsx = ns, Ei.jsxs = es;
  }()), Ei;
}
process.env.NODE_ENV === "production" ? Su.exports = ew() : Su.exports = rw();
var w = Su.exports;
const bu = 0.8, iw = 0.365, ow = 16, aw = (t, e) => (t - e) / 2 + bu * e, sw = (t) => iw * t, e0 = 36, uw = 500 + e0 * 2, dh = 5, ua = {
  DOTTED: "2 5",
  STRIPED: "5 6"
}, ca = parseFloat(Qd.light.typography.bodyMedium.fontSize) * 16, du = parseFloat(Qd.light.typography.bodyMedium.lineHeight) * 16, cw = sw(ca), fw = {
  DEFAULT: 10,
  SIMPLIFIED: 4
}, lw = {
  regular: 10,
  small: 25
}, hw = 600, ki = {
  MAIN: "-radar-shape-main",
  COMPARISON: "-radar-shape-comparison",
  COMBINED: "-radar-shape-combined",
  SLICE_MASK: "-radar-slice-mask"
}, _e = {
  SMALL: 410,
  MEDIUM: 490,
  EXTRA_LARGE: 720
};
function fa(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function dw(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function r0(t) {
  let e, i, o;
  t.length !== 2 ? (e = fa, i = (l, h) => fa(t(l), h), o = (l, h) => t(l) - h) : (e = t === fa || t === dw ? t : gw, i = t, o = t);
  function s(l, h, d = 0, _ = l.length) {
    if (d < _) {
      if (e(h, h) !== 0)
        return _;
      do {
        const y = d + _ >>> 1;
        i(l[y], h) < 0 ? d = y + 1 : _ = y;
      } while (d < _);
    }
    return d;
  }
  function u(l, h, d = 0, _ = l.length) {
    if (d < _) {
      if (e(h, h) !== 0)
        return _;
      do {
        const y = d + _ >>> 1;
        i(l[y], h) <= 0 ? d = y + 1 : _ = y;
      } while (d < _);
    }
    return d;
  }
  function f(l, h, d = 0, _ = l.length) {
    const y = s(l, h, d, _ - 1);
    return y > d && o(l[y - 1], h) > -o(l[y], h) ? y - 1 : y;
  }
  return { left: s, center: f, right: u };
}
function gw() {
  return 0;
}
function pw(t) {
  return t === null ? NaN : +t;
}
const _w = r0(fa), vw = _w.right;
r0(pw).center;
const mw = vw, yw = xw(ww);
function xw(t) {
  return function(e, i, o = i) {
    if (!((i = +i) >= 0))
      throw new RangeError("invalid rx");
    if (!((o = +o) >= 0))
      throw new RangeError("invalid ry");
    let { data: s, width: u, height: f } = e;
    if (!((u = Math.floor(u)) >= 0))
      throw new RangeError("invalid width");
    if (!((f = Math.floor(f !== void 0 ? f : s.length / u)) >= 0))
      throw new RangeError("invalid height");
    if (!u || !f || !i && !o)
      return e;
    const l = i && t(i), h = o && t(o), d = s.slice();
    return l && h ? (Cr(l, d, s, u, f), Cr(l, s, d, u, f), Cr(l, d, s, u, f), Sr(h, s, d, u, f), Sr(h, d, s, u, f), Sr(h, s, d, u, f)) : l ? (Cr(l, s, d, u, f), Cr(l, d, s, u, f), Cr(l, s, d, u, f)) : h && (Sr(h, s, d, u, f), Sr(h, d, s, u, f), Sr(h, s, d, u, f)), e;
  };
}
function Cr(t, e, i, o, s) {
  for (let u = 0, f = o * s; u < f; )
    t(e, i, u, u += o, 1);
}
function Sr(t, e, i, o, s) {
  for (let u = 0, f = o * s; u < o; ++u)
    t(e, i, u, u + f, o);
}
function ww(t) {
  const e = Math.floor(t);
  if (e === t)
    return Aw(t);
  const i = t - e, o = 2 * t + 1;
  return (s, u, f, l, h) => {
    if (!((l -= h) >= f))
      return;
    let d = e * u[f];
    const _ = h * e, y = _ + h;
    for (let m = f, T = f + _; m < T; m += h)
      d += u[Math.min(l, m)];
    for (let m = f, T = l; m <= T; m += h)
      d += u[Math.min(l, m + _)], s[m] = (d + i * (u[Math.max(f, m - y)] + u[Math.min(l, m + y)])) / o, d -= u[Math.max(f, m - _)];
  };
}
function Aw(t) {
  const e = 2 * t + 1;
  return (i, o, s, u, f) => {
    if (!((u -= f) >= s))
      return;
    let l = t * o[s];
    const h = f * t;
    for (let d = s, _ = s + h; d < _; d += f)
      l += o[Math.min(u, d)];
    for (let d = s, _ = u; d <= _; d += f)
      l += o[Math.min(u, d + h)], i[d] = l / e, l -= o[Math.max(s, d - h)];
  };
}
function Ew(t, e) {
  let i = 0;
  if (e === void 0)
    for (let o of t)
      o != null && (o = +o) >= o && ++i;
  else {
    let o = -1;
    for (let s of t)
      (s = e(s, ++o, t)) != null && (s = +s) >= s && ++i;
  }
  return i;
}
function Tw(t, e) {
  let i, o;
  if (e === void 0)
    for (const s of t)
      s != null && (i === void 0 ? s >= s && (i = o = s) : (i > s && (i = s), o < s && (o = s)));
  else {
    let s = -1;
    for (let u of t)
      (u = e(u, ++s, t)) != null && (i === void 0 ? u >= u && (i = o = u) : (i > u && (i = u), o < u && (o = u)));
  }
  return [i, o];
}
class kr {
  constructor() {
    this._partials = new Float64Array(32), this._n = 0;
  }
  add(e) {
    const i = this._partials;
    let o = 0;
    for (let s = 0; s < this._n && s < 32; s++) {
      const u = i[s], f = e + u, l = Math.abs(e) < Math.abs(u) ? e - (f - u) : u - (f - e);
      l && (i[o++] = l), e = f;
    }
    return i[o] = e, this._n = o + 1, this;
  }
  valueOf() {
    const e = this._partials;
    let i = this._n, o, s, u, f = 0;
    if (i > 0) {
      for (f = e[--i]; i > 0 && (o = f, s = e[--i], f = o + s, u = s - (f - o), !u); )
        ;
      i > 0 && (u < 0 && e[i - 1] < 0 || u > 0 && e[i - 1] > 0) && (s = u * 2, o = f + s, s == o - f && (f = o));
    }
    return f;
  }
}
class gh extends Map {
  constructor(e, i = Cw) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: i } }), e != null)
      for (const [o, s] of e)
        this.set(o, s);
  }
  get(e) {
    return super.get(ph(this, e));
  }
  has(e) {
    return super.has(ph(this, e));
  }
  set(e, i) {
    return super.set($w(this, e), i);
  }
  delete(e) {
    return super.delete(Rw(this, e));
  }
}
function ph({ _intern: t, _key: e }, i) {
  const o = e(i);
  return t.has(o) ? t.get(o) : i;
}
function $w({ _intern: t, _key: e }, i) {
  const o = e(i);
  return t.has(o) ? t.get(o) : (t.set(o, i), i);
}
function Rw({ _intern: t, _key: e }, i) {
  const o = e(i);
  return t.has(o) && (i = t.get(o), t.delete(o)), i;
}
function Cw(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
const Sw = Math.sqrt(50), bw = Math.sqrt(10), Ow = Math.sqrt(2);
function _a(t, e, i) {
  const o = (e - t) / Math.max(0, i), s = Math.floor(Math.log10(o)), u = o / Math.pow(10, s), f = u >= Sw ? 10 : u >= bw ? 5 : u >= Ow ? 2 : 1;
  let l, h, d;
  return s < 0 ? (d = Math.pow(10, -s) / f, l = Math.round(t * d), h = Math.round(e * d), l / d < t && ++l, h / d > e && --h, d = -d) : (d = Math.pow(10, s) * f, l = Math.round(t / d), h = Math.round(e / d), l * d < t && ++l, h * d > e && --h), h < l && 0.5 <= i && i < 2 ? _a(t, e, i * 2) : [l, h, d];
}
function fc(t, e, i) {
  if (e = +e, t = +t, i = +i, !(i > 0))
    return [];
  if (t === e)
    return [t];
  const o = e < t, [s, u, f] = o ? _a(e, t, i) : _a(t, e, i);
  if (!(u >= s))
    return [];
  const l = u - s + 1, h = new Array(l);
  if (o)
    if (f < 0)
      for (let d = 0; d < l; ++d)
        h[d] = (u - d) / -f;
    else
      for (let d = 0; d < l; ++d)
        h[d] = (u - d) * f;
  else if (f < 0)
    for (let d = 0; d < l; ++d)
      h[d] = (s + d) / -f;
  else
    for (let d = 0; d < l; ++d)
      h[d] = (s + d) * f;
  return h;
}
function va(t, e, i) {
  return e = +e, t = +t, i = +i, _a(t, e, i)[2];
}
function Iw(t, e, i) {
  e = +e, t = +t, i = +i;
  const o = e < t, s = o ? va(e, t, i) : va(t, e, i);
  return (o ? -1 : 1) * (s < 0 ? 1 / -s : s);
}
function Lw(t, e, i) {
  let o;
  for (; ; ) {
    const s = va(t, e, i);
    if (s === o || s === 0 || !isFinite(s))
      return [t, e];
    s > 0 ? (t = Math.floor(t / s) * s, e = Math.ceil(e / s) * s) : s < 0 && (t = Math.ceil(t * s) / s, e = Math.floor(e * s) / s), o = s;
  }
}
function Mw(t) {
  return Math.max(1, Math.ceil(Math.log(Ew(t)) / Math.LN2) + 1);
}
function _h(t, e) {
  let i;
  if (e === void 0)
    for (const o of t)
      o != null && (i < o || i === void 0 && o >= o) && (i = o);
  else {
    let o = -1;
    for (let s of t)
      (s = e(s, ++o, t)) != null && (i < s || i === void 0 && s >= s) && (i = s);
  }
  return i;
}
function Pw(t, e, i) {
  t = +t, e = +e, i = (s = arguments.length) < 2 ? (e = t, t = 0, 1) : s < 3 ? 1 : +i;
  for (var o = -1, s = Math.max(0, Math.ceil((e - t) / i)) | 0, u = new Array(s); ++o < s; )
    u[o] = t + o * i;
  return u;
}
function lc(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
const vh = Symbol("implicit");
function i0() {
  var t = new gh(), e = [], i = [], o = vh;
  function s(u) {
    let f = t.get(u);
    if (f === void 0) {
      if (o !== vh)
        return o;
      t.set(u, f = e.push(u) - 1);
    }
    return i[f % i.length];
  }
  return s.domain = function(u) {
    if (!arguments.length)
      return e.slice();
    e = [], t = new gh();
    for (const f of u)
      t.has(f) || t.set(f, e.push(f) - 1);
    return s;
  }, s.range = function(u) {
    return arguments.length ? (i = Array.from(u), s) : i.slice();
  }, s.unknown = function(u) {
    return arguments.length ? (o = u, s) : o;
  }, s.copy = function() {
    return i0(e, i).unknown(o);
  }, lc.apply(s, arguments), s;
}
function hc() {
  var t = i0().unknown(void 0), e = t.domain, i = t.range, o = 0, s = 1, u, f, l = !1, h = 0, d = 0, _ = 0.5;
  delete t.unknown;
  function y() {
    var m = e().length, T = s < o, S = T ? s : o, b = T ? o : s;
    u = (b - S) / Math.max(1, m - h + d * 2), l && (u = Math.floor(u)), S += (b - S - u * (m - h)) * _, f = u * (1 - h), l && (S = Math.round(S), f = Math.round(f));
    var M = Pw(m).map(function(I) {
      return S + u * I;
    });
    return i(T ? M.reverse() : M);
  }
  return t.domain = function(m) {
    return arguments.length ? (e(m), y()) : e();
  }, t.range = function(m) {
    return arguments.length ? ([o, s] = m, o = +o, s = +s, y()) : [o, s];
  }, t.rangeRound = function(m) {
    return [o, s] = m, o = +o, s = +s, l = !0, y();
  }, t.bandwidth = function() {
    return f;
  }, t.step = function() {
    return u;
  }, t.round = function(m) {
    return arguments.length ? (l = !!m, y()) : l;
  }, t.padding = function(m) {
    return arguments.length ? (h = Math.min(1, d = +m), y()) : h;
  }, t.paddingInner = function(m) {
    return arguments.length ? (h = Math.min(1, m), y()) : h;
  }, t.paddingOuter = function(m) {
    return arguments.length ? (d = +m, y()) : d;
  }, t.align = function(m) {
    return arguments.length ? (_ = Math.max(0, Math.min(1, m)), y()) : _;
  }, t.copy = function() {
    return hc(e(), [o, s]).round(l).paddingInner(h).paddingOuter(d).align(_);
  }, lc.apply(y(), arguments);
}
function dc(t, e, i) {
  t.prototype = e.prototype = i, i.constructor = t;
}
function o0(t, e) {
  var i = Object.create(t.prototype);
  for (var o in e)
    i[o] = e[o];
  return i;
}
function Yi() {
}
var ji = 0.7, ma = 1 / ji, Pr = "\\s*([+-]?\\d+)\\s*", zi = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", te = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Nw = /^#([0-9a-f]{3,8})$/, kw = new RegExp(`^rgb\\(${Pr},${Pr},${Pr}\\)$`), Dw = new RegExp(`^rgb\\(${te},${te},${te}\\)$`), Fw = new RegExp(`^rgba\\(${Pr},${Pr},${Pr},${zi}\\)$`), Hw = new RegExp(`^rgba\\(${te},${te},${te},${zi}\\)$`), Bw = new RegExp(`^hsl\\(${zi},${te},${te}\\)$`), Ww = new RegExp(`^hsla\\(${zi},${te},${te},${zi}\\)$`), mh = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
dc(Yi, ir, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: yh,
  // Deprecated! Use color.formatHex.
  formatHex: yh,
  formatHex8: Uw,
  formatHsl: Gw,
  formatRgb: xh,
  toString: xh
});
function yh() {
  return this.rgb().formatHex();
}
function Uw() {
  return this.rgb().formatHex8();
}
function Gw() {
  return a0(this).formatHsl();
}
function xh() {
  return this.rgb().formatRgb();
}
function ir(t) {
  var e, i;
  return t = (t + "").trim().toLowerCase(), (e = Nw.exec(t)) ? (i = e[1].length, e = parseInt(e[1], 16), i === 6 ? wh(e) : i === 3 ? new fn(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : i === 8 ? Jo(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : i === 4 ? Jo(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = kw.exec(t)) ? new fn(e[1], e[2], e[3], 1) : (e = Dw.exec(t)) ? new fn(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = Fw.exec(t)) ? Jo(e[1], e[2], e[3], e[4]) : (e = Hw.exec(t)) ? Jo(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = Bw.exec(t)) ? Th(e[1], e[2] / 100, e[3] / 100, 1) : (e = Ww.exec(t)) ? Th(e[1], e[2] / 100, e[3] / 100, e[4]) : mh.hasOwnProperty(t) ? wh(mh[t]) : t === "transparent" ? new fn(NaN, NaN, NaN, 0) : null;
}
function wh(t) {
  return new fn(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Jo(t, e, i, o) {
  return o <= 0 && (t = e = i = NaN), new fn(t, e, i, o);
}
function jw(t) {
  return t instanceof Yi || (t = ir(t)), t ? (t = t.rgb(), new fn(t.r, t.g, t.b, t.opacity)) : new fn();
}
function Ou(t, e, i, o) {
  return arguments.length === 1 ? jw(t) : new fn(t, e, i, o ?? 1);
}
function fn(t, e, i, o) {
  this.r = +t, this.g = +e, this.b = +i, this.opacity = +o;
}
dc(fn, Ou, o0(Yi, {
  brighter(t) {
    return t = t == null ? ma : Math.pow(ma, t), new fn(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? ji : Math.pow(ji, t), new fn(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new fn(rr(this.r), rr(this.g), rr(this.b), ya(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Ah,
  // Deprecated! Use color.formatHex.
  formatHex: Ah,
  formatHex8: zw,
  formatRgb: Eh,
  toString: Eh
}));
function Ah() {
  return `#${er(this.r)}${er(this.g)}${er(this.b)}`;
}
function zw() {
  return `#${er(this.r)}${er(this.g)}${er(this.b)}${er((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Eh() {
  const t = ya(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${rr(this.r)}, ${rr(this.g)}, ${rr(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function ya(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function rr(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function er(t) {
  return t = rr(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Th(t, e, i, o) {
  return o <= 0 ? t = e = i = NaN : i <= 0 || i >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Fn(t, e, i, o);
}
function a0(t) {
  if (t instanceof Fn)
    return new Fn(t.h, t.s, t.l, t.opacity);
  if (t instanceof Yi || (t = ir(t)), !t)
    return new Fn();
  if (t instanceof Fn)
    return t;
  t = t.rgb();
  var e = t.r / 255, i = t.g / 255, o = t.b / 255, s = Math.min(e, i, o), u = Math.max(e, i, o), f = NaN, l = u - s, h = (u + s) / 2;
  return l ? (e === u ? f = (i - o) / l + (i < o) * 6 : i === u ? f = (o - e) / l + 2 : f = (e - i) / l + 4, l /= h < 0.5 ? u + s : 2 - u - s, f *= 60) : l = h > 0 && h < 1 ? 0 : f, new Fn(f, l, h, t.opacity);
}
function Xw(t, e, i, o) {
  return arguments.length === 1 ? a0(t) : new Fn(t, e, i, o ?? 1);
}
function Fn(t, e, i, o) {
  this.h = +t, this.s = +e, this.l = +i, this.opacity = +o;
}
dc(Fn, Xw, o0(Yi, {
  brighter(t) {
    return t = t == null ? ma : Math.pow(ma, t), new Fn(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? ji : Math.pow(ji, t), new Fn(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, i = this.l, o = i + (i < 0.5 ? i : 1 - i) * e, s = 2 * i - o;
    return new fn(
      gu(t >= 240 ? t - 240 : t + 120, s, o),
      gu(t, s, o),
      gu(t < 120 ? t + 240 : t - 120, s, o),
      this.opacity
    );
  },
  clamp() {
    return new Fn($h(this.h), Qo(this.s), Qo(this.l), ya(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = ya(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${$h(this.h)}, ${Qo(this.s) * 100}%, ${Qo(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function $h(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Qo(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function gu(t, e, i) {
  return (t < 60 ? e + (i - e) * t / 60 : t < 180 ? i : t < 240 ? e + (i - e) * (240 - t) / 60 : e) * 255;
}
const gc = (t) => () => t;
function Kw(t, e) {
  return function(i) {
    return t + i * e;
  };
}
function Yw(t, e, i) {
  return t = Math.pow(t, i), e = Math.pow(e, i) - t, i = 1 / i, function(o) {
    return Math.pow(t + o * e, i);
  };
}
function qw(t) {
  return (t = +t) == 1 ? s0 : function(e, i) {
    return i - e ? Yw(e, i, t) : gc(isNaN(e) ? i : e);
  };
}
function s0(t, e) {
  var i = e - t;
  return i ? Kw(t, i) : gc(isNaN(t) ? e : t);
}
const xa = function t(e) {
  var i = qw(e);
  function o(s, u) {
    var f = i((s = Ou(s)).r, (u = Ou(u)).r), l = i(s.g, u.g), h = i(s.b, u.b), d = s0(s.opacity, u.opacity);
    return function(_) {
      return s.r = f(_), s.g = l(_), s.b = h(_), s.opacity = d(_), s + "";
    };
  }
  return o.gamma = t, o;
}(1);
function Vw(t, e) {
  e || (e = []);
  var i = t ? Math.min(e.length, t.length) : 0, o = e.slice(), s;
  return function(u) {
    for (s = 0; s < i; ++s)
      o[s] = t[s] * (1 - u) + e[s] * u;
    return o;
  };
}
function Zw(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Jw(t, e) {
  var i = e ? e.length : 0, o = t ? Math.min(i, t.length) : 0, s = new Array(o), u = new Array(i), f;
  for (f = 0; f < o; ++f)
    s[f] = pc(t[f], e[f]);
  for (; f < i; ++f)
    u[f] = e[f];
  return function(l) {
    for (f = 0; f < o; ++f)
      u[f] = s[f](l);
    return u;
  };
}
function Qw(t, e) {
  var i = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(o) {
    return i.setTime(t * (1 - o) + e * o), i;
  };
}
function Dn(t, e) {
  return t = +t, e = +e, function(i) {
    return t * (1 - i) + e * i;
  };
}
function tA(t, e) {
  var i = {}, o = {}, s;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (s in e)
    s in t ? i[s] = pc(t[s], e[s]) : o[s] = e[s];
  return function(u) {
    for (s in i)
      o[s] = i[s](u);
    return o;
  };
}
var Iu = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, pu = new RegExp(Iu.source, "g");
function nA(t) {
  return function() {
    return t;
  };
}
function eA(t) {
  return function(e) {
    return t(e) + "";
  };
}
function u0(t, e) {
  var i = Iu.lastIndex = pu.lastIndex = 0, o, s, u, f = -1, l = [], h = [];
  for (t = t + "", e = e + ""; (o = Iu.exec(t)) && (s = pu.exec(e)); )
    (u = s.index) > i && (u = e.slice(i, u), l[f] ? l[f] += u : l[++f] = u), (o = o[0]) === (s = s[0]) ? l[f] ? l[f] += s : l[++f] = s : (l[++f] = null, h.push({ i: f, x: Dn(o, s) })), i = pu.lastIndex;
  return i < e.length && (u = e.slice(i), l[f] ? l[f] += u : l[++f] = u), l.length < 2 ? h[0] ? eA(h[0].x) : nA(e) : (e = h.length, function(d) {
    for (var _ = 0, y; _ < e; ++_)
      l[(y = h[_]).i] = y.x(d);
    return l.join("");
  });
}
function pc(t, e) {
  var i = typeof e, o;
  return e == null || i === "boolean" ? gc(e) : (i === "number" ? Dn : i === "string" ? (o = ir(e)) ? (e = o, xa) : u0 : e instanceof ir ? xa : e instanceof Date ? Qw : Zw(e) ? Vw : Array.isArray(e) ? Jw : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? tA : Dn)(t, e);
}
function rA(t, e) {
  return t = +t, e = +e, function(i) {
    return Math.round(t * (1 - i) + e * i);
  };
}
var Rh = 180 / Math.PI, Lu = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function c0(t, e, i, o, s, u) {
  var f, l, h;
  return (f = Math.sqrt(t * t + e * e)) && (t /= f, e /= f), (h = t * i + e * o) && (i -= t * h, o -= e * h), (l = Math.sqrt(i * i + o * o)) && (i /= l, o /= l, h /= l), t * o < e * i && (t = -t, e = -e, h = -h, f = -f), {
    translateX: s,
    translateY: u,
    rotate: Math.atan2(e, t) * Rh,
    skewX: Math.atan(h) * Rh,
    scaleX: f,
    scaleY: l
  };
}
var ta;
function iA(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? Lu : c0(e.a, e.b, e.c, e.d, e.e, e.f);
}
function oA(t) {
  return t == null || (ta || (ta = document.createElementNS("http://www.w3.org/2000/svg", "g")), ta.setAttribute("transform", t), !(t = ta.transform.baseVal.consolidate())) ? Lu : (t = t.matrix, c0(t.a, t.b, t.c, t.d, t.e, t.f));
}
function f0(t, e, i, o) {
  function s(d) {
    return d.length ? d.pop() + " " : "";
  }
  function u(d, _, y, m, T, S) {
    if (d !== y || _ !== m) {
      var b = T.push("translate(", null, e, null, i);
      S.push({ i: b - 4, x: Dn(d, y) }, { i: b - 2, x: Dn(_, m) });
    } else
      (y || m) && T.push("translate(" + y + e + m + i);
  }
  function f(d, _, y, m) {
    d !== _ ? (d - _ > 180 ? _ += 360 : _ - d > 180 && (d += 360), m.push({ i: y.push(s(y) + "rotate(", null, o) - 2, x: Dn(d, _) })) : _ && y.push(s(y) + "rotate(" + _ + o);
  }
  function l(d, _, y, m) {
    d !== _ ? m.push({ i: y.push(s(y) + "skewX(", null, o) - 2, x: Dn(d, _) }) : _ && y.push(s(y) + "skewX(" + _ + o);
  }
  function h(d, _, y, m, T, S) {
    if (d !== y || _ !== m) {
      var b = T.push(s(T) + "scale(", null, ",", null, ")");
      S.push({ i: b - 4, x: Dn(d, y) }, { i: b - 2, x: Dn(_, m) });
    } else
      (y !== 1 || m !== 1) && T.push(s(T) + "scale(" + y + "," + m + ")");
  }
  return function(d, _) {
    var y = [], m = [];
    return d = t(d), _ = t(_), u(d.translateX, d.translateY, _.translateX, _.translateY, y, m), f(d.rotate, _.rotate, y, m), l(d.skewX, _.skewX, y, m), h(d.scaleX, d.scaleY, _.scaleX, _.scaleY, y, m), d = _ = null, function(T) {
      for (var S = -1, b = m.length, M; ++S < b; )
        y[(M = m[S]).i] = M.x(T);
      return y.join("");
    };
  };
}
var aA = f0(iA, "px, ", "px)", "deg)"), sA = f0(oA, ", ", ")", ")");
function uA(t) {
  return function() {
    return t;
  };
}
function cA(t) {
  return +t;
}
var Ch = [0, 1];
function Lr(t) {
  return t;
}
function Mu(t, e) {
  return (e -= t = +t) ? function(i) {
    return (i - t) / e;
  } : uA(isNaN(e) ? NaN : 0.5);
}
function fA(t, e) {
  var i;
  return t > e && (i = t, t = e, e = i), function(o) {
    return Math.max(t, Math.min(e, o));
  };
}
function lA(t, e, i) {
  var o = t[0], s = t[1], u = e[0], f = e[1];
  return s < o ? (o = Mu(s, o), u = i(f, u)) : (o = Mu(o, s), u = i(u, f)), function(l) {
    return u(o(l));
  };
}
function hA(t, e, i) {
  var o = Math.min(t.length, e.length) - 1, s = new Array(o), u = new Array(o), f = -1;
  for (t[o] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++f < o; )
    s[f] = Mu(t[f], t[f + 1]), u[f] = i(e[f], e[f + 1]);
  return function(l) {
    var h = mw(t, l, 1, o) - 1;
    return u[h](s[h](l));
  };
}
function dA(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function gA() {
  var t = Ch, e = Ch, i = pc, o, s, u, f = Lr, l, h, d;
  function _() {
    var m = Math.min(t.length, e.length);
    return f !== Lr && (f = fA(t[0], t[m - 1])), l = m > 2 ? hA : lA, h = d = null, y;
  }
  function y(m) {
    return m == null || isNaN(m = +m) ? u : (h || (h = l(t.map(o), e, i)))(o(f(m)));
  }
  return y.invert = function(m) {
    return f(s((d || (d = l(e, t.map(o), Dn)))(m)));
  }, y.domain = function(m) {
    return arguments.length ? (t = Array.from(m, cA), _()) : t.slice();
  }, y.range = function(m) {
    return arguments.length ? (e = Array.from(m), _()) : e.slice();
  }, y.rangeRound = function(m) {
    return e = Array.from(m), i = rA, _();
  }, y.clamp = function(m) {
    return arguments.length ? (f = m ? !0 : Lr, _()) : f !== Lr;
  }, y.interpolate = function(m) {
    return arguments.length ? (i = m, _()) : i;
  }, y.unknown = function(m) {
    return arguments.length ? (u = m, y) : u;
  }, function(m, T) {
    return o = m, s = T, _();
  };
}
function pA() {
  return gA()(Lr, Lr);
}
function _A(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function wa(t, e) {
  if ((i = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var i, o = t.slice(0, i);
  return [
    o.length > 1 ? o[0] + o.slice(2) : o,
    +t.slice(i + 1)
  ];
}
function Dr(t) {
  return t = wa(Math.abs(t)), t ? t[1] : NaN;
}
function vA(t, e) {
  return function(i, o) {
    for (var s = i.length, u = [], f = 0, l = t[0], h = 0; s > 0 && l > 0 && (h + l + 1 > o && (l = Math.max(1, o - h)), u.push(i.substring(s -= l, s + l)), !((h += l + 1) > o)); )
      l = t[f = (f + 1) % t.length];
    return u.reverse().join(e);
  };
}
function mA(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(i) {
      return t[+i];
    });
  };
}
var yA = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Aa(t) {
  if (!(e = yA.exec(t)))
    throw new Error("invalid format: " + t);
  var e;
  return new _c({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
Aa.prototype = _c.prototype;
function _c(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
_c.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function xA(t) {
  t:
    for (var e = t.length, i = 1, o = -1, s; i < e; ++i)
      switch (t[i]) {
        case ".":
          o = s = i;
          break;
        case "0":
          o === 0 && (o = i), s = i;
          break;
        default:
          if (!+t[i])
            break t;
          o > 0 && (o = 0);
          break;
      }
  return o > 0 ? t.slice(0, o) + t.slice(s + 1) : t;
}
var l0;
function wA(t, e) {
  var i = wa(t, e);
  if (!i)
    return t + "";
  var o = i[0], s = i[1], u = s - (l0 = Math.max(-8, Math.min(8, Math.floor(s / 3))) * 3) + 1, f = o.length;
  return u === f ? o : u > f ? o + new Array(u - f + 1).join("0") : u > 0 ? o.slice(0, u) + "." + o.slice(u) : "0." + new Array(1 - u).join("0") + wa(t, Math.max(0, e + u - 1))[0];
}
function Sh(t, e) {
  var i = wa(t, e);
  if (!i)
    return t + "";
  var o = i[0], s = i[1];
  return s < 0 ? "0." + new Array(-s).join("0") + o : o.length > s + 1 ? o.slice(0, s + 1) + "." + o.slice(s + 1) : o + new Array(s - o.length + 2).join("0");
}
const bh = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: _A,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => Sh(t * 100, e),
  r: Sh,
  s: wA,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function Oh(t) {
  return t;
}
var Ih = Array.prototype.map, Lh = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function AA(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? Oh : vA(Ih.call(t.grouping, Number), t.thousands + ""), i = t.currency === void 0 ? "" : t.currency[0] + "", o = t.currency === void 0 ? "" : t.currency[1] + "", s = t.decimal === void 0 ? "." : t.decimal + "", u = t.numerals === void 0 ? Oh : mA(Ih.call(t.numerals, String)), f = t.percent === void 0 ? "%" : t.percent + "", l = t.minus === void 0 ? "−" : t.minus + "", h = t.nan === void 0 ? "NaN" : t.nan + "";
  function d(y) {
    y = Aa(y);
    var m = y.fill, T = y.align, S = y.sign, b = y.symbol, M = y.zero, I = y.width, C = y.comma, H = y.precision, B = y.trim, k = y.type;
    k === "n" ? (C = !0, k = "g") : bh[k] || (H === void 0 && (H = 12), B = !0, k = "g"), (M || m === "0" && T === "=") && (M = !0, m = "0", T = "=");
    var W = b === "$" ? i : b === "#" && /[boxX]/.test(k) ? "0" + k.toLowerCase() : "", K = b === "$" ? o : /[%p]/.test(k) ? f : "", q = bh[k], tt = /[defgprs%]/.test(k);
    H = H === void 0 ? 6 : /[gprs]/.test(k) ? Math.max(1, Math.min(21, H)) : Math.max(0, Math.min(20, H));
    function X(j) {
      var et = W, nt = K, yt, Tt, Pt;
      if (k === "c")
        nt = q(j) + nt, j = "";
      else {
        j = +j;
        var gt = j < 0 || 1 / j < 0;
        if (j = isNaN(j) ? h : q(Math.abs(j), H), B && (j = xA(j)), gt && +j == 0 && S !== "+" && (gt = !1), et = (gt ? S === "(" ? S : l : S === "-" || S === "(" ? "" : S) + et, nt = (k === "s" ? Lh[8 + l0 / 3] : "") + nt + (gt && S === "(" ? ")" : ""), tt) {
          for (yt = -1, Tt = j.length; ++yt < Tt; )
            if (Pt = j.charCodeAt(yt), 48 > Pt || Pt > 57) {
              nt = (Pt === 46 ? s + j.slice(yt + 1) : j.slice(yt)) + nt, j = j.slice(0, yt);
              break;
            }
        }
      }
      C && !M && (j = e(j, 1 / 0));
      var St = et.length + j.length + nt.length, Nt = St < I ? new Array(I - St + 1).join(m) : "";
      switch (C && M && (j = e(Nt + j, Nt.length ? I - nt.length : 1 / 0), Nt = ""), T) {
        case "<":
          j = et + j + nt + Nt;
          break;
        case "=":
          j = et + Nt + j + nt;
          break;
        case "^":
          j = Nt.slice(0, St = Nt.length >> 1) + et + j + nt + Nt.slice(St);
          break;
        default:
          j = Nt + et + j + nt;
          break;
      }
      return u(j);
    }
    return X.toString = function() {
      return y + "";
    }, X;
  }
  function _(y, m) {
    var T = d((y = Aa(y), y.type = "f", y)), S = Math.max(-8, Math.min(8, Math.floor(Dr(m) / 3))) * 3, b = Math.pow(10, -S), M = Lh[8 + S / 3];
    return function(I) {
      return T(b * I) + M;
    };
  }
  return {
    format: d,
    formatPrefix: _
  };
}
var na, h0, d0;
EA({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function EA(t) {
  return na = AA(t), h0 = na.format, d0 = na.formatPrefix, na;
}
function TA(t) {
  return Math.max(0, -Dr(Math.abs(t)));
}
function $A(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Dr(e) / 3))) * 3 - Dr(Math.abs(t)));
}
function RA(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Dr(e) - Dr(t)) + 1;
}
function CA(t, e, i, o) {
  var s = Iw(t, e, i), u;
  switch (o = Aa(o ?? ",f"), o.type) {
    case "s": {
      var f = Math.max(Math.abs(t), Math.abs(e));
      return o.precision == null && !isNaN(u = $A(s, f)) && (o.precision = u), d0(o, f);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      o.precision == null && !isNaN(u = RA(s, Math.max(Math.abs(t), Math.abs(e)))) && (o.precision = u - (o.type === "e"));
      break;
    }
    case "f":
    case "%": {
      o.precision == null && !isNaN(u = TA(s)) && (o.precision = u - (o.type === "%") * 2);
      break;
    }
  }
  return h0(o);
}
function SA(t) {
  var e = t.domain;
  return t.ticks = function(i) {
    var o = e();
    return fc(o[0], o[o.length - 1], i ?? 10);
  }, t.tickFormat = function(i, o) {
    var s = e();
    return CA(s[0], s[s.length - 1], i ?? 10, o);
  }, t.nice = function(i) {
    i == null && (i = 10);
    var o = e(), s = 0, u = o.length - 1, f = o[s], l = o[u], h, d, _ = 10;
    for (l < f && (d = f, f = l, l = d, d = s, s = u, u = d); _-- > 0; ) {
      if (d = va(f, l, i), d === h)
        return o[s] = f, o[u] = l, e(o);
      if (d > 0)
        f = Math.floor(f / d) * d, l = Math.ceil(l / d) * d;
      else if (d < 0)
        f = Math.ceil(f * d) / d, l = Math.floor(l * d) / d;
      else
        break;
      h = d;
    }
    return t;
  }, t;
}
function xe() {
  var t = pA();
  return t.copy = function() {
    return dA(t, xe());
  }, lc.apply(t, arguments), SA(t);
}
function br(t) {
  return function() {
    return t;
  };
}
const Pu = Math.PI, Nu = 2 * Pu, Qe = 1e-6, bA = Nu - Qe;
function g0(t) {
  this._ += t[0];
  for (let e = 1, i = t.length; e < i; ++e)
    this._ += arguments[e] + t[e];
}
function OA(t) {
  let e = Math.floor(t);
  if (!(e >= 0))
    throw new Error(`invalid digits: ${t}`);
  if (e > 15)
    return g0;
  const i = 10 ** e;
  return function(o) {
    this._ += o[0];
    for (let s = 1, u = o.length; s < u; ++s)
      this._ += Math.round(arguments[s] * i) / i + o[s];
  };
}
class IA {
  constructor(e) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = e == null ? g0 : OA(e);
  }
  moveTo(e, i) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +i}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, i) {
    this._append`L${this._x1 = +e},${this._y1 = +i}`;
  }
  quadraticCurveTo(e, i, o, s) {
    this._append`Q${+e},${+i},${this._x1 = +o},${this._y1 = +s}`;
  }
  bezierCurveTo(e, i, o, s, u, f) {
    this._append`C${+e},${+i},${+o},${+s},${this._x1 = +u},${this._y1 = +f}`;
  }
  arcTo(e, i, o, s, u) {
    if (e = +e, i = +i, o = +o, s = +s, u = +u, u < 0)
      throw new Error(`negative radius: ${u}`);
    let f = this._x1, l = this._y1, h = o - e, d = s - i, _ = f - e, y = l - i, m = _ * _ + y * y;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = i}`;
    else if (m > Qe)
      if (!(Math.abs(y * h - d * _) > Qe) || !u)
        this._append`L${this._x1 = e},${this._y1 = i}`;
      else {
        let T = o - f, S = s - l, b = h * h + d * d, M = T * T + S * S, I = Math.sqrt(b), C = Math.sqrt(m), H = u * Math.tan((Pu - Math.acos((b + m - M) / (2 * I * C))) / 2), B = H / C, k = H / I;
        Math.abs(B - 1) > Qe && this._append`L${e + B * _},${i + B * y}`, this._append`A${u},${u},0,0,${+(y * T > _ * S)},${this._x1 = e + k * h},${this._y1 = i + k * d}`;
      }
  }
  arc(e, i, o, s, u, f) {
    if (e = +e, i = +i, o = +o, f = !!f, o < 0)
      throw new Error(`negative radius: ${o}`);
    let l = o * Math.cos(s), h = o * Math.sin(s), d = e + l, _ = i + h, y = 1 ^ f, m = f ? s - u : u - s;
    this._x1 === null ? this._append`M${d},${_}` : (Math.abs(this._x1 - d) > Qe || Math.abs(this._y1 - _) > Qe) && this._append`L${d},${_}`, o && (m < 0 && (m = m % Nu + Nu), m > bA ? this._append`A${o},${o},0,1,${y},${e - l},${i - h}A${o},${o},0,1,${y},${this._x1 = d},${this._y1 = _}` : m > Qe && this._append`A${o},${o},0,${+(m >= Pu)},${y},${this._x1 = e + o * Math.cos(u)},${this._y1 = i + o * Math.sin(u)}`);
  }
  rect(e, i, o, s) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +i}h${o = +o}v${+s}h${-o}Z`;
  }
  toString() {
    return this._;
  }
}
function LA(t) {
  let e = 3;
  return t.digits = function(i) {
    if (!arguments.length)
      return e;
    if (i == null)
      e = null;
    else {
      const o = Math.floor(i);
      if (!(o >= 0))
        throw new RangeError(`invalid digits: ${i}`);
      e = o;
    }
    return t;
  }, () => new IA(e);
}
function MA(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function p0(t) {
  this._context = t;
}
p0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function PA(t) {
  return new p0(t);
}
function NA(t) {
  return t[0];
}
function kA(t) {
  return t[1];
}
function DA(t, e) {
  var i = br(!0), o = null, s = PA, u = null, f = LA(l);
  t = typeof t == "function" ? t : t === void 0 ? NA : br(t), e = typeof e == "function" ? e : e === void 0 ? kA : br(e);
  function l(h) {
    var d, _ = (h = MA(h)).length, y, m = !1, T;
    for (o == null && (u = s(T = f())), d = 0; d <= _; ++d)
      !(d < _ && i(y = h[d], d, h)) === m && ((m = !m) ? u.lineStart() : u.lineEnd()), m && u.point(+t(y, d, h), +e(y, d, h));
    if (T)
      return u = null, T + "" || null;
  }
  return l.x = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : br(+h), l) : t;
  }, l.y = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : br(+h), l) : e;
  }, l.defined = function(h) {
    return arguments.length ? (i = typeof h == "function" ? h : br(!!h), l) : i;
  }, l.curve = function(h) {
    return arguments.length ? (s = h, o != null && (u = s(o)), l) : s;
  }, l.context = function(h) {
    return arguments.length ? (h == null ? o = u = null : u = s(o = h), l) : o;
  }, l;
}
function Mh() {
}
function _0(t) {
  this._context = t;
}
_0.prototype = {
  areaStart: Mh,
  areaEnd: Mh,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
};
function FA(t) {
  return new _0(t);
}
const vc = 360, v0 = vc / 2, m0 = vc / 4, y0 = m0 * 3, qi = (t) => t * v0 / Math.PI, Ph = (t) => t * (Math.PI / v0), Vi = (t) => Math.PI * 2 / t, Nh = (t, e, i) => Math.cos(t * e - Math.PI / 2) * i, kh = (t, e, i) => Math.sin(t * e - Math.PI / 2) * i, HA = (t, e, i, o) => {
  const s = i - t, u = o - e;
  return Math.hypot(s, u);
}, BA = (t, e, i, o) => {
  const s = i - t, u = o - e;
  return Math.atan2(u, s);
}, WA = (t, e, i, o) => {
  const s = BA(t, e, i, o);
  return qi(s);
}, UA = (t, e, i) => xe().domain([e, i]).range([e, i]).clamp(!0)(t), GA = (t, e) => 1 * (1 / t) * e, jA = (t, e, i, o) => (o - i) / (e - 1) * (t - 1) + i, x0 = (t, e, i, o) => xe([e, i], [o, t]), w0 = (t, e, i, o) => {
  const s = t * o - Math.PI / 2, u = Math.cos(s) * i(e), f = Math.sin(s) * i(e);
  return { x: u, y: f };
}, zA = (t, e, i) => {
  const o = t.length, s = Vi(o);
  return t.map((u, f) => {
    const l = UA(u.value, u.minValue, u.maxValue), h = x0(e, u.minValue, u.maxValue, i);
    return {
      ...w0(s, l, h, f),
      ...u
    };
  });
}, XA = DA().x((t) => t.x).y((t) => t.y).curve(FA), KA = (t, e, i) => {
  const o = t.length, s = Vi(o);
  return t.map((u, f) => {
    const l = x0(e, u.minValue, u.maxValue, i), h = s * f;
    return {
      key: u.key,
      label: u.label,
      angleInRad: h,
      angleInDeg: qi(h),
      lineCoords: w0(s, u.maxValue, l, f),
      minValue: u.minValue,
      maxValue: u.maxValue,
      decimalPlaces: u.decimalPlaces,
      value: u.value,
      comparisonValue: u.comparisonValue
    };
  });
}, ku = (t, e, i) => {
  const o = zA(t, e, i);
  return XA(o);
}, YA = (t) => t.every((e) => e.comparisonValue !== void 0), qA = (t, e) => e === 4 ? t : e <= 10 && t.length > 24 ? `${t.slice(0, 23).trim()}...` : e > 10 && t.length > 20 ? `${t.slice(0, 19).trim()}...` : t, Du = (t, e, i) => new Intl.NumberFormat(e, {
  minimumFractionDigits: i,
  maximumFractionDigits: i
}).format(t), mc = ({
  minValue: t,
  maxValue: e,
  decimalPlaces: i,
  notchesFill: o,
  xEnd: s,
  yEnd: u,
  angleInRad: f,
  centreCircleRadius: l,
  locale: h
}) => Array.from({ length: dh }, (d, _) => {
  const y = t > e, m = (_ + 1) / dh, T = f - Math.PI / 2, S = Math.cos(T) * l, b = Math.sin(T) * l, M = S + (s - S) * m, I = b + (u - b) * m, C = Math.abs(e - t), H = y ? t - C * m : t + C * m, B = Du(H, h, i);
  return /* @__PURE__ */ w.jsx(
    Gn,
    {
      as: "text",
      variant: "bodyMedium",
      className: o,
      x: M,
      y: I + cw,
      textAnchor: "middle",
      children: B
    },
    `text-${_}`
  );
}), Zi = (t) => (e) => `${t}-${e}`, Dh = ({
  children: t,
  title: e,
  isBottomHalf: i,
  isOuterLabel: o,
  isSelected: s
}) => {
  const u = o ? -du * 2 : -du, f = (du - ca) / 2, l = i ? (1 - bu) * ca : bu * ca, _ = `${`translate(0,${u + f + l})`} ${i ? "rotate(180)" : ""}`;
  return /* @__PURE__ */ w.jsxs(
    Gn,
    {
      as: "text",
      variant: s ? "headingSmall" : "bodyMedium",
      x: 0,
      y: 0,
      className: "fill-label",
      transform: _,
      textAnchor: "middle",
      children: [
        /* @__PURE__ */ w.jsx("title", { children: e }),
        t
      ]
    }
  );
}, VA = ({
  id: t,
  axesData: e,
  centreCircleRadius: i,
  selectedKey: o,
  locale: s,
  displayLabels: u,
  displayValues: f,
  displayNotches: l
}) => {
  const h = Zi(t);
  return /* @__PURE__ */ w.jsx("g", { id: h("axes"), children: e.map(
    ({
      angleInDeg: d,
      angleInRad: _,
      lineCoords: { x: y, y: m },
      key: T,
      label: S,
      minValue: b,
      maxValue: M,
      decimalPlaces: I,
      value: C,
      comparisonValue: H
    }) => {
      const B = h(`axis-${T}`), k = d > m0 && d < y0, W = o === T, K = Du(C, s, I), q = H && Du(H, s, I), tt = H ? `${K} (${q})` : K;
      return /* @__PURE__ */ w.jsxs("g", { id: B, children: [
        /* @__PURE__ */ w.jsx("line", { x1: 0, y1: 0, x2: y, y2: m, className: "stroke-axis" }),
        /* @__PURE__ */ w.jsxs("g", { transform: `translate(${y},${m}) rotate(${d})`, children: [
          u && /* @__PURE__ */ w.jsx(Dh, { isSelected: W, title: S, isOuterLabel: !0, isBottomHalf: k, children: qA(S, e.length) }),
          f && /* @__PURE__ */ w.jsx(Dh, { isSelected: W, title: tt, isBottomHalf: k, children: tt })
        ] }),
        l && /* @__PURE__ */ w.jsx(
          mc,
          {
            minValue: b,
            maxValue: M,
            decimalPlaces: I,
            angleInRad: _,
            notchesFill: "fill-notch-main",
            xEnd: y,
            yEnd: m,
            centreCircleRadius: i,
            locale: s
          }
        )
      ] }, B);
    }
  ) });
};
var A0 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function i() {
      for (var o = [], s = 0; s < arguments.length; s++) {
        var u = arguments[s];
        if (u) {
          var f = typeof u;
          if (f === "string" || f === "number")
            o.push(u);
          else if (Array.isArray(u)) {
            if (u.length) {
              var l = i.apply(null, u);
              l && o.push(l);
            }
          } else if (f === "object") {
            if (u.toString !== Object.prototype.toString && !u.toString.toString().includes("[native code]")) {
              o.push(u.toString());
              continue;
            }
            for (var h in u)
              e.call(u, h) && u[h] && o.push(h);
          }
        }
      }
      return o.join(" ");
    }
    t.exports ? (i.default = i, t.exports = i) : window.classNames = i;
  })();
})(A0);
var ZA = A0.exports;
const ln = /* @__PURE__ */ n0(ZA), yc = (t, e, i) => {
  const o = Nh(t, 1, i), s = Nh(e, 1, i), u = kh(t, 1, i), f = kh(e, 1, i);
  return `
    M 0 0
    L ${o} ${u}
    A ${i} ${i} 0 0 1 ${s} ${f}
    Z
  `;
}, JA = ({
  data: t,
  radius: e,
  onSliceClick: i,
  selectedKey: o
}) => {
  const s = t.length, u = Vi(s), f = -(qi(u) / 2);
  return /* @__PURE__ */ w.jsx("g", { transform: `rotate(${f})`, children: t.map((l, h) => {
    const d = h + 1, _ = h * u, y = d * u, m = yc(_, y, e), T = (b) => i(l, b), S = (b) => {
      b.key === "Enter" && T(b);
    };
    return /* @__PURE__ */ w.jsx("g", { children: /* @__PURE__ */ w.jsx(
      "path",
      {
        tabIndex: 0,
        "data-testid": `radar-slice-${l.key}`,
        d: m,
        className: ln(
          "fill-transparent outline-none hover:fill-slice-hover hover:opacity-overlay hover:cursor-pointer focus-visible:fill-slice-hover focus-visible:opacity-overlay focus-visible:cursor-pointer",
          { "stroke-2 stroke-contrast": o === l.key }
        ),
        onClick: T,
        onKeyUp: S,
        strokeDasharray: o === l.key ? ua.STRIPED : void 0
      }
    ) }, `radar-slice-${l.key}`);
  }) });
}, Di = ({
  id: t,
  numberOfRings: e,
  radius: i,
  primaryColour: o,
  secondaryColour: s = o,
  hasOpacity: u = !1,
  hasStroke: f = !1,
  clipPath: l,
  mask: h,
  centreCircleRadius: d,
  strokeDasharray: _,
  displayOuterStroke: y
}) => /* @__PURE__ */ w.jsx(
  "g",
  {
    id: t,
    className: ln({ "opacity-overlay": u }),
    clipPath: l ? `url(#${l})` : void 0,
    mask: h,
    children: Array.from({ length: e }, (m, T) => e - T).map((m) => {
      const T = jA(m, e, d, i), S = m % 2 === 0;
      return /* @__PURE__ */ w.jsx(
        "circle",
        {
          cx: 0,
          cy: 0,
          r: T,
          fill: S ? s : o,
          className: ln({
            "stroke-notch-main": y && m === e || f
          }),
          vectorEffect: "non-scaling-stroke",
          ..._ && {
            strokeDasharray: _
          }
        },
        `circle-ring-${m}`
      );
    })
  }
);
var Fu = "http://www.w3.org/1999/xhtml";
const Fh = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Fu,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Fa(t) {
  var e = t += "", i = e.indexOf(":");
  return i >= 0 && (e = t.slice(0, i)) !== "xmlns" && (t = t.slice(i + 1)), Fh.hasOwnProperty(e) ? { space: Fh[e], local: t } : t;
}
function QA(t) {
  return function() {
    var e = this.ownerDocument, i = this.namespaceURI;
    return i === Fu && e.documentElement.namespaceURI === Fu ? e.createElement(t) : e.createElementNS(i, t);
  };
}
function tE(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function E0(t) {
  var e = Fa(t);
  return (e.local ? tE : QA)(e);
}
function nE() {
}
function xc(t) {
  return t == null ? nE : function() {
    return this.querySelector(t);
  };
}
function eE(t) {
  typeof t != "function" && (t = xc(t));
  for (var e = this._groups, i = e.length, o = new Array(i), s = 0; s < i; ++s)
    for (var u = e[s], f = u.length, l = o[s] = new Array(f), h, d, _ = 0; _ < f; ++_)
      (h = u[_]) && (d = t.call(h, h.__data__, _, u)) && ("__data__" in h && (d.__data__ = h.__data__), l[_] = d);
  return new en(o, this._parents);
}
function T0(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function rE() {
  return [];
}
function $0(t) {
  return t == null ? rE : function() {
    return this.querySelectorAll(t);
  };
}
function iE(t) {
  return function() {
    return T0(t.apply(this, arguments));
  };
}
function oE(t) {
  typeof t == "function" ? t = iE(t) : t = $0(t);
  for (var e = this._groups, i = e.length, o = [], s = [], u = 0; u < i; ++u)
    for (var f = e[u], l = f.length, h, d = 0; d < l; ++d)
      (h = f[d]) && (o.push(t.call(h, h.__data__, d, f)), s.push(h));
  return new en(o, s);
}
function R0(t) {
  return function() {
    return this.matches(t);
  };
}
function C0(t) {
  return function(e) {
    return e.matches(t);
  };
}
var aE = Array.prototype.find;
function sE(t) {
  return function() {
    return aE.call(this.children, t);
  };
}
function uE() {
  return this.firstElementChild;
}
function cE(t) {
  return this.select(t == null ? uE : sE(typeof t == "function" ? t : C0(t)));
}
var fE = Array.prototype.filter;
function lE() {
  return Array.from(this.children);
}
function hE(t) {
  return function() {
    return fE.call(this.children, t);
  };
}
function dE(t) {
  return this.selectAll(t == null ? lE : hE(typeof t == "function" ? t : C0(t)));
}
function gE(t) {
  typeof t != "function" && (t = R0(t));
  for (var e = this._groups, i = e.length, o = new Array(i), s = 0; s < i; ++s)
    for (var u = e[s], f = u.length, l = o[s] = [], h, d = 0; d < f; ++d)
      (h = u[d]) && t.call(h, h.__data__, d, u) && l.push(h);
  return new en(o, this._parents);
}
function S0(t) {
  return new Array(t.length);
}
function pE() {
  return new en(this._enter || this._groups.map(S0), this._parents);
}
function Ea(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
Ea.prototype = {
  constructor: Ea,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function _E(t) {
  return function() {
    return t;
  };
}
function vE(t, e, i, o, s, u) {
  for (var f = 0, l, h = e.length, d = u.length; f < d; ++f)
    (l = e[f]) ? (l.__data__ = u[f], o[f] = l) : i[f] = new Ea(t, u[f]);
  for (; f < h; ++f)
    (l = e[f]) && (s[f] = l);
}
function mE(t, e, i, o, s, u, f) {
  var l, h, d = /* @__PURE__ */ new Map(), _ = e.length, y = u.length, m = new Array(_), T;
  for (l = 0; l < _; ++l)
    (h = e[l]) && (m[l] = T = f.call(h, h.__data__, l, e) + "", d.has(T) ? s[l] = h : d.set(T, h));
  for (l = 0; l < y; ++l)
    T = f.call(t, u[l], l, u) + "", (h = d.get(T)) ? (o[l] = h, h.__data__ = u[l], d.delete(T)) : i[l] = new Ea(t, u[l]);
  for (l = 0; l < _; ++l)
    (h = e[l]) && d.get(m[l]) === h && (s[l] = h);
}
function yE(t) {
  return t.__data__;
}
function xE(t, e) {
  if (!arguments.length)
    return Array.from(this, yE);
  var i = e ? mE : vE, o = this._parents, s = this._groups;
  typeof t != "function" && (t = _E(t));
  for (var u = s.length, f = new Array(u), l = new Array(u), h = new Array(u), d = 0; d < u; ++d) {
    var _ = o[d], y = s[d], m = y.length, T = wE(t.call(_, _ && _.__data__, d, o)), S = T.length, b = l[d] = new Array(S), M = f[d] = new Array(S), I = h[d] = new Array(m);
    i(_, y, b, M, I, T, e);
    for (var C = 0, H = 0, B, k; C < S; ++C)
      if (B = b[C]) {
        for (C >= H && (H = C + 1); !(k = M[H]) && ++H < S; )
          ;
        B._next = k || null;
      }
  }
  return f = new en(f, o), f._enter = l, f._exit = h, f;
}
function wE(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function AE() {
  return new en(this._exit || this._groups.map(S0), this._parents);
}
function EE(t, e, i) {
  var o = this.enter(), s = this, u = this.exit();
  return typeof t == "function" ? (o = t(o), o && (o = o.selection())) : o = o.append(t + ""), e != null && (s = e(s), s && (s = s.selection())), i == null ? u.remove() : i(u), o && s ? o.merge(s).order() : s;
}
function TE(t) {
  for (var e = t.selection ? t.selection() : t, i = this._groups, o = e._groups, s = i.length, u = o.length, f = Math.min(s, u), l = new Array(s), h = 0; h < f; ++h)
    for (var d = i[h], _ = o[h], y = d.length, m = l[h] = new Array(y), T, S = 0; S < y; ++S)
      (T = d[S] || _[S]) && (m[S] = T);
  for (; h < s; ++h)
    l[h] = i[h];
  return new en(l, this._parents);
}
function $E() {
  for (var t = this._groups, e = -1, i = t.length; ++e < i; )
    for (var o = t[e], s = o.length - 1, u = o[s], f; --s >= 0; )
      (f = o[s]) && (u && f.compareDocumentPosition(u) ^ 4 && u.parentNode.insertBefore(f, u), u = f);
  return this;
}
function RE(t) {
  t || (t = CE);
  function e(y, m) {
    return y && m ? t(y.__data__, m.__data__) : !y - !m;
  }
  for (var i = this._groups, o = i.length, s = new Array(o), u = 0; u < o; ++u) {
    for (var f = i[u], l = f.length, h = s[u] = new Array(l), d, _ = 0; _ < l; ++_)
      (d = f[_]) && (h[_] = d);
    h.sort(e);
  }
  return new en(s, this._parents).order();
}
function CE(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function SE() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function bE() {
  return Array.from(this);
}
function OE() {
  for (var t = this._groups, e = 0, i = t.length; e < i; ++e)
    for (var o = t[e], s = 0, u = o.length; s < u; ++s) {
      var f = o[s];
      if (f)
        return f;
    }
  return null;
}
function IE() {
  let t = 0;
  for (const e of this)
    ++t;
  return t;
}
function LE() {
  return !this.node();
}
function ME(t) {
  for (var e = this._groups, i = 0, o = e.length; i < o; ++i)
    for (var s = e[i], u = 0, f = s.length, l; u < f; ++u)
      (l = s[u]) && t.call(l, l.__data__, u, s);
  return this;
}
function PE(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function NE(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function kE(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function DE(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function FE(t, e) {
  return function() {
    var i = e.apply(this, arguments);
    i == null ? this.removeAttribute(t) : this.setAttribute(t, i);
  };
}
function HE(t, e) {
  return function() {
    var i = e.apply(this, arguments);
    i == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, i);
  };
}
function BE(t, e) {
  var i = Fa(t);
  if (arguments.length < 2) {
    var o = this.node();
    return i.local ? o.getAttributeNS(i.space, i.local) : o.getAttribute(i);
  }
  return this.each((e == null ? i.local ? NE : PE : typeof e == "function" ? i.local ? HE : FE : i.local ? DE : kE)(i, e));
}
function b0(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function WE(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function UE(t, e, i) {
  return function() {
    this.style.setProperty(t, e, i);
  };
}
function GE(t, e, i) {
  return function() {
    var o = e.apply(this, arguments);
    o == null ? this.style.removeProperty(t) : this.style.setProperty(t, o, i);
  };
}
function jE(t, e, i) {
  return arguments.length > 1 ? this.each((e == null ? WE : typeof e == "function" ? GE : UE)(t, e, i ?? "")) : Fr(this.node(), t);
}
function Fr(t, e) {
  return t.style.getPropertyValue(e) || b0(t).getComputedStyle(t, null).getPropertyValue(e);
}
function zE(t) {
  return function() {
    delete this[t];
  };
}
function XE(t, e) {
  return function() {
    this[t] = e;
  };
}
function KE(t, e) {
  return function() {
    var i = e.apply(this, arguments);
    i == null ? delete this[t] : this[t] = i;
  };
}
function YE(t, e) {
  return arguments.length > 1 ? this.each((e == null ? zE : typeof e == "function" ? KE : XE)(t, e)) : this.node()[t];
}
function O0(t) {
  return t.trim().split(/^|\s+/);
}
function wc(t) {
  return t.classList || new I0(t);
}
function I0(t) {
  this._node = t, this._names = O0(t.getAttribute("class") || "");
}
I0.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function L0(t, e) {
  for (var i = wc(t), o = -1, s = e.length; ++o < s; )
    i.add(e[o]);
}
function M0(t, e) {
  for (var i = wc(t), o = -1, s = e.length; ++o < s; )
    i.remove(e[o]);
}
function qE(t) {
  return function() {
    L0(this, t);
  };
}
function VE(t) {
  return function() {
    M0(this, t);
  };
}
function ZE(t, e) {
  return function() {
    (e.apply(this, arguments) ? L0 : M0)(this, t);
  };
}
function JE(t, e) {
  var i = O0(t + "");
  if (arguments.length < 2) {
    for (var o = wc(this.node()), s = -1, u = i.length; ++s < u; )
      if (!o.contains(i[s]))
        return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? ZE : e ? qE : VE)(i, e));
}
function QE() {
  this.textContent = "";
}
function tT(t) {
  return function() {
    this.textContent = t;
  };
}
function nT(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function eT(t) {
  return arguments.length ? this.each(t == null ? QE : (typeof t == "function" ? nT : tT)(t)) : this.node().textContent;
}
function rT() {
  this.innerHTML = "";
}
function iT(t) {
  return function() {
    this.innerHTML = t;
  };
}
function oT(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function aT(t) {
  return arguments.length ? this.each(t == null ? rT : (typeof t == "function" ? oT : iT)(t)) : this.node().innerHTML;
}
function sT() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function uT() {
  return this.each(sT);
}
function cT() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function fT() {
  return this.each(cT);
}
function lT(t) {
  var e = typeof t == "function" ? t : E0(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function hT() {
  return null;
}
function dT(t, e) {
  var i = typeof t == "function" ? t : E0(t), o = e == null ? hT : typeof e == "function" ? e : xc(e);
  return this.select(function() {
    return this.insertBefore(i.apply(this, arguments), o.apply(this, arguments) || null);
  });
}
function gT() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function pT() {
  return this.each(gT);
}
function _T() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function vT() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function mT(t) {
  return this.select(t ? vT : _T);
}
function yT(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function xT(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function wT(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var i = "", o = e.indexOf(".");
    return o >= 0 && (i = e.slice(o + 1), e = e.slice(0, o)), { type: e, name: i };
  });
}
function AT(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var i = 0, o = -1, s = e.length, u; i < s; ++i)
        u = e[i], (!t.type || u.type === t.type) && u.name === t.name ? this.removeEventListener(u.type, u.listener, u.options) : e[++o] = u;
      ++o ? e.length = o : delete this.__on;
    }
  };
}
function ET(t, e, i) {
  return function() {
    var o = this.__on, s, u = xT(e);
    if (o) {
      for (var f = 0, l = o.length; f < l; ++f)
        if ((s = o[f]).type === t.type && s.name === t.name) {
          this.removeEventListener(s.type, s.listener, s.options), this.addEventListener(s.type, s.listener = u, s.options = i), s.value = e;
          return;
        }
    }
    this.addEventListener(t.type, u, i), s = { type: t.type, name: t.name, value: e, listener: u, options: i }, o ? o.push(s) : this.__on = [s];
  };
}
function TT(t, e, i) {
  var o = wT(t + ""), s, u = o.length, f;
  if (arguments.length < 2) {
    var l = this.node().__on;
    if (l) {
      for (var h = 0, d = l.length, _; h < d; ++h)
        for (s = 0, _ = l[h]; s < u; ++s)
          if ((f = o[s]).type === _.type && f.name === _.name)
            return _.value;
    }
    return;
  }
  for (l = e ? ET : AT, s = 0; s < u; ++s)
    this.each(l(o[s], e, i));
  return this;
}
function P0(t, e, i) {
  var o = b0(t), s = o.CustomEvent;
  typeof s == "function" ? s = new s(e, i) : (s = o.document.createEvent("Event"), i ? (s.initEvent(e, i.bubbles, i.cancelable), s.detail = i.detail) : s.initEvent(e, !1, !1)), t.dispatchEvent(s);
}
function $T(t, e) {
  return function() {
    return P0(this, t, e);
  };
}
function RT(t, e) {
  return function() {
    return P0(this, t, e.apply(this, arguments));
  };
}
function CT(t, e) {
  return this.each((typeof e == "function" ? RT : $T)(t, e));
}
function* ST() {
  for (var t = this._groups, e = 0, i = t.length; e < i; ++e)
    for (var o = t[e], s = 0, u = o.length, f; s < u; ++s)
      (f = o[s]) && (yield f);
}
var Ac = [null];
function en(t, e) {
  this._groups = t, this._parents = e;
}
function Ji() {
  return new en([[document.documentElement]], Ac);
}
function bT() {
  return this;
}
en.prototype = Ji.prototype = {
  constructor: en,
  select: eE,
  selectAll: oE,
  selectChild: cE,
  selectChildren: dE,
  filter: gE,
  data: xE,
  enter: pE,
  exit: AE,
  join: EE,
  merge: TE,
  selection: bT,
  order: $E,
  sort: RE,
  call: SE,
  nodes: bE,
  node: OE,
  size: IE,
  empty: LE,
  each: ME,
  attr: BE,
  style: jE,
  property: YE,
  classed: JE,
  text: eT,
  html: aT,
  raise: uT,
  lower: fT,
  append: lT,
  insert: dT,
  remove: pT,
  clone: mT,
  datum: yT,
  on: TT,
  dispatch: CT,
  [Symbol.iterator]: ST
};
function OT(t) {
  return typeof t == "string" ? new en([[document.querySelector(t)]], [document.documentElement]) : new en([[t]], Ac);
}
function IT(t) {
  let e;
  for (; e = t.sourceEvent; )
    t = e;
  return t;
}
function Ec(t, e) {
  if (t = IT(t), e === void 0 && (e = t.currentTarget), e) {
    var i = e.ownerSVGElement || e;
    if (i.createSVGPoint) {
      var o = i.createSVGPoint();
      return o.x = t.clientX, o.y = t.clientY, o = o.matrixTransform(e.getScreenCTM().inverse()), [o.x, o.y];
    }
    if (e.getBoundingClientRect) {
      var s = e.getBoundingClientRect();
      return [t.clientX - s.left - e.clientLeft, t.clientY - s.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
function Hh(t) {
  return typeof t == "string" ? new en([document.querySelectorAll(t)], [document.documentElement]) : new en([T0(t)], Ac);
}
function N0(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var LT = { value: () => {
} };
function k0() {
  for (var t = 0, e = arguments.length, i = {}, o; t < e; ++t) {
    if (!(o = arguments[t] + "") || o in i || /[\s.]/.test(o))
      throw new Error("illegal type: " + o);
    i[o] = [];
  }
  return new la(i);
}
function la(t) {
  this._ = t;
}
function MT(t, e) {
  return t.trim().split(/^|\s+/).map(function(i) {
    var o = "", s = i.indexOf(".");
    if (s >= 0 && (o = i.slice(s + 1), i = i.slice(0, s)), i && !e.hasOwnProperty(i))
      throw new Error("unknown type: " + i);
    return { type: i, name: o };
  });
}
la.prototype = k0.prototype = {
  constructor: la,
  on: function(t, e) {
    var i = this._, o = MT(t + "", i), s, u = -1, f = o.length;
    if (arguments.length < 2) {
      for (; ++u < f; )
        if ((s = (t = o[u]).type) && (s = PT(i[s], t.name)))
          return s;
      return;
    }
    if (e != null && typeof e != "function")
      throw new Error("invalid callback: " + e);
    for (; ++u < f; )
      if (s = (t = o[u]).type)
        i[s] = Bh(i[s], t.name, e);
      else if (e == null)
        for (s in i)
          i[s] = Bh(i[s], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var i in e)
      t[i] = e[i].slice();
    return new la(t);
  },
  call: function(t, e) {
    if ((s = arguments.length - 2) > 0)
      for (var i = new Array(s), o = 0, s, u; o < s; ++o)
        i[o] = arguments[o + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (u = this._[t], o = 0, s = u.length; o < s; ++o)
      u[o].value.apply(e, i);
  },
  apply: function(t, e, i) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var o = this._[t], s = 0, u = o.length; s < u; ++s)
      o[s].value.apply(e, i);
  }
};
function PT(t, e) {
  for (var i = 0, o = t.length, s; i < o; ++i)
    if ((s = t[i]).name === e)
      return s.value;
}
function Bh(t, e, i) {
  for (var o = 0, s = t.length; o < s; ++o)
    if (t[o].name === e) {
      t[o] = LT, t = t.slice(0, o).concat(t.slice(o + 1));
      break;
    }
  return i != null && t.push({ name: e, value: i }), t;
}
var Hr = 0, bi = 0, Ti = 0, D0 = 1e3, Ta, Oi, $a = 0, or = 0, Ha = 0, Xi = typeof performance == "object" && performance.now ? performance : Date, F0 = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function Tc() {
  return or || (F0(NT), or = Xi.now() + Ha);
}
function NT() {
  or = 0;
}
function Ra() {
  this._call = this._time = this._next = null;
}
Ra.prototype = H0.prototype = {
  constructor: Ra,
  restart: function(t, e, i) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    i = (i == null ? Tc() : +i) + (e == null ? 0 : +e), !this._next && Oi !== this && (Oi ? Oi._next = this : Ta = this, Oi = this), this._call = t, this._time = i, Hu();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Hu());
  }
};
function H0(t, e, i) {
  var o = new Ra();
  return o.restart(t, e, i), o;
}
function kT() {
  Tc(), ++Hr;
  for (var t = Ta, e; t; )
    (e = or - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --Hr;
}
function Wh() {
  or = ($a = Xi.now()) + Ha, Hr = bi = 0;
  try {
    kT();
  } finally {
    Hr = 0, FT(), or = 0;
  }
}
function DT() {
  var t = Xi.now(), e = t - $a;
  e > D0 && (Ha -= e, $a = t);
}
function FT() {
  for (var t, e = Ta, i, o = 1 / 0; e; )
    e._call ? (o > e._time && (o = e._time), t = e, e = e._next) : (i = e._next, e._next = null, e = t ? t._next = i : Ta = i);
  Oi = t, Hu(o);
}
function Hu(t) {
  if (!Hr) {
    bi && (bi = clearTimeout(bi));
    var e = t - or;
    e > 24 ? (t < 1 / 0 && (bi = setTimeout(Wh, t - Xi.now() - Ha)), Ti && (Ti = clearInterval(Ti))) : (Ti || ($a = Xi.now(), Ti = setInterval(DT, D0)), Hr = 1, F0(Wh));
  }
}
function Uh(t, e, i) {
  var o = new Ra();
  return e = e == null ? 0 : +e, o.restart((s) => {
    o.stop(), t(s + e);
  }, e, i), o;
}
var HT = k0("start", "end", "cancel", "interrupt"), BT = [], B0 = 0, Gh = 1, Bu = 2, ha = 3, jh = 4, Wu = 5, da = 6;
function Ba(t, e, i, o, s, u) {
  var f = t.__transition;
  if (!f)
    t.__transition = {};
  else if (i in f)
    return;
  WT(t, i, {
    name: e,
    index: o,
    // For context during callback.
    group: s,
    // For context during callback.
    on: HT,
    tween: BT,
    time: u.time,
    delay: u.delay,
    duration: u.duration,
    ease: u.ease,
    timer: null,
    state: B0
  });
}
function $c(t, e) {
  var i = jn(t, e);
  if (i.state > B0)
    throw new Error("too late; already scheduled");
  return i;
}
function ne(t, e) {
  var i = jn(t, e);
  if (i.state > ha)
    throw new Error("too late; already running");
  return i;
}
function jn(t, e) {
  var i = t.__transition;
  if (!i || !(i = i[e]))
    throw new Error("transition not found");
  return i;
}
function WT(t, e, i) {
  var o = t.__transition, s;
  o[e] = i, i.timer = H0(u, 0, i.time);
  function u(d) {
    i.state = Gh, i.timer.restart(f, i.delay, i.time), i.delay <= d && f(d - i.delay);
  }
  function f(d) {
    var _, y, m, T;
    if (i.state !== Gh)
      return h();
    for (_ in o)
      if (T = o[_], T.name === i.name) {
        if (T.state === ha)
          return Uh(f);
        T.state === jh ? (T.state = da, T.timer.stop(), T.on.call("interrupt", t, t.__data__, T.index, T.group), delete o[_]) : +_ < e && (T.state = da, T.timer.stop(), T.on.call("cancel", t, t.__data__, T.index, T.group), delete o[_]);
      }
    if (Uh(function() {
      i.state === ha && (i.state = jh, i.timer.restart(l, i.delay, i.time), l(d));
    }), i.state = Bu, i.on.call("start", t, t.__data__, i.index, i.group), i.state === Bu) {
      for (i.state = ha, s = new Array(m = i.tween.length), _ = 0, y = -1; _ < m; ++_)
        (T = i.tween[_].value.call(t, t.__data__, i.index, i.group)) && (s[++y] = T);
      s.length = y + 1;
    }
  }
  function l(d) {
    for (var _ = d < i.duration ? i.ease.call(null, d / i.duration) : (i.timer.restart(h), i.state = Wu, 1), y = -1, m = s.length; ++y < m; )
      s[y].call(t, _);
    i.state === Wu && (i.on.call("end", t, t.__data__, i.index, i.group), h());
  }
  function h() {
    i.state = da, i.timer.stop(), delete o[e];
    for (var d in o)
      return;
    delete t.__transition;
  }
}
function UT(t, e) {
  var i = t.__transition, o, s, u = !0, f;
  if (i) {
    e = e == null ? null : e + "";
    for (f in i) {
      if ((o = i[f]).name !== e) {
        u = !1;
        continue;
      }
      s = o.state > Bu && o.state < Wu, o.state = da, o.timer.stop(), o.on.call(s ? "interrupt" : "cancel", t, t.__data__, o.index, o.group), delete i[f];
    }
    u && delete t.__transition;
  }
}
function GT(t) {
  return this.each(function() {
    UT(this, t);
  });
}
function jT(t, e) {
  var i, o;
  return function() {
    var s = ne(this, t), u = s.tween;
    if (u !== i) {
      o = i = u;
      for (var f = 0, l = o.length; f < l; ++f)
        if (o[f].name === e) {
          o = o.slice(), o.splice(f, 1);
          break;
        }
    }
    s.tween = o;
  };
}
function zT(t, e, i) {
  var o, s;
  if (typeof i != "function")
    throw new Error();
  return function() {
    var u = ne(this, t), f = u.tween;
    if (f !== o) {
      s = (o = f).slice();
      for (var l = { name: e, value: i }, h = 0, d = s.length; h < d; ++h)
        if (s[h].name === e) {
          s[h] = l;
          break;
        }
      h === d && s.push(l);
    }
    u.tween = s;
  };
}
function XT(t, e) {
  var i = this._id;
  if (t += "", arguments.length < 2) {
    for (var o = jn(this.node(), i).tween, s = 0, u = o.length, f; s < u; ++s)
      if ((f = o[s]).name === t)
        return f.value;
    return null;
  }
  return this.each((e == null ? jT : zT)(i, t, e));
}
function Rc(t, e, i) {
  var o = t._id;
  return t.each(function() {
    var s = ne(this, o);
    (s.value || (s.value = {}))[e] = i.apply(this, arguments);
  }), function(s) {
    return jn(s, o).value[e];
  };
}
function W0(t, e) {
  var i;
  return (typeof e == "number" ? Dn : e instanceof ir ? xa : (i = ir(e)) ? (e = i, xa) : u0)(t, e);
}
function KT(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function YT(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function qT(t, e, i) {
  var o, s = i + "", u;
  return function() {
    var f = this.getAttribute(t);
    return f === s ? null : f === o ? u : u = e(o = f, i);
  };
}
function VT(t, e, i) {
  var o, s = i + "", u;
  return function() {
    var f = this.getAttributeNS(t.space, t.local);
    return f === s ? null : f === o ? u : u = e(o = f, i);
  };
}
function ZT(t, e, i) {
  var o, s, u;
  return function() {
    var f, l = i(this), h;
    return l == null ? void this.removeAttribute(t) : (f = this.getAttribute(t), h = l + "", f === h ? null : f === o && h === s ? u : (s = h, u = e(o = f, l)));
  };
}
function JT(t, e, i) {
  var o, s, u;
  return function() {
    var f, l = i(this), h;
    return l == null ? void this.removeAttributeNS(t.space, t.local) : (f = this.getAttributeNS(t.space, t.local), h = l + "", f === h ? null : f === o && h === s ? u : (s = h, u = e(o = f, l)));
  };
}
function QT(t, e) {
  var i = Fa(t), o = i === "transform" ? sA : W0;
  return this.attrTween(t, typeof e == "function" ? (i.local ? JT : ZT)(i, o, Rc(this, "attr." + t, e)) : e == null ? (i.local ? YT : KT)(i) : (i.local ? VT : qT)(i, o, e));
}
function t2(t, e) {
  return function(i) {
    this.setAttribute(t, e.call(this, i));
  };
}
function n2(t, e) {
  return function(i) {
    this.setAttributeNS(t.space, t.local, e.call(this, i));
  };
}
function e2(t, e) {
  var i, o;
  function s() {
    var u = e.apply(this, arguments);
    return u !== o && (i = (o = u) && n2(t, u)), i;
  }
  return s._value = e, s;
}
function r2(t, e) {
  var i, o;
  function s() {
    var u = e.apply(this, arguments);
    return u !== o && (i = (o = u) && t2(t, u)), i;
  }
  return s._value = e, s;
}
function i2(t, e) {
  var i = "attr." + t;
  if (arguments.length < 2)
    return (i = this.tween(i)) && i._value;
  if (e == null)
    return this.tween(i, null);
  if (typeof e != "function")
    throw new Error();
  var o = Fa(t);
  return this.tween(i, (o.local ? e2 : r2)(o, e));
}
function o2(t, e) {
  return function() {
    $c(this, t).delay = +e.apply(this, arguments);
  };
}
function a2(t, e) {
  return e = +e, function() {
    $c(this, t).delay = e;
  };
}
function s2(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? o2 : a2)(e, t)) : jn(this.node(), e).delay;
}
function u2(t, e) {
  return function() {
    ne(this, t).duration = +e.apply(this, arguments);
  };
}
function c2(t, e) {
  return e = +e, function() {
    ne(this, t).duration = e;
  };
}
function f2(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? u2 : c2)(e, t)) : jn(this.node(), e).duration;
}
function l2(t, e) {
  if (typeof e != "function")
    throw new Error();
  return function() {
    ne(this, t).ease = e;
  };
}
function h2(t) {
  var e = this._id;
  return arguments.length ? this.each(l2(e, t)) : jn(this.node(), e).ease;
}
function d2(t, e) {
  return function() {
    var i = e.apply(this, arguments);
    if (typeof i != "function")
      throw new Error();
    ne(this, t).ease = i;
  };
}
function g2(t) {
  if (typeof t != "function")
    throw new Error();
  return this.each(d2(this._id, t));
}
function p2(t) {
  typeof t != "function" && (t = R0(t));
  for (var e = this._groups, i = e.length, o = new Array(i), s = 0; s < i; ++s)
    for (var u = e[s], f = u.length, l = o[s] = [], h, d = 0; d < f; ++d)
      (h = u[d]) && t.call(h, h.__data__, d, u) && l.push(h);
  return new we(o, this._parents, this._name, this._id);
}
function _2(t) {
  if (t._id !== this._id)
    throw new Error();
  for (var e = this._groups, i = t._groups, o = e.length, s = i.length, u = Math.min(o, s), f = new Array(o), l = 0; l < u; ++l)
    for (var h = e[l], d = i[l], _ = h.length, y = f[l] = new Array(_), m, T = 0; T < _; ++T)
      (m = h[T] || d[T]) && (y[T] = m);
  for (; l < o; ++l)
    f[l] = e[l];
  return new we(f, this._parents, this._name, this._id);
}
function v2(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var i = e.indexOf(".");
    return i >= 0 && (e = e.slice(0, i)), !e || e === "start";
  });
}
function m2(t, e, i) {
  var o, s, u = v2(e) ? $c : ne;
  return function() {
    var f = u(this, t), l = f.on;
    l !== o && (s = (o = l).copy()).on(e, i), f.on = s;
  };
}
function y2(t, e) {
  var i = this._id;
  return arguments.length < 2 ? jn(this.node(), i).on.on(t) : this.each(m2(i, t, e));
}
function x2(t) {
  return function() {
    var e = this.parentNode;
    for (var i in this.__transition)
      if (+i !== t)
        return;
    e && e.removeChild(this);
  };
}
function w2() {
  return this.on("end.remove", x2(this._id));
}
function A2(t) {
  var e = this._name, i = this._id;
  typeof t != "function" && (t = xc(t));
  for (var o = this._groups, s = o.length, u = new Array(s), f = 0; f < s; ++f)
    for (var l = o[f], h = l.length, d = u[f] = new Array(h), _, y, m = 0; m < h; ++m)
      (_ = l[m]) && (y = t.call(_, _.__data__, m, l)) && ("__data__" in _ && (y.__data__ = _.__data__), d[m] = y, Ba(d[m], e, i, m, d, jn(_, i)));
  return new we(u, this._parents, e, i);
}
function E2(t) {
  var e = this._name, i = this._id;
  typeof t != "function" && (t = $0(t));
  for (var o = this._groups, s = o.length, u = [], f = [], l = 0; l < s; ++l)
    for (var h = o[l], d = h.length, _, y = 0; y < d; ++y)
      if (_ = h[y]) {
        for (var m = t.call(_, _.__data__, y, h), T, S = jn(_, i), b = 0, M = m.length; b < M; ++b)
          (T = m[b]) && Ba(T, e, i, b, m, S);
        u.push(m), f.push(_);
      }
  return new we(u, f, e, i);
}
var T2 = Ji.prototype.constructor;
function $2() {
  return new T2(this._groups, this._parents);
}
function R2(t, e) {
  var i, o, s;
  return function() {
    var u = Fr(this, t), f = (this.style.removeProperty(t), Fr(this, t));
    return u === f ? null : u === i && f === o ? s : s = e(i = u, o = f);
  };
}
function U0(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function C2(t, e, i) {
  var o, s = i + "", u;
  return function() {
    var f = Fr(this, t);
    return f === s ? null : f === o ? u : u = e(o = f, i);
  };
}
function S2(t, e, i) {
  var o, s, u;
  return function() {
    var f = Fr(this, t), l = i(this), h = l + "";
    return l == null && (h = l = (this.style.removeProperty(t), Fr(this, t))), f === h ? null : f === o && h === s ? u : (s = h, u = e(o = f, l));
  };
}
function b2(t, e) {
  var i, o, s, u = "style." + e, f = "end." + u, l;
  return function() {
    var h = ne(this, t), d = h.on, _ = h.value[u] == null ? l || (l = U0(e)) : void 0;
    (d !== i || s !== _) && (o = (i = d).copy()).on(f, s = _), h.on = o;
  };
}
function O2(t, e, i) {
  var o = (t += "") == "transform" ? aA : W0;
  return e == null ? this.styleTween(t, R2(t, o)).on("end.style." + t, U0(t)) : typeof e == "function" ? this.styleTween(t, S2(t, o, Rc(this, "style." + t, e))).each(b2(this._id, t)) : this.styleTween(t, C2(t, o, e), i).on("end.style." + t, null);
}
function I2(t, e, i) {
  return function(o) {
    this.style.setProperty(t, e.call(this, o), i);
  };
}
function L2(t, e, i) {
  var o, s;
  function u() {
    var f = e.apply(this, arguments);
    return f !== s && (o = (s = f) && I2(t, f, i)), o;
  }
  return u._value = e, u;
}
function M2(t, e, i) {
  var o = "style." + (t += "");
  if (arguments.length < 2)
    return (o = this.tween(o)) && o._value;
  if (e == null)
    return this.tween(o, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(o, L2(t, e, i ?? ""));
}
function P2(t) {
  return function() {
    this.textContent = t;
  };
}
function N2(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function k2(t) {
  return this.tween("text", typeof t == "function" ? N2(Rc(this, "text", t)) : P2(t == null ? "" : t + ""));
}
function D2(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function F2(t) {
  var e, i;
  function o() {
    var s = t.apply(this, arguments);
    return s !== i && (e = (i = s) && D2(s)), e;
  }
  return o._value = t, o;
}
function H2(t) {
  var e = "text";
  if (arguments.length < 1)
    return (e = this.tween(e)) && e._value;
  if (t == null)
    return this.tween(e, null);
  if (typeof t != "function")
    throw new Error();
  return this.tween(e, F2(t));
}
function B2() {
  for (var t = this._name, e = this._id, i = G0(), o = this._groups, s = o.length, u = 0; u < s; ++u)
    for (var f = o[u], l = f.length, h, d = 0; d < l; ++d)
      if (h = f[d]) {
        var _ = jn(h, e);
        Ba(h, t, i, d, f, {
          time: _.time + _.delay + _.duration,
          delay: 0,
          duration: _.duration,
          ease: _.ease
        });
      }
  return new we(o, this._parents, t, i);
}
function W2() {
  var t, e, i = this, o = i._id, s = i.size();
  return new Promise(function(u, f) {
    var l = { value: f }, h = { value: function() {
      --s === 0 && u();
    } };
    i.each(function() {
      var d = ne(this, o), _ = d.on;
      _ !== t && (e = (t = _).copy(), e._.cancel.push(l), e._.interrupt.push(l), e._.end.push(h)), d.on = e;
    }), s === 0 && u();
  });
}
var U2 = 0;
function we(t, e, i, o) {
  this._groups = t, this._parents = e, this._name = i, this._id = o;
}
function G0() {
  return ++U2;
}
var ve = Ji.prototype;
we.prototype = {
  constructor: we,
  select: A2,
  selectAll: E2,
  selectChild: ve.selectChild,
  selectChildren: ve.selectChildren,
  filter: p2,
  merge: _2,
  selection: $2,
  transition: B2,
  call: ve.call,
  nodes: ve.nodes,
  node: ve.node,
  size: ve.size,
  empty: ve.empty,
  each: ve.each,
  on: y2,
  attr: QT,
  attrTween: i2,
  style: O2,
  styleTween: M2,
  text: k2,
  textTween: H2,
  remove: w2,
  tween: XT,
  delay: s2,
  duration: f2,
  ease: h2,
  easeVarying: g2,
  end: W2,
  [Symbol.iterator]: ve[Symbol.iterator]
};
var G2 = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: N0
};
function j2(t, e) {
  for (var i; !(i = t.__transition) || !(i = i[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return i;
}
function z2(t) {
  var e, i;
  t instanceof we ? (e = t._id, t = t._name) : (e = G0(), (i = G2).time = Tc(), t = t == null ? null : t + "");
  for (var o = this._groups, s = o.length, u = 0; u < s; ++u)
    for (var f = o[u], l = f.length, h, d = 0; d < l; ++d)
      (h = f[d]) && Ba(h, t, e, d, f, i || j2(h, e));
  return new we(o, this._parents, t, e);
}
Ji.prototype.interrupt = GT;
Ji.prototype.transition = z2;
const Uu = (t) => t == null, X2 = ({ path: t, clipPathName: e }) => (cc(() => {
  OT(`#${e} > path`).transition().duration(hw).ease(N0).attr("d", t);
}, [e, t]), /* @__PURE__ */ w.jsx("clipPath", { id: e, "data-testid": e, children: /* @__PURE__ */ w.jsx("path", {}) })), K2 = (t, e, i) => {
  if (Uu(e) || Uu(i))
    return null;
  const o = e + 1, s = e * i, u = o * i;
  return yc(s, u, t);
}, j0 = ({
  id: t,
  width: e,
  radius: i,
  clipPaths: o,
  centreCircleRadius: s,
  selectedMetricIndex: u,
  maskId: f,
  numberOfAxes: l
}) => {
  const h = Vi(l), d = -(qi(h) / 2), _ = K2(i, u, h);
  return /* @__PURE__ */ w.jsxs("defs", { id: t, children: [
    o.map(({ clipPathName: y, path: m }) => /* @__PURE__ */ w.jsx(X2, { path: m, clipPathName: y }, y)),
    _ && /* @__PURE__ */ w.jsxs("mask", { id: f, children: [
      /* @__PURE__ */ w.jsx("circle", { cx: 0, cy: 0, r: e, fill: "#666" }),
      /* @__PURE__ */ w.jsx("path", { d: _, transform: `rotate(${d})`, fill: "#fff" }),
      /* @__PURE__ */ w.jsx("circle", { cx: 0, cy: 0, r: s, fill: "#000" })
    ] })
  ] });
}, Y2 = ({
  id: t,
  data: e,
  axesData: i,
  centreCircleRadius: o,
  numberOfRings: s,
  selectedMetricIndex: u,
  width: f,
  radius: l,
  mask: h,
  maskId: d,
  primaryColour: _,
  secondaryColour: y,
  locale: m,
  displayNotches: T
}) => {
  const S = Zi(t), b = S(ki.MAIN), M = ku(e, l, o), I = i.length;
  return /* @__PURE__ */ w.jsxs("g", { id: S("drawing"), children: [
    /* @__PURE__ */ w.jsx(
      j0,
      {
        id: S("drawing-defs"),
        maskId: d,
        clipPaths: [{ clipPathName: b, path: M }],
        width: f,
        radius: l,
        centreCircleRadius: o,
        selectedMetricIndex: u,
        numberOfAxes: I
      }
    ),
    /* @__PURE__ */ w.jsx(
      Di,
      {
        id: S("clipped-rings"),
        clipPath: b,
        mask: h,
        radius: l,
        numberOfRings: s,
        primaryColour: _,
        secondaryColour: y,
        centreCircleRadius: o
      }
    ),
    T && /* @__PURE__ */ w.jsx("g", { clipPath: `url(#${b})`, children: i.map(
      ({ angleInRad: C, lineCoords: { x: H, y: B }, minValue: k, maxValue: W, decimalPlaces: K }, q) => /* @__PURE__ */ w.jsx(
        mc,
        {
          minValue: k,
          maxValue: W,
          decimalPlaces: K,
          angleInRad: C,
          notchesFill: "fill-notch-overlay",
          xEnd: H,
          yEnd: B,
          centreCircleRadius: o,
          locale: m
        },
        `drawing-axis-notches-${q}`
      )
    ) })
  ] });
}, q2 = (t, e, i) => t.map((o) => {
  const s = { ...o, [e]: o[i] };
  return delete s[i], s;
}), V2 = ({
  id: t,
  data: e,
  axesData: i,
  centreCircleRadius: o,
  numberOfRings: s,
  selectedMetricIndex: u,
  width: f,
  radius: l,
  mask: h,
  maskId: d,
  primaryColour: _,
  comparisonColour: y,
  locale: m,
  displayNotches: T
}) => {
  const S = q2(e, "value", "comparisonValue"), b = ku(e, l, o), M = ku(S, l, o), I = b + " " + M, C = Zi(t), H = e.length, B = C(ki.MAIN), k = C(ki.COMPARISON), W = C(ki.COMBINED), K = [
    { clipPathName: B, path: b },
    {
      clipPathName: k,
      path: M
    },
    {
      clipPathName: W,
      path: I
    }
  ];
  return /* @__PURE__ */ w.jsxs("g", { id: C("drawing-with-comparison"), children: [
    /* @__PURE__ */ w.jsx(
      j0,
      {
        id: C("comparison-drawing-defs"),
        maskId: d,
        clipPaths: K,
        width: f,
        radius: l,
        centreCircleRadius: o,
        selectedMetricIndex: u,
        numberOfAxes: H
      }
    ),
    /* @__PURE__ */ w.jsxs("g", { id: C("drawing-shapes"), children: [
      /* @__PURE__ */ w.jsx(
        Di,
        {
          id: C("comparison-drawing-solid"),
          clipPath: k,
          radius: l,
          numberOfRings: s,
          primaryColour: y,
          centreCircleRadius: o,
          mask: h,
          hasStroke: !0,
          strokeDasharray: ua.DOTTED
        }
      ),
      /* @__PURE__ */ w.jsx(
        Di,
        {
          id: C("main-drawing-solid"),
          clipPath: B,
          radius: l,
          numberOfRings: s,
          primaryColour: _,
          centreCircleRadius: o,
          mask: h,
          hasStroke: !0,
          strokeDasharray: ua.DOTTED
        }
      ),
      /* @__PURE__ */ w.jsx(
        Di,
        {
          id: C("comparison-drawing-translucent"),
          clipPath: k,
          radius: l,
          numberOfRings: s,
          primaryColour: y,
          centreCircleRadius: o,
          mask: h,
          hasOpacity: !0,
          hasStroke: !0,
          strokeDasharray: ua.DOTTED
        }
      )
    ] }),
    T && /* @__PURE__ */ w.jsx("g", { clipPath: `url(#${W})`, children: i.map(
      ({ angleInRad: q, lineCoords: { x: tt, y: X }, minValue: j, maxValue: et, decimalPlaces: nt }, yt) => /* @__PURE__ */ w.jsx(
        mc,
        {
          minValue: j,
          maxValue: et,
          decimalPlaces: nt,
          angleInRad: q,
          notchesFill: "fill-notch-overlay",
          xEnd: tt,
          yEnd: X,
          centreCircleRadius: o,
          locale: m
        },
        `drawing-axis-notches-${yt}`
      )
    ) })
  ] });
}, Z2 = ({ centreCircleRadius: t }) => /* @__PURE__ */ w.jsx("circle", { cx: 0, cy: 0, r: t, className: "fill-vis-bg" }), J2 = ({
  id: t,
  radius: e,
  numberOfRings: i,
  displayBaseRings: o,
  centreCircleRadius: s,
  displayOuterStroke: u
}) => {
  const f = Dt(), { americanFootball: l, base: h } = f.colours.visualisations, d = Zi(t), _ = o ? l.fieldZones.endZone : h.background, y = o ? l.fieldZones.tenYardAlternate : h.background;
  return /* @__PURE__ */ w.jsx(
    Di,
    {
      id: d("rings"),
      numberOfRings: i,
      radius: e,
      primaryColour: _,
      secondaryColour: y,
      centreCircleRadius: s,
      displayOuterStroke: u
    }
  );
}, Wa = ({
  id: t,
  data: e,
  numberOfRings: i = fw.DEFAULT,
  centreCircle: o = "regular",
  onSliceClick: s,
  selectedKey: u,
  primaryColour: f,
  secondaryColour: l,
  comparisonColour: h,
  width: d = uw,
  displayLabels: _ = !0,
  displayValues: y = !1,
  displayNotches: m = !0,
  displayBaseRings: T = !0,
  displayOuterStroke: S = !1,
  locale: b = "en"
}) => {
  const M = d, I = _ || y ? e0 : 0, C = I * 2, H = d - C, B = H / 2, k = i + 1, W = GA(lw[o], B), K = KA(e, B, W), q = e.length > 0, tt = !!s, X = tt && u ? u : void 0, j = tt && u ? e.findIndex((Wt) => Wt.key === u) : void 0, et = Zi(t), nt = et(ki.SLICE_MASK), Tt = !Uu(j) ? `url(#${nt})` : void 0, Pt = Dt(), gt = f || Pt.colours.visualisations.dataObjects.forAgainst.for.main, St = l || Pt.colours.visualisations.dataObjects.forAgainst.forShade.main, Nt = h || Pt.colours.visualisations.dataObjects.forAgainst.against.main;
  return /* @__PURE__ */ w.jsxs("svg", { id: et("radar-chart"), height: "100%", width: "100%", viewBox: `0 0 ${d} ${M}`, children: [
    /* @__PURE__ */ w.jsx("rect", { height: "100%", width: "100%", className: "fill-vis-bg" }),
    /* @__PURE__ */ w.jsxs("g", { id: et("chart-group"), transform: `translate(${B + I},${B + I})`, children: [
      /* @__PURE__ */ w.jsx(
        J2,
        {
          id: t,
          radius: B,
          numberOfRings: k,
          centreCircleRadius: W,
          displayBaseRings: T,
          displayOuterStroke: S
        }
      ),
      q && /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
        /* @__PURE__ */ w.jsx(
          VA,
          {
            id: t,
            axesData: K,
            centreCircleRadius: W,
            locale: b,
            selectedKey: X,
            displayLabels: _,
            displayValues: y,
            displayNotches: m
          }
        ),
        YA(e) ? /* @__PURE__ */ w.jsx(
          V2,
          {
            id: t,
            data: e,
            width: H,
            radius: B,
            centreCircleRadius: W,
            axesData: K,
            numberOfRings: k,
            selectedMetricIndex: j,
            mask: Tt,
            maskId: nt,
            locale: b,
            primaryColour: gt,
            comparisonColour: Nt,
            displayNotches: m
          }
        ) : /* @__PURE__ */ w.jsx(
          Y2,
          {
            id: t,
            data: e,
            width: H,
            radius: B,
            centreCircleRadius: W,
            axesData: K,
            numberOfRings: k,
            selectedMetricIndex: j,
            mask: Tt,
            maskId: nt,
            locale: b,
            primaryColour: gt,
            secondaryColour: St,
            displayNotches: m
          }
        ),
        tt && /* @__PURE__ */ w.jsx(JA, { data: e, radius: B, onSliceClick: s, selectedKey: X }),
        /* @__PURE__ */ w.jsx(Z2, { centreCircleRadius: W })
      ] })
    ] })
  ] });
}, Q2 = ({
  id: t,
  data: e,
  // this colour is the same value in both themes so no need to get it by using the `useTheme` hook
  colour: i = tw.dark.colours.visualisations.dataObjects.forAgainst.for.main
}) => /* @__PURE__ */ w.jsx(
  Wa,
  {
    id: t,
    data: e,
    centreCircle: "small",
    displayLabels: !1,
    displayNotches: !1,
    displayBaseRings: !1,
    displayOuterStroke: !0,
    primaryColour: i,
    secondaryColour: i
  }
), t$ = ({ id: t, data: e, primaryColour: i, secondaryColour: o }) => /* @__PURE__ */ w.jsx(
  Wa,
  {
    id: t,
    data: e,
    numberOfRings: 4,
    centreCircle: "small",
    displayLabels: !1,
    displayNotches: !1,
    primaryColour: i,
    secondaryColour: o
  }
), n$ = ({
  id: t,
  data: e,
  onSliceClick: i,
  selectedKey: o,
  primaryColour: s,
  secondaryColour: u,
  comparisonColour: f,
  locale: l = "en"
}) => {
  const [h, d] = nw(), { width: _, height: y } = d, m = Math.min(_ || y, y || _), T = m > 0, S = m < _e.SMALL, b = m >= _e.SMALL && m < _e.MEDIUM, M = m >= _e.MEDIUM && m < _e.EXTRA_LARGE, I = m >= _e.EXTRA_LARGE, H = ((B) => {
    switch (!0) {
      case S:
        return _e.SMALL;
      case b:
        return _e.MEDIUM;
      case M:
        return B;
      case I:
        return _e.EXTRA_LARGE;
      default:
        return B;
    }
  })(m);
  return /* @__PURE__ */ w.jsx("div", { className: "w-full h-full", ref: h, children: T && /* @__PURE__ */ w.jsx(
    Wa,
    {
      id: t,
      data: e,
      locale: l,
      onSliceClick: i,
      selectedKey: o,
      primaryColour: s,
      secondaryColour: u,
      comparisonColour: f,
      width: H,
      displayValues: S,
      displayNotches: !S,
      centreCircle: S || I ? "small" : "regular"
    }
  ) });
}, zh = 50, e$ = 40, Ii = (t, e) => e + t * 2, Xh = (t, e) => Ii(t, e) / 2, Gu = (t) => e$ + t, Kh = (t) => Gu(t) / 2, ga = (t, e) => e / 3 + t, Yh = (t, e) => ga(t, e) / 2, ju = (t, e) => e / 2 + t, qh = (t, e) => ju(t, e) / 2, Or = (t, e) => e + t * 2, Ne = (t, e) => t + e / 2, z0 = {
  FULL_PITCH: {
    key: "FULL_PITCH",
    name: "Full pitch",
    width: Ii,
    focusX: Xh,
    height: Or,
    focusY: Ne
  },
  HOME_BOX: {
    key: "HOME_BOX",
    name: "Defensive box",
    width: Gu,
    focusX: Kh,
    height: () => zh,
    focusY: Ne
  },
  HOME_THIRD: {
    key: "HOME_THIRD",
    name: "Defensive third",
    width: ga,
    focusX: Yh,
    height: Or,
    focusY: Ne
  },
  HOME_HALF: {
    key: "HOME_HALF",
    name: "Defensive half",
    width: ju,
    focusX: qh,
    height: Or,
    focusY: Ne
  },
  OPPOSITION_BOX: {
    key: "OPPOSITION_BOX",
    name: "Attacking box",
    width: Gu,
    focusX: (t, e) => Ii(t, e) - Kh(t),
    height: () => zh,
    focusY: Ne
  },
  OPPOSITION_THIRD: {
    key: "OPPOSITION_THIRD",
    name: "Attacking third",
    width: ga,
    focusX: (t, e) => Ii(t, e) - Yh(t, e),
    height: Or,
    focusY: Ne
  },
  OPPOSITION_HALF: {
    key: "OPPOSITION_HALF",
    name: "Attacking half",
    width: ju,
    focusX: (t, e) => Ii(t, e) - qh(t, e),
    height: Or,
    focusY: Ne
  },
  CENTRE_THIRD: {
    key: "CENTRE_THIRD",
    name: "Central third",
    width: ga,
    focusX: Xh,
    height: Or,
    focusY: Ne
  }
}, nn = {
  HORIZONTAL: {
    key: "HORIZONTAL",
    angle: 0,
    name: "Attacking Right",
    description: "Default orientation. For pitches/fields this will mean the x value of the pitch increases moving left to right."
  },
  VERTICAL: {
    key: "VERTICAL",
    angle: -90,
    name: "Attacking Up",
    description: "Standard vertical orientation. For pitches/fields this will mean the x value of the pitch increases moving from bottom to top."
  },
  VERTICAL_REVERSE: {
    key: "VERTICAL_REVERSE",
    angle: 90,
    name: "Attacking Down",
    description: "Vertical orientation, but attacking down/defending up. For pitches/fields this will mean the x value of the pitch increases moving from top to bottom."
  },
  HORIZONTAL_REVERSE: {
    key: "HORIZONTAL_REVERSE",
    angle: 180,
    name: "Attacking Left",
    description: "Horizontal orientation, but attacking left. For pitches/fields this will mean the x value of the pitch increases moving from right to left."
  }
}, X0 = Object.keys(nn), r$ = (t, e) => {
  const i = e.width / 2, o = e.height / 2;
  return t === nn.VERTICAL.key ? `rotate(-90, ${i}, ${i})` : t === nn.VERTICAL_REVERSE.key ? `rotate(90, ${o}, ${o})` : t === nn.HORIZONTAL_REVERSE.key ? `rotate(180, ${i}, ${o})` : "";
}, Br = (t) => t === nn.VERTICAL.key || t === nn.VERTICAL_REVERSE.key, K0 = (t, e, i) => {
  const o = e.focalPointX ?? e.width / 2;
  let s = i.width / 2 - o;
  return t === nn.VERTICAL.key && (s = -i.height / 2 + (e.width - o)), t === nn.VERTICAL_REVERSE.key && (s = i.height / 2 - o), t === nn.HORIZONTAL_REVERSE.key && (s = -i.width / 2 + e.width - o), { dX: s, targetX: o };
}, Y0 = (t, e, i) => {
  const o = e.focalPointY ?? e.height / 2;
  let s = i.height / 2 - o;
  return t === nn.VERTICAL.key && (s = i.width / 2 - o), t === nn.VERTICAL_REVERSE.key && (s = e.height - o - i.width / 2), t === nn.HORIZONTAL_REVERSE.key && (s = -i.height / 2 + e.height - o), { dY: s, targetY: o };
}, i$ = (t, e, i) => {
  const { dX: o } = K0(t, e, i), { dY: s } = Y0(t, e, i);
  return `translate(${o},${s})`;
}, o$ = (t, e, i) => {
  const { targetX: o } = K0(t, e, i), { targetY: s } = Y0(t, e, i), u = Br(t) ? i.height : i.width, f = Br(t) ? i.width : i.height;
  return {
    minX: o - u / 2,
    maxX: o + u / 2,
    minY: s - f / 2,
    maxY: s + f / 2
  };
}, q0 = ({
  window: t,
  windowCropId: e,
  displayedObject: i,
  rotationName: o,
  children: s
}) => {
  const u = o || X0[0], f = `${e}-${t.width}-${t.height}`, l = e ? `url(#${f})` : "";
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx("defs", { children: /* @__PURE__ */ w.jsx("clipPath", { id: f, children: /* @__PURE__ */ w.jsx("rect", { x: 0, y: 0, width: t.width, height: t.height }) }) }),
    /* @__PURE__ */ w.jsx("g", { "data-testid": "window-crop-g", clipPath: l, children: /* @__PURE__ */ w.jsx("g", { "data-testid": "rotation-g", transform: r$(u, i), children: /* @__PURE__ */ w.jsx("g", { "data-testid": "shift-g", transform: i$(u, i, t), children: s }) }) })
  ] });
}, a$ = { DARK: "#121212", LIGHT: "#FFFFFF" }, s$ = { DARK: "#999999", LIGHT: "#999999" }, u$ = { DARK: "#333333", LIGHT: "#CCCCCC" }, c$ = { DARK: "#676767", LIGHT: "#CCCCCC" }, f$ = { DARK: "#232323", LIGHT: "#EDF2F7" }, Zt = { DARK_CONTRAST: "#121212", LIGHT_CONTRAST: "#FFFFFF" }, l$ = {
  isDark: !1,
  /*
    Base options cover the background (comes via theme), and other basic blocks /
    */
  base: {
    background: a$.LIGHT,
    chartLines: {
      axis: s$.LIGHT,
      //used singular "axis" rather than plural "axes"
      guide: u$.LIGHT,
      marking: c$.LIGHT,
      boundingBox: f$.LIGHT
    }
  },
  /*
    These describe how elements drawn in visualisations should get coloured: categorical definitions
   */
  dataObjects: {
    ghost: "#cccccc",
    neutral: { main: "#C7C7C7", ink: Zt.DARK_CONTRAST },
    // mid grey
    inspection: "#6891BD",
    focus: Zt.DARK_CONTRAST,
    default: {
      n1: { main: "#02C3C8", ink: Zt.DARK_CONTRAST },
      // cyan
      n2: { main: "#F14E00", ink: Zt.LIGHT_CONTRAST },
      // orange
      n3: { main: "#6F04DA", ink: Zt.LIGHT_CONTRAST },
      // purple
      n4: { main: "#F980DB", ink: Zt.DARK_CONTRAST },
      // pink
      n5: { main: "#1682BE", ink: Zt.LIGHT_CONTRAST },
      // sea blue
      n6: { main: "#FFB84D", ink: Zt.DARK_CONTRAST },
      // sand
      n7: { main: "#740C5A", ink: Zt.LIGHT_CONTRAST },
      // magenta
      n8: { main: "#BC1090", ink: Zt.LIGHT_CONTRAST }
      // fuchsia
    },
    forAgainst: {
      /*AKA Red vs Blue (For = SB Red)*/
      for: { main: "#E21017", ink: Zt.LIGHT_CONTRAST },
      against: { main: "#0044CC", ink: Zt.LIGHT_CONTRAST },
      forShade: { main: "#b2080e", ink: Zt.LIGHT_CONTRAST },
      againstShade: { main: "#00297c", ink: Zt.LIGHT_CONTRAST },
      forBright: { main: "#F0878B", ink: Zt.LIGHT_CONTRAST },
      againstBright: { main: "#80A1E5", ink: Zt.LIGHT_CONTRAST }
    }
  },
  text: {
    legend: {
      primary: "#404040"
    }
  }
}, Wn = {
  x: 120,
  y: 80,
  boundarySize: 1
}, $i = 18, ea = 44, _u = 6, ra = 20, Vh = 12, h$ = 10, d$ = 0.25, g$ = 1, ia = 8, vu = 0.75, p$ = l$.dataObjects.default.n1.main, Zn = {
  radius: 1,
  stroke: "none",
  strokeWidth: 0.2,
  strokeWidthFocused: 0.5,
  fillOpacityNowPlaying: 0.75
}, Ri = {
  stroke: p$,
  arrowHeadRadius: 0.8,
  strokeWidth: 0.2,
  strokeWidthFocused: 0.5
}, V0 = {
  /* Pitch markings use non-scaling stroke, not pseudo-yard measurements */
  strokeWidth: "1px",
  boundaryStrokeWidth: "1.5px",
  contentStrokeWidth: "2px"
}, _$ = ({
  x: t = Wn.x,
  y: e = Wn.y,
  showGoals: i = !0,
  showCorners: o = !0,
  showSpots: s = !0
}) => {
  const u = Dt(), f = Bn({ tokens: u, findKey: "colours.visualisations.soccer.pitchLines" }), l = Bn({ tokens: u, findKey: "colours.visualisations.base.chartLines.axis" }), { strokeWidth: h, boundaryStrokeWidth: d } = V0, _ = {
    fill: "none",
    stroke: f,
    strokeWidth: h,
    vectorEffect: "non-scaling-stroke"
  }, y = `pitchCentreClip-${t}-${e}`, m = `pitchBoundaryClip-${t}-${e}`, T = [Vh, t / 2, t - Vh], S = [
    { cx: 0, cy: 0 },
    { cx: 0, cy: e },
    { cx: t, cy: 0 },
    { cx: t, cy: e }
  ];
  return /* @__PURE__ */ w.jsxs("g", { children: [
    /* @__PURE__ */ w.jsxs("defs", { children: [
      /* @__PURE__ */ w.jsx("clipPath", { id: y, children: /* @__PURE__ */ w.jsx("rect", { x: $i, y: 0, width: t - $i * 2, height: e }) }),
      /* @__PURE__ */ w.jsx("clipPath", { id: m, children: /* @__PURE__ */ w.jsx("rect", { x: 0, y: 0, width: t, height: e }) })
    ] }),
    /* @__PURE__ */ w.jsx(
      "rect",
      {
        "data-testid": "home-penalty-box",
        x: 0,
        y: (e - ea) / 2,
        width: $i,
        height: ea,
        ..._
      }
    ),
    /* @__PURE__ */ w.jsx(
      "rect",
      {
        "data-testid": "away-penalty-box",
        x: t - $i,
        y: (e - ea) / 2,
        width: $i,
        height: ea,
        ..._
      }
    ),
    /* @__PURE__ */ w.jsx(
      "rect",
      {
        "data-testid": "home-six-yard-box",
        x: 0,
        y: (e - ra) / 2,
        width: _u,
        height: ra,
        ..._
      }
    ),
    /* @__PURE__ */ w.jsx(
      "rect",
      {
        "data-testid": "away-six-yard-box",
        x: t - _u,
        y: (e - ra) / 2,
        width: _u,
        height: ra,
        ..._
      }
    ),
    /* @__PURE__ */ w.jsx("line", { "data-testid": "half-way-line", x1: t / 2, x2: t / 2, y1: 0, y2: e, ..._ }),
    /* @__PURE__ */ w.jsx("g", { clipPath: `url(#${y})`, children: T.map((b) => /* @__PURE__ */ w.jsx(
      "circle",
      {
        "data-testid": "pitch-circle",
        cx: b,
        cy: e / 2,
        r: h$,
        ..._
      },
      `circle-${b}`
    )) }),
    s && /* @__PURE__ */ w.jsx("g", { children: T.map((b) => /* @__PURE__ */ w.jsx(
      "circle",
      {
        "data-testid": "pitch-spot",
        cx: b,
        cy: e / 2,
        r: d$,
        stroke: "none",
        fill: f
      },
      `circle-${b}`
    )) }),
    o && /* @__PURE__ */ w.jsx("g", { clipPath: `url(#${m})`, children: S.map((b) => /* @__PURE__ */ w.jsx(
      "circle",
      {
        "data-testid": "pitch-corner",
        cx: b.cx,
        cy: b.cy,
        r: g$,
        ..._
      },
      `corner-${b.cx}-${b.cy}`
    )) }),
    i && /* @__PURE__ */ w.jsxs("g", { children: [
      /* @__PURE__ */ w.jsx(
        "rect",
        {
          "data-testid": "home-goal",
          x: -vu,
          y: (e - ia) / 2,
          width: vu,
          height: ia,
          fill: "none",
          stroke: l,
          strokeWidth: h,
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ w.jsx(
        "rect",
        {
          "data-testid": "away-goal",
          x: t,
          y: (e - ia) / 2,
          width: vu,
          height: ia,
          fill: "none",
          stroke: l,
          strokeWidth: h,
          vectorEffect: "non-scaling-stroke"
        }
      )
    ] }),
    /* @__PURE__ */ w.jsx(
      "rect",
      {
        "data-testid": "pitch-boundary-line",
        x: 0,
        y: 0,
        width: t,
        height: e,
        fill: "none",
        stroke: l,
        strokeWidth: d,
        vectorEffect: "non-scaling-stroke"
      }
    )
  ] });
}, v$ = ({
  rotationName: t,
  displayedObject: e,
  window: i,
  pitchWidth: o,
  pitchHeight: s,
  boundarySize: u = 0
}) => {
  const f = t || X0[0], { minX: l, maxX: h, minY: d, maxY: _ } = o$(f, e, i), y = o + u, m = s + u, T = l > u, S = h < y, b = d > u, M = _ < m, I = Dt(), C = Bn({
    tokens: I,
    findKey: "colours.visualisations.base.chartLines.boundingBox"
  }), H = V0.contentStrokeWidth;
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    b && /* @__PURE__ */ w.jsx(
      "line",
      {
        "data-testid": "top-edge",
        x1: Math.max(l, u),
        x2: Math.min(h, y),
        y1: d,
        y2: d,
        stroke: C,
        strokeWidth: H,
        vectorEffect: "non-scaling-stroke"
      }
    ),
    M && /* @__PURE__ */ w.jsx(
      "line",
      {
        "data-testid": "bottom-edge",
        x1: Math.max(l, u),
        x2: Math.min(h, y),
        y1: _,
        y2: _,
        stroke: C,
        strokeWidth: H,
        vectorEffect: "non-scaling-stroke"
      }
    ),
    T && /* @__PURE__ */ w.jsx(
      "line",
      {
        "data-testid": "left-edge",
        x1: l,
        x2: l,
        y1: Math.max(d, u),
        y2: Math.min(_, m),
        stroke: C,
        strokeWidth: H,
        vectorEffect: "non-scaling-stroke"
      }
    ),
    S && /* @__PURE__ */ w.jsx(
      "line",
      {
        "data-testid": "right-edge",
        x1: h,
        x2: h,
        y1: Math.max(d, u),
        y2: Math.min(_, m),
        stroke: C,
        strokeWidth: H,
        vectorEffect: "non-scaling-stroke"
      }
    )
  ] });
}, m$ = ({
  rotationName: t = "HORIZONTAL",
  pitchFocusZoneName: e = "FULL_PITCH",
  pitchWidth: i = Wn.x,
  pitchHeight: o = Wn.y,
  boundarySize: s = Wn.boundarySize,
  //how many pseudo-yards outside the pitch edge to show
  underlay: u,
  overlay: f,
  ...l
}) => {
  const h = z0[e], d = h.width(s, i), _ = h.height(s, o), y = {
    width: d,
    height: _,
    focalPointX: h.focusX(s, i),
    focalPointY: h.focusY(s, o)
  }, m = {
    width: Br(t) ? _ : d,
    height: Br(t) ? d : _
  };
  return /* @__PURE__ */ w.jsx("svg", { viewBox: `0 0 ${m.width} ${m.height}`, className: "h-full overflow-visible", ...l, children: /* @__PURE__ */ w.jsxs(
    q0,
    {
      windowCropId: "bounded-pitch-window",
      rotationName: t,
      window: m,
      displayedObject: y,
      children: [
        /* @__PURE__ */ w.jsx(
          v$,
          {
            rotationName: t,
            window: m,
            displayedObject: y,
            boundarySize: s,
            pitchWidth: i,
            pitchHeight: o
          }
        ),
        /* @__PURE__ */ w.jsxs("g", { transform: `translate(${s},${s})`, children: [
          u,
          /* @__PURE__ */ w.jsx(_$, { x: i, y: o }),
          f
        ] })
      ]
    }
  ) });
}, Zh = 400, y$ = 1, x$ = 0.16, Z0 = (t) => {
  cc(() => {
    Hh(".unselected-zone").transition().duration(Zh).style("opacity", x$), Hh(".selected-zone").transition().duration(Zh).style("opacity", y$);
  }, [t]);
}, w$ = (t) => `M0,0 m-${t},0 a ${t},${t} 0 1,0 ${t * 2},0 a ${t},${t} 0 1,0 -${t * 2},0 z`, A$ = (t) => {
  const e = t * Math.tan(0.16666666666666666 * Math.PI);
  return `M0,-${2 * e} l${t},${e} v${2 * e} l-${t},${e} l-${t},-${e} v-${2 * e} z`;
}, E$ = (t) => {
  const e = t * Math.cos(0.4 * Math.PI), i = t * Math.sin(72 / 180 * Math.PI), o = t * Math.cos(36 / 180 * Math.PI), s = t * Math.sin(36 / 180 * Math.PI);
  return `M0,-${t} L${i},-${e} L${s},${o} L-${s},${o} L-${i},-${e} z`;
}, T$ = (t) => {
  const e = t / 2;
  return `M${t} 0 a${e},${e} 90 0,1 ${-t},${t} a${e},${e} 90 0,1 ${-t},${-t} a${e},${e} 90 0,1 ${t},${-t} a${e},${e} 90 0,1 ${t},${t} z`;
}, $$ = (t) => `M${0 - t},${0 - t} l${t * 2},0 l0,${t * 2} l-${t * 2},0 z`, R$ = (t) => (
  //top left and across
  `M${-t * 0.5} ${-t} h${t} v${t / 2} h${t / 2} v${t} h${-t / 2} v${t / 2} h${-t} v${-t / 2} h${-t / 2} v${-t} h${t / 2} z`
), C$ = (t) => `M0 ${-t} L${t * 0.75} 0 L0 ${t} L${t * -0.75} 0 z`, S$ = (t) => `M${-t * 0.6495} ${-t * 0.375} A${t * 0.5},${t * 0.5} 0 0,1 ${t * 0.6495} ${-t * 0.375} A${t * 0.5},${t * 0.5} 30 0,1 0 ${t * 0.75} A${t * 0.5},${t * 0.5} -30 0,1 ${-t * 0.6495} ${-t * 0.375} z`, b$ = (t) => `M${t},0 L${-t},${t} L-${t * 0.5},0 L${-t},${-t} z`, O$ = (t) => `M${t},0 L${t * 0.25},${-t} L${-t},${-t} L${t * -0.25},0 L${-t},${t} L${t * 0.25},${t} z`, I$ = (t) => `M${t},0 l-${t * 0.8} ${t * 0.8} a${t / 2},${t / 2} 90 0,1 ${-t * 0.8},${-t * 0.8} a${t / 2},${t / 2} 90 0,1 ${t * 0.8},${-t * 0.8} z`, L$ = (t) => {
  const e = t * Math.cos(0.4 * Math.PI), i = t * Math.sin(72 / 180 * Math.PI), o = t * Math.cos(36 / 180 * Math.PI), s = t * Math.sin(36 / 180 * Math.PI);
  return `M${t},0 L${e},${i} L-${o},${s} L${-o * 0.5},0 L-${o},-${s} L${e},-${i} z`;
}, M$ = (t) => `M0 0 l${-t * 2}${-t} v${t * 2}  z`, P$ = (t) => {
  const e = -t * 2.75;
  return `M0 0 L${-t * 2} ${t} C${e} ${t / 2} ${e} ${-t / 2} ${-t * 2} ${-t} z`;
}, N$ = (t) => {
  const e = t * 0.65, i = -t * 1;
  return `M0 0 M${-t * 2} ${-t} C${e} ${-t / 2} ${e} ${t / 2} ${-t * 2} ${t} C${i} ${t / 2} ${i} ${-t / 2} ${-t * 2} ${-t} z`;
}, k$ = {
  CIRCLE: { key: "CIRCLE", name: "Circle", rScaler: 1, pathFunction: w$, isDirectional: !1 },
  HEXAGON: { key: "HEXAGON", name: "Hexagon", rScaler: 0.95, pathFunction: A$, isDirectional: !1 },
  PENTAGON: { key: "PENTAGON", name: "Pentagon", rScaler: 1.15, pathFunction: E$, isDirectional: !1 },
  CLOVER: { key: "CLOVER", name: "Clover (Four Leafed)", rScaler: 0.8, pathFunction: T$, isDirectional: !1 },
  SQUARE: { key: "SQUARE", name: "Square", rScaler: 0.85, pathFunction: $$, isDirectional: !1 },
  PLUS: { key: "PLUS", name: "Plus / Cross", rScaler: 1, pathFunction: R$, isDirectional: !1 },
  DIAMOND: { key: "DIAMOND", name: "Diamond", rScaler: 1.25, pathFunction: C$, isDirectional: !1 },
  CLUB_CLOVER: {
    key: "CLUB_CLOVER",
    name: "Clover (Club suit)",
    rScaler: 1.1,
    pathFunction: S$,
    isDirectional: !1
  },
  /* Directional shapes - should be used with a specified orientation (rotation) */
  BOOMERANG: {
    key: "BOOMERANG",
    name: "Boomerang Arrow",
    rScaler: 1.05,
    pathFunction: b$,
    isDirectional: !0
  },
  BLOCK_CHEVRON: {
    key: "BLOCK_CHEVRON",
    name: "Block Chevron Arrow",
    rScaler: 1,
    pathFunction: O$,
    isDirectional: !0
  },
  HEART_SPADE: {
    key: "HEART_SPADE",
    name: "Heart/Spade Arrow",
    rScaler: 1.15,
    pathFunction: I$,
    isDirectional: !0
  },
  PENTAGON_WEDGE: {
    key: "PENTAGON_WEDGE",
    name: "Pentagon Wedge Arrow",
    rScaler: 1.1,
    pathFunction: L$,
    isDirectional: !0
  }
}, pa = {
  STROKE: "none",
  STROKE_WIDTH: 1,
  STROKE_DASHARRAY: void 0
}, D$ = {
  CONVEX: {
    key: "CONVEX",
    name: "Convex Triangular",
    rScaler: 0.9,
    pathFunction: P$,
    radiusConnection: -2.55
  },
  CRESCENT: {
    key: "CRESCENT",
    name: "Concave Excurvate",
    rScaler: 1.1,
    pathFunction: N$,
    radiusConnection: -1.25
  },
  EQUILATERAL: {
    key: "EQUILATERAL",
    name: "Equilateral Triangle",
    rScaler: 1,
    pathFunction: M$,
    radiusConnection: -2
  }
};
var Cc = /* @__PURE__ */ ((t) => (t.AUTO = "auto", t.GEOMETRIC = "geometricPrecision", t.CRISP = "crispEdges", t))(Cc || {});
const Fi = ({
  shapeName: t,
  radius: e,
  x: i,
  y: o,
  fill: s,
  fillOpacity: u = 1,
  stroke: f = pa.STROKE,
  strokeWidth: l = pa.STROKE_WIDTH,
  strokeDasharray: h = pa.STROKE_DASHARRAY,
  rotation: d,
  tooltip: _,
  autoScaleRadius: y = !0,
  shapeRendering: m = Cc.AUTO
}) => {
  const [T, S] = Nr(!1), b = !!_, M = Gi(null), I = b && M.current ? M.current.getBBox({ stroke: !0, clipped: !0 }) : null, C = I ? {
    width: I.width + l,
    height: I.height + l
  } : {}, H = k$[t], B = y ? e * H.rScaler : e, k = H.pathFunction(B), W = d ? ` rotate(${d})` : "", K = `translate(${i} ${o})${W}`;
  return /* @__PURE__ */ w.jsxs(
    "g",
    {
      "data-testid": `marker-${t}`,
      ref: M,
      onMouseOver: b ? () => S(!0) : void 0,
      onMouseOut: b ? () => S(!1) : void 0,
      children: [
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: k,
            transform: K,
            fill: s,
            fillOpacity: u,
            stroke: f,
            strokeWidth: l,
            strokeDasharray: h,
            shapeRendering: m,
            className: "group-hover:fill-marker-hover"
          }
        ),
        b && T && I && /* @__PURE__ */ w.jsx(
          "foreignObject",
          {
            role: "tooltip",
            x: I.x - l / 2,
            y: I.y - l / 2,
            style: C,
            children: /* @__PURE__ */ w.jsx(t0, { content: _, isCondensed: !0, delay: 0, children: /* @__PURE__ */ w.jsx("div", { style: C }) })
          }
        )
      ]
    }
  );
};
function F$(t, e, i, o) {
  for (var s = -1, u = t == null ? 0 : t.length; ++s < u; ) {
    var f = t[s];
    e(o, f, i(f), t);
  }
  return o;
}
var H$ = F$;
function B$(t) {
  return function(e, i, o) {
    for (var s = -1, u = Object(e), f = o(e), l = f.length; l--; ) {
      var h = f[t ? l : ++s];
      if (i(u[h], h, u) === !1)
        break;
    }
    return e;
  };
}
var W$ = B$, U$ = W$, G$ = U$(), j$ = G$;
function z$(t, e) {
  for (var i = -1, o = Array(t); ++i < t; )
    o[i] = e(i);
  return o;
}
var X$ = z$, K$ = typeof ye == "object" && ye && ye.Object === Object && ye, J0 = K$, Y$ = J0, q$ = typeof self == "object" && self && self.Object === Object && self, V$ = Y$ || q$ || Function("return this")(), Ae = V$, Z$ = Ae, J$ = Z$.Symbol, Ua = J$, Jh = Ua, Q0 = Object.prototype, Q$ = Q0.hasOwnProperty, tR = Q0.toString, Ci = Jh ? Jh.toStringTag : void 0;
function nR(t) {
  var e = Q$.call(t, Ci), i = t[Ci];
  try {
    t[Ci] = void 0;
    var o = !0;
  } catch {
  }
  var s = tR.call(t);
  return o && (e ? t[Ci] = i : delete t[Ci]), s;
}
var eR = nR, rR = Object.prototype, iR = rR.toString;
function oR(t) {
  return iR.call(t);
}
var aR = oR, Qh = Ua, sR = eR, uR = aR, cR = "[object Null]", fR = "[object Undefined]", td = Qh ? Qh.toStringTag : void 0;
function lR(t) {
  return t == null ? t === void 0 ? fR : cR : td && td in Object(t) ? sR(t) : uR(t);
}
var Qi = lR;
function hR(t) {
  return t != null && typeof t == "object";
}
var to = hR, dR = Qi, gR = to, pR = "[object Arguments]";
function _R(t) {
  return gR(t) && dR(t) == pR;
}
var vR = _R, nd = vR, mR = to, tg = Object.prototype, yR = tg.hasOwnProperty, xR = tg.propertyIsEnumerable, wR = nd(function() {
  return arguments;
}()) ? nd : function(t) {
  return mR(t) && yR.call(t, "callee") && !xR.call(t, "callee");
}, ng = wR, AR = Array.isArray, Ee = AR, Ca = { exports: {} };
function ER() {
  return !1;
}
var TR = ER;
Ca.exports;
(function(t, e) {
  var i = Ae, o = TR, s = e && !e.nodeType && e, u = s && !0 && t && !t.nodeType && t, f = u && u.exports === s, l = f ? i.Buffer : void 0, h = l ? l.isBuffer : void 0, d = h || o;
  t.exports = d;
})(Ca, Ca.exports);
var eg = Ca.exports, $R = 9007199254740991, RR = /^(?:0|[1-9]\d*)$/;
function CR(t, e) {
  var i = typeof t;
  return e = e ?? $R, !!e && (i == "number" || i != "symbol" && RR.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var rg = CR, SR = 9007199254740991;
function bR(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= SR;
}
var Sc = bR, OR = Qi, IR = Sc, LR = to, MR = "[object Arguments]", PR = "[object Array]", NR = "[object Boolean]", kR = "[object Date]", DR = "[object Error]", FR = "[object Function]", HR = "[object Map]", BR = "[object Number]", WR = "[object Object]", UR = "[object RegExp]", GR = "[object Set]", jR = "[object String]", zR = "[object WeakMap]", XR = "[object ArrayBuffer]", KR = "[object DataView]", YR = "[object Float32Array]", qR = "[object Float64Array]", VR = "[object Int8Array]", ZR = "[object Int16Array]", JR = "[object Int32Array]", QR = "[object Uint8Array]", tC = "[object Uint8ClampedArray]", nC = "[object Uint16Array]", eC = "[object Uint32Array]", Et = {};
Et[YR] = Et[qR] = Et[VR] = Et[ZR] = Et[JR] = Et[QR] = Et[tC] = Et[nC] = Et[eC] = !0;
Et[MR] = Et[PR] = Et[XR] = Et[NR] = Et[KR] = Et[kR] = Et[DR] = Et[FR] = Et[HR] = Et[BR] = Et[WR] = Et[UR] = Et[GR] = Et[jR] = Et[zR] = !1;
function rC(t) {
  return LR(t) && IR(t.length) && !!Et[OR(t)];
}
var iC = rC;
function oC(t) {
  return function(e) {
    return t(e);
  };
}
var aC = oC, Sa = { exports: {} };
Sa.exports;
(function(t, e) {
  var i = J0, o = e && !e.nodeType && e, s = o && !0 && t && !t.nodeType && t, u = s && s.exports === o, f = u && i.process, l = function() {
    try {
      var h = s && s.require && s.require("util").types;
      return h || f && f.binding && f.binding("util");
    } catch {
    }
  }();
  t.exports = l;
})(Sa, Sa.exports);
var sC = Sa.exports, uC = iC, cC = aC, ed = sC, rd = ed && ed.isTypedArray, fC = rd ? cC(rd) : uC, ig = fC, lC = X$, hC = ng, dC = Ee, gC = eg, pC = rg, _C = ig, vC = Object.prototype, mC = vC.hasOwnProperty;
function yC(t, e) {
  var i = dC(t), o = !i && hC(t), s = !i && !o && gC(t), u = !i && !o && !s && _C(t), f = i || o || s || u, l = f ? lC(t.length, String) : [], h = l.length;
  for (var d in t)
    (e || mC.call(t, d)) && !(f && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    u && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    pC(d, h))) && l.push(d);
  return l;
}
var xC = yC, wC = Object.prototype;
function AC(t) {
  var e = t && t.constructor, i = typeof e == "function" && e.prototype || wC;
  return t === i;
}
var EC = AC;
function TC(t, e) {
  return function(i) {
    return t(e(i));
  };
}
var $C = TC, RC = $C, CC = RC(Object.keys, Object), SC = CC, bC = EC, OC = SC, IC = Object.prototype, LC = IC.hasOwnProperty;
function MC(t) {
  if (!bC(t))
    return OC(t);
  var e = [];
  for (var i in Object(t))
    LC.call(t, i) && i != "constructor" && e.push(i);
  return e;
}
var PC = MC;
function NC(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var bc = NC, kC = Qi, DC = bc, FC = "[object AsyncFunction]", HC = "[object Function]", BC = "[object GeneratorFunction]", WC = "[object Proxy]";
function UC(t) {
  if (!DC(t))
    return !1;
  var e = kC(t);
  return e == HC || e == BC || e == FC || e == WC;
}
var og = UC, GC = og, jC = Sc;
function zC(t) {
  return t != null && jC(t.length) && !GC(t);
}
var ag = zC, XC = xC, KC = PC, YC = ag;
function qC(t) {
  return YC(t) ? XC(t) : KC(t);
}
var Oc = qC, VC = j$, ZC = Oc;
function JC(t, e) {
  return t && VC(t, e, ZC);
}
var QC = JC, tS = ag;
function nS(t, e) {
  return function(i, o) {
    if (i == null)
      return i;
    if (!tS(i))
      return t(i, o);
    for (var s = i.length, u = e ? s : -1, f = Object(i); (e ? u-- : ++u < s) && o(f[u], u, f) !== !1; )
      ;
    return i;
  };
}
var eS = nS, rS = QC, iS = eS, oS = iS(rS), aS = oS, sS = aS;
function uS(t, e, i, o) {
  return sS(t, function(s, u, f) {
    e(o, s, i(s), f);
  }), o;
}
var cS = uS;
function fS() {
  this.__data__ = [], this.size = 0;
}
var lS = fS;
function hS(t, e) {
  return t === e || t !== t && e !== e;
}
var sg = hS, dS = sg;
function gS(t, e) {
  for (var i = t.length; i--; )
    if (dS(t[i][0], e))
      return i;
  return -1;
}
var Ga = gS, pS = Ga, _S = Array.prototype, vS = _S.splice;
function mS(t) {
  var e = this.__data__, i = pS(e, t);
  if (i < 0)
    return !1;
  var o = e.length - 1;
  return i == o ? e.pop() : vS.call(e, i, 1), --this.size, !0;
}
var yS = mS, xS = Ga;
function wS(t) {
  var e = this.__data__, i = xS(e, t);
  return i < 0 ? void 0 : e[i][1];
}
var AS = wS, ES = Ga;
function TS(t) {
  return ES(this.__data__, t) > -1;
}
var $S = TS, RS = Ga;
function CS(t, e) {
  var i = this.__data__, o = RS(i, t);
  return o < 0 ? (++this.size, i.push([t, e])) : i[o][1] = e, this;
}
var SS = CS, bS = lS, OS = yS, IS = AS, LS = $S, MS = SS;
function Gr(t) {
  var e = -1, i = t == null ? 0 : t.length;
  for (this.clear(); ++e < i; ) {
    var o = t[e];
    this.set(o[0], o[1]);
  }
}
Gr.prototype.clear = bS;
Gr.prototype.delete = OS;
Gr.prototype.get = IS;
Gr.prototype.has = LS;
Gr.prototype.set = MS;
var ja = Gr, PS = ja;
function NS() {
  this.__data__ = new PS(), this.size = 0;
}
var kS = NS;
function DS(t) {
  var e = this.__data__, i = e.delete(t);
  return this.size = e.size, i;
}
var FS = DS;
function HS(t) {
  return this.__data__.get(t);
}
var BS = HS;
function WS(t) {
  return this.__data__.has(t);
}
var US = WS, GS = Ae, jS = GS["__core-js_shared__"], zS = jS, mu = zS, id = function() {
  var t = /[^.]+$/.exec(mu && mu.keys && mu.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function XS(t) {
  return !!id && id in t;
}
var KS = XS, YS = Function.prototype, qS = YS.toString;
function VS(t) {
  if (t != null) {
    try {
      return qS.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var ug = VS, ZS = og, JS = KS, QS = bc, tb = ug, nb = /[\\^$.*+?()[\]{}|]/g, eb = /^\[object .+?Constructor\]$/, rb = Function.prototype, ib = Object.prototype, ob = rb.toString, ab = ib.hasOwnProperty, sb = RegExp(
  "^" + ob.call(ab).replace(nb, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ub(t) {
  if (!QS(t) || JS(t))
    return !1;
  var e = ZS(t) ? sb : eb;
  return e.test(tb(t));
}
var cb = ub;
function fb(t, e) {
  return t == null ? void 0 : t[e];
}
var lb = fb, hb = cb, db = lb;
function gb(t, e) {
  var i = db(t, e);
  return hb(i) ? i : void 0;
}
var jr = gb, pb = jr, _b = Ae, vb = pb(_b, "Map"), Ic = vb, mb = jr, yb = mb(Object, "create"), za = yb, od = za;
function xb() {
  this.__data__ = od ? od(null) : {}, this.size = 0;
}
var wb = xb;
function Ab(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Eb = Ab, Tb = za, $b = "__lodash_hash_undefined__", Rb = Object.prototype, Cb = Rb.hasOwnProperty;
function Sb(t) {
  var e = this.__data__;
  if (Tb) {
    var i = e[t];
    return i === $b ? void 0 : i;
  }
  return Cb.call(e, t) ? e[t] : void 0;
}
var bb = Sb, Ob = za, Ib = Object.prototype, Lb = Ib.hasOwnProperty;
function Mb(t) {
  var e = this.__data__;
  return Ob ? e[t] !== void 0 : Lb.call(e, t);
}
var Pb = Mb, Nb = za, kb = "__lodash_hash_undefined__";
function Db(t, e) {
  var i = this.__data__;
  return this.size += this.has(t) ? 0 : 1, i[t] = Nb && e === void 0 ? kb : e, this;
}
var Fb = Db, Hb = wb, Bb = Eb, Wb = bb, Ub = Pb, Gb = Fb;
function zr(t) {
  var e = -1, i = t == null ? 0 : t.length;
  for (this.clear(); ++e < i; ) {
    var o = t[e];
    this.set(o[0], o[1]);
  }
}
zr.prototype.clear = Hb;
zr.prototype.delete = Bb;
zr.prototype.get = Wb;
zr.prototype.has = Ub;
zr.prototype.set = Gb;
var jb = zr, ad = jb, zb = ja, Xb = Ic;
function Kb() {
  this.size = 0, this.__data__ = {
    hash: new ad(),
    map: new (Xb || zb)(),
    string: new ad()
  };
}
var Yb = Kb;
function qb(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var Vb = qb, Zb = Vb;
function Jb(t, e) {
  var i = t.__data__;
  return Zb(e) ? i[typeof e == "string" ? "string" : "hash"] : i.map;
}
var Xa = Jb, Qb = Xa;
function tO(t) {
  var e = Qb(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var nO = tO, eO = Xa;
function rO(t) {
  return eO(this, t).get(t);
}
var iO = rO, oO = Xa;
function aO(t) {
  return oO(this, t).has(t);
}
var sO = aO, uO = Xa;
function cO(t, e) {
  var i = uO(this, t), o = i.size;
  return i.set(t, e), this.size += i.size == o ? 0 : 1, this;
}
var fO = cO, lO = Yb, hO = nO, dO = iO, gO = sO, pO = fO;
function Xr(t) {
  var e = -1, i = t == null ? 0 : t.length;
  for (this.clear(); ++e < i; ) {
    var o = t[e];
    this.set(o[0], o[1]);
  }
}
Xr.prototype.clear = lO;
Xr.prototype.delete = hO;
Xr.prototype.get = dO;
Xr.prototype.has = gO;
Xr.prototype.set = pO;
var Lc = Xr, _O = ja, vO = Ic, mO = Lc, yO = 200;
function xO(t, e) {
  var i = this.__data__;
  if (i instanceof _O) {
    var o = i.__data__;
    if (!vO || o.length < yO - 1)
      return o.push([t, e]), this.size = ++i.size, this;
    i = this.__data__ = new mO(o);
  }
  return i.set(t, e), this.size = i.size, this;
}
var wO = xO, AO = ja, EO = kS, TO = FS, $O = BS, RO = US, CO = wO;
function Kr(t) {
  var e = this.__data__ = new AO(t);
  this.size = e.size;
}
Kr.prototype.clear = EO;
Kr.prototype.delete = TO;
Kr.prototype.get = $O;
Kr.prototype.has = RO;
Kr.prototype.set = CO;
var cg = Kr, SO = "__lodash_hash_undefined__";
function bO(t) {
  return this.__data__.set(t, SO), this;
}
var OO = bO;
function IO(t) {
  return this.__data__.has(t);
}
var LO = IO, MO = Lc, PO = OO, NO = LO;
function ba(t) {
  var e = -1, i = t == null ? 0 : t.length;
  for (this.__data__ = new MO(); ++e < i; )
    this.add(t[e]);
}
ba.prototype.add = ba.prototype.push = PO;
ba.prototype.has = NO;
var kO = ba;
function DO(t, e) {
  for (var i = -1, o = t == null ? 0 : t.length; ++i < o; )
    if (e(t[i], i, t))
      return !0;
  return !1;
}
var FO = DO;
function HO(t, e) {
  return t.has(e);
}
var BO = HO, WO = kO, UO = FO, GO = BO, jO = 1, zO = 2;
function XO(t, e, i, o, s, u) {
  var f = i & jO, l = t.length, h = e.length;
  if (l != h && !(f && h > l))
    return !1;
  var d = u.get(t), _ = u.get(e);
  if (d && _)
    return d == e && _ == t;
  var y = -1, m = !0, T = i & zO ? new WO() : void 0;
  for (u.set(t, e), u.set(e, t); ++y < l; ) {
    var S = t[y], b = e[y];
    if (o)
      var M = f ? o(b, S, y, e, t, u) : o(S, b, y, t, e, u);
    if (M !== void 0) {
      if (M)
        continue;
      m = !1;
      break;
    }
    if (T) {
      if (!UO(e, function(I, C) {
        if (!GO(T, C) && (S === I || s(S, I, i, o, u)))
          return T.push(C);
      })) {
        m = !1;
        break;
      }
    } else if (!(S === b || s(S, b, i, o, u))) {
      m = !1;
      break;
    }
  }
  return u.delete(t), u.delete(e), m;
}
var fg = XO, KO = Ae, YO = KO.Uint8Array, qO = YO;
function VO(t) {
  var e = -1, i = Array(t.size);
  return t.forEach(function(o, s) {
    i[++e] = [s, o];
  }), i;
}
var ZO = VO;
function JO(t) {
  var e = -1, i = Array(t.size);
  return t.forEach(function(o) {
    i[++e] = o;
  }), i;
}
var QO = JO, sd = Ua, ud = qO, tI = sg, nI = fg, eI = ZO, rI = QO, iI = 1, oI = 2, aI = "[object Boolean]", sI = "[object Date]", uI = "[object Error]", cI = "[object Map]", fI = "[object Number]", lI = "[object RegExp]", hI = "[object Set]", dI = "[object String]", gI = "[object Symbol]", pI = "[object ArrayBuffer]", _I = "[object DataView]", cd = sd ? sd.prototype : void 0, yu = cd ? cd.valueOf : void 0;
function vI(t, e, i, o, s, u, f) {
  switch (i) {
    case _I:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case pI:
      return !(t.byteLength != e.byteLength || !u(new ud(t), new ud(e)));
    case aI:
    case sI:
    case fI:
      return tI(+t, +e);
    case uI:
      return t.name == e.name && t.message == e.message;
    case lI:
    case dI:
      return t == e + "";
    case cI:
      var l = eI;
    case hI:
      var h = o & iI;
      if (l || (l = rI), t.size != e.size && !h)
        return !1;
      var d = f.get(t);
      if (d)
        return d == e;
      o |= oI, f.set(t, e);
      var _ = nI(l(t), l(e), o, s, u, f);
      return f.delete(t), _;
    case gI:
      if (yu)
        return yu.call(t) == yu.call(e);
  }
  return !1;
}
var mI = vI;
function yI(t, e) {
  for (var i = -1, o = e.length, s = t.length; ++i < o; )
    t[s + i] = e[i];
  return t;
}
var xI = yI, wI = xI, AI = Ee;
function EI(t, e, i) {
  var o = e(t);
  return AI(t) ? o : wI(o, i(t));
}
var TI = EI;
function $I(t, e) {
  for (var i = -1, o = t == null ? 0 : t.length, s = 0, u = []; ++i < o; ) {
    var f = t[i];
    e(f, i, t) && (u[s++] = f);
  }
  return u;
}
var RI = $I;
function CI() {
  return [];
}
var SI = CI, bI = RI, OI = SI, II = Object.prototype, LI = II.propertyIsEnumerable, fd = Object.getOwnPropertySymbols, MI = fd ? function(t) {
  return t == null ? [] : (t = Object(t), bI(fd(t), function(e) {
    return LI.call(t, e);
  }));
} : OI, PI = MI, NI = TI, kI = PI, DI = Oc;
function FI(t) {
  return NI(t, DI, kI);
}
var HI = FI, ld = HI, BI = 1, WI = Object.prototype, UI = WI.hasOwnProperty;
function GI(t, e, i, o, s, u) {
  var f = i & BI, l = ld(t), h = l.length, d = ld(e), _ = d.length;
  if (h != _ && !f)
    return !1;
  for (var y = h; y--; ) {
    var m = l[y];
    if (!(f ? m in e : UI.call(e, m)))
      return !1;
  }
  var T = u.get(t), S = u.get(e);
  if (T && S)
    return T == e && S == t;
  var b = !0;
  u.set(t, e), u.set(e, t);
  for (var M = f; ++y < h; ) {
    m = l[y];
    var I = t[m], C = e[m];
    if (o)
      var H = f ? o(C, I, m, e, t, u) : o(I, C, m, t, e, u);
    if (!(H === void 0 ? I === C || s(I, C, i, o, u) : H)) {
      b = !1;
      break;
    }
    M || (M = m == "constructor");
  }
  if (b && !M) {
    var B = t.constructor, k = e.constructor;
    B != k && "constructor" in t && "constructor" in e && !(typeof B == "function" && B instanceof B && typeof k == "function" && k instanceof k) && (b = !1);
  }
  return u.delete(t), u.delete(e), b;
}
var jI = GI, zI = jr, XI = Ae, KI = zI(XI, "DataView"), YI = KI, qI = jr, VI = Ae, ZI = qI(VI, "Promise"), JI = ZI, QI = jr, tL = Ae, nL = QI(tL, "Set"), eL = nL, rL = jr, iL = Ae, oL = rL(iL, "WeakMap"), aL = oL, zu = YI, Xu = Ic, Ku = JI, Yu = eL, qu = aL, lg = Qi, Yr = ug, hd = "[object Map]", sL = "[object Object]", dd = "[object Promise]", gd = "[object Set]", pd = "[object WeakMap]", _d = "[object DataView]", uL = Yr(zu), cL = Yr(Xu), fL = Yr(Ku), lL = Yr(Yu), hL = Yr(qu), tr = lg;
(zu && tr(new zu(new ArrayBuffer(1))) != _d || Xu && tr(new Xu()) != hd || Ku && tr(Ku.resolve()) != dd || Yu && tr(new Yu()) != gd || qu && tr(new qu()) != pd) && (tr = function(t) {
  var e = lg(t), i = e == sL ? t.constructor : void 0, o = i ? Yr(i) : "";
  if (o)
    switch (o) {
      case uL:
        return _d;
      case cL:
        return hd;
      case fL:
        return dd;
      case lL:
        return gd;
      case hL:
        return pd;
    }
  return e;
});
var dL = tr, xu = cg, gL = fg, pL = mI, _L = jI, vd = dL, md = Ee, yd = eg, vL = ig, mL = 1, xd = "[object Arguments]", wd = "[object Array]", oa = "[object Object]", yL = Object.prototype, Ad = yL.hasOwnProperty;
function xL(t, e, i, o, s, u) {
  var f = md(t), l = md(e), h = f ? wd : vd(t), d = l ? wd : vd(e);
  h = h == xd ? oa : h, d = d == xd ? oa : d;
  var _ = h == oa, y = d == oa, m = h == d;
  if (m && yd(t)) {
    if (!yd(e))
      return !1;
    f = !0, _ = !1;
  }
  if (m && !_)
    return u || (u = new xu()), f || vL(t) ? gL(t, e, i, o, s, u) : pL(t, e, h, i, o, s, u);
  if (!(i & mL)) {
    var T = _ && Ad.call(t, "__wrapped__"), S = y && Ad.call(e, "__wrapped__");
    if (T || S) {
      var b = T ? t.value() : t, M = S ? e.value() : e;
      return u || (u = new xu()), s(b, M, i, o, u);
    }
  }
  return m ? (u || (u = new xu()), _L(t, e, i, o, s, u)) : !1;
}
var wL = xL, AL = wL, Ed = to;
function hg(t, e, i, o, s) {
  return t === e ? !0 : t == null || e == null || !Ed(t) && !Ed(e) ? t !== t && e !== e : AL(t, e, i, o, hg, s);
}
var dg = hg, EL = cg, TL = dg, $L = 1, RL = 2;
function CL(t, e, i, o) {
  var s = i.length, u = s, f = !o;
  if (t == null)
    return !u;
  for (t = Object(t); s--; ) {
    var l = i[s];
    if (f && l[2] ? l[1] !== t[l[0]] : !(l[0] in t))
      return !1;
  }
  for (; ++s < u; ) {
    l = i[s];
    var h = l[0], d = t[h], _ = l[1];
    if (f && l[2]) {
      if (d === void 0 && !(h in t))
        return !1;
    } else {
      var y = new EL();
      if (o)
        var m = o(d, _, h, t, e, y);
      if (!(m === void 0 ? TL(_, d, $L | RL, o, y) : m))
        return !1;
    }
  }
  return !0;
}
var SL = CL, bL = bc;
function OL(t) {
  return t === t && !bL(t);
}
var gg = OL, IL = gg, LL = Oc;
function ML(t) {
  for (var e = LL(t), i = e.length; i--; ) {
    var o = e[i], s = t[o];
    e[i] = [o, s, IL(s)];
  }
  return e;
}
var PL = ML;
function NL(t, e) {
  return function(i) {
    return i == null ? !1 : i[t] === e && (e !== void 0 || t in Object(i));
  };
}
var pg = NL, kL = SL, DL = PL, FL = pg;
function HL(t) {
  var e = DL(t);
  return e.length == 1 && e[0][2] ? FL(e[0][0], e[0][1]) : function(i) {
    return i === t || kL(i, t, e);
  };
}
var BL = HL, WL = Qi, UL = to, GL = "[object Symbol]";
function jL(t) {
  return typeof t == "symbol" || UL(t) && WL(t) == GL;
}
var Mc = jL, zL = Ee, XL = Mc, KL = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, YL = /^\w*$/;
function qL(t, e) {
  if (zL(t))
    return !1;
  var i = typeof t;
  return i == "number" || i == "symbol" || i == "boolean" || t == null || XL(t) ? !0 : YL.test(t) || !KL.test(t) || e != null && t in Object(e);
}
var Pc = qL, _g = Lc, VL = "Expected a function";
function Nc(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(VL);
  var i = function() {
    var o = arguments, s = e ? e.apply(this, o) : o[0], u = i.cache;
    if (u.has(s))
      return u.get(s);
    var f = t.apply(this, o);
    return i.cache = u.set(s, f) || u, f;
  };
  return i.cache = new (Nc.Cache || _g)(), i;
}
Nc.Cache = _g;
var ZL = Nc, JL = ZL, QL = 500;
function tM(t) {
  var e = JL(t, function(o) {
    return i.size === QL && i.clear(), o;
  }), i = e.cache;
  return e;
}
var nM = tM, eM = nM, rM = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, iM = /\\(\\)?/g, oM = eM(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(rM, function(i, o, s, u) {
    e.push(s ? u.replace(iM, "$1") : o || i);
  }), e;
}), aM = oM;
function sM(t, e) {
  for (var i = -1, o = t == null ? 0 : t.length, s = Array(o); ++i < o; )
    s[i] = e(t[i], i, t);
  return s;
}
var uM = sM, Td = Ua, cM = uM, fM = Ee, lM = Mc, hM = 1 / 0, $d = Td ? Td.prototype : void 0, Rd = $d ? $d.toString : void 0;
function vg(t) {
  if (typeof t == "string")
    return t;
  if (fM(t))
    return cM(t, vg) + "";
  if (lM(t))
    return Rd ? Rd.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -hM ? "-0" : e;
}
var dM = vg, gM = dM;
function pM(t) {
  return t == null ? "" : gM(t);
}
var _M = pM, vM = Ee, mM = Pc, yM = aM, xM = _M;
function wM(t, e) {
  return vM(t) ? t : mM(t, e) ? [t] : yM(xM(t));
}
var mg = wM, AM = Mc, EM = 1 / 0;
function TM(t) {
  if (typeof t == "string" || AM(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -EM ? "-0" : e;
}
var Ka = TM, $M = mg, RM = Ka;
function CM(t, e) {
  e = $M(e, t);
  for (var i = 0, o = e.length; t != null && i < o; )
    t = t[RM(e[i++])];
  return i && i == o ? t : void 0;
}
var yg = CM, SM = yg;
function bM(t, e, i) {
  var o = t == null ? void 0 : SM(t, e);
  return o === void 0 ? i : o;
}
var OM = bM;
function IM(t, e) {
  return t != null && e in Object(t);
}
var LM = IM, MM = mg, PM = ng, NM = Ee, kM = rg, DM = Sc, FM = Ka;
function HM(t, e, i) {
  e = MM(e, t);
  for (var o = -1, s = e.length, u = !1; ++o < s; ) {
    var f = FM(e[o]);
    if (!(u = t != null && i(t, f)))
      break;
    t = t[f];
  }
  return u || ++o != s ? u : (s = t == null ? 0 : t.length, !!s && DM(s) && kM(f, s) && (NM(t) || PM(t)));
}
var BM = HM, WM = LM, UM = BM;
function GM(t, e) {
  return t != null && UM(t, e, WM);
}
var jM = GM, zM = dg, XM = OM, KM = jM, YM = Pc, qM = gg, VM = pg, ZM = Ka, JM = 1, QM = 2;
function tP(t, e) {
  return YM(t) && qM(e) ? VM(ZM(t), e) : function(i) {
    var o = XM(i, t);
    return o === void 0 && o === e ? KM(i, t) : zM(e, o, JM | QM);
  };
}
var nP = tP;
function eP(t) {
  return t;
}
var rP = eP;
function iP(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var oP = iP, aP = yg;
function sP(t) {
  return function(e) {
    return aP(e, t);
  };
}
var uP = sP, cP = oP, fP = uP, lP = Pc, hP = Ka;
function dP(t) {
  return lP(t) ? cP(hP(t)) : fP(t);
}
var gP = dP, pP = BL, _P = nP, vP = rP, mP = Ee, yP = gP;
function xP(t) {
  return typeof t == "function" ? t : t == null ? vP : typeof t == "object" ? mP(t) ? _P(t[0], t[1]) : pP(t) : yP(t);
}
var wP = xP, AP = H$, EP = cS, TP = wP, $P = Ee;
function RP(t, e) {
  return function(i, o) {
    var s = $P(i) ? AP : EP, u = e ? e() : {};
    return s(i, t, TP(o), u);
  };
}
var CP = RP, SP = CP, bP = SP(function(t, e, i) {
  t[i ? 0 : 1].push(e);
}, function() {
  return [[], []];
}), OP = bP;
const xg = /* @__PURE__ */ n0(OP), IP = ({
  markers: t,
  onMarkerClick: e,
  selectedItemIds: i,
  setSelectedItemIds: o,
  highlightedItemIds: s,
  isHighlightNowPlaying: u
}) => {
  const [f, l] = Nr([]), h = [...t].sort((k, W) => k.x - W.x), d = !!(i && (i == null ? void 0 : i.length) > 0), _ = (k) => d && (i == null ? void 0 : i.includes(k.id)), [y, m] = xg(h, (k) => _(k)), T = h.filter((k) => s == null ? void 0 : s.includes(k.id));
  Z0(d);
  const S = !!e, b = Dt(), M = b.colours.visualisations.dataObjects.default.n1.main, I = b.colours.visualisations.base.background, C = b.colours.visualisations.dataObjects.inspection, H = b.colours.visualisations.dataObjects.focus, B = (k) => {
    const {
      id: W,
      x: K,
      y: q,
      shapeName: tt,
      rotation: X,
      shapeRendering: j,
      autoScaleRadius: et,
      tooltip: nt,
      strokeDasharray: yt,
      // These values are mandatory for the marker component, but pitch has sensible defaults so not mandatory for pitch layer
      radius: Tt = Zn.radius,
      fill: Pt = M,
      stroke: gt = Zn.stroke,
      strokeWidth: St = Zn.strokeWidth
    } = k, Nt = !!nt || S;
    return /* @__PURE__ */ w.jsx(
      "g",
      {
        tabIndex: S ? 0 : void 0,
        id: `event-marker-${W}`,
        "data-testid": `clickable-shape-${W}`,
        onClick: S ? (Wt) => e(Wt, W) : void 0,
        onKeyUp: S ? (Wt) => {
          Wt.key === "Tab" ? l([k]) : Wt.key === "Escape" && i && o ? o([]) : Wt.key === "Enter" && e(Wt, W);
        } : void 0,
        onBlur: () => l([]),
        className: ln("outline-none", { "cursor-pointer": S, group: Nt }),
        children: /* @__PURE__ */ w.jsx(
          Fi,
          {
            shapeName: tt,
            x: K,
            y: q,
            fill: Pt,
            rotation: X,
            radius: Tt,
            tooltip: nt,
            stroke: gt,
            strokeWidth: St,
            shapeRendering: j,
            autoScaleRadius: et,
            strokeDasharray: yt
          }
        )
      },
      W
    );
  };
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx("g", { className: d ? "unselected-zone" : "selected-zone", "data-testid": "unselected-marker-group", children: m.map(B) }),
    /* @__PURE__ */ w.jsx("g", { className: "selected-zone", "data-testid": "selected-marker-group", children: y.map(B) }),
    T.map((k) => {
      const { id: W, x: K, y: q, radius: tt = Zn.radius } = k;
      return /* @__PURE__ */ w.jsxs("g", { className: "pointer-events-none", children: [
        u && /* @__PURE__ */ w.jsx(
          Fi,
          {
            shapeName: "CIRCLE",
            x: K,
            y: q,
            radius: tt * 2,
            fill: I,
            fillOpacity: Zn.fillOpacityNowPlaying,
            stroke: C,
            strokeWidth: Zn.strokeWidthFocused
          }
        ),
        /* @__PURE__ */ w.jsx("use", { "data-testid": `highlighted-event-marker-${W}`, href: `#event-marker-${W}` })
      ] }, W);
    }),
    f.map((k) => {
      const { id: W, x: K, y: q, shapeName: tt, rotation: X, radius: j = Zn.radius } = k, et = Zn.strokeWidthFocused;
      return /* @__PURE__ */ w.jsx("g", { "data-testid": "focused-marker-group", children: /* @__PURE__ */ w.jsx(
        "g",
        {
          "data-testid": `focused-shape-${W}`,
          className: "unselected pointer-events-none stroke-black dark:stroke-white",
          children: /* @__PURE__ */ w.jsx(
            Fi,
            {
              shapeName: tt,
              x: K,
              y: q,
              radius: j * 2,
              fill: "transparent",
              stroke: H,
              strokeWidth: et,
              rotation: X
            }
          )
        }
      ) }, `event-marker-focus-${W}`);
    })
  ] });
}, LP = ({
  arrowHeadStrokeWidth: t,
  endX: e,
  endY: i,
  rotationTransform: o,
  tooltip: s,
  onArrowClick: u,
  arrowRef: f
}) => {
  if (!f.current)
    return null;
  const { width: l, height: h, x: d, y: _ } = f.current.getBBox({ stroke: !0, clipped: !0 });
  return /* @__PURE__ */ w.jsx(
    "foreignObject",
    {
      role: "tooltip",
      x: d,
      y: _,
      style: {
        width: l + t * 2,
        height: h + t * 2,
        transform: `translate(${e}px, ${i}px) rotate(${o}deg)`
      },
      children: /* @__PURE__ */ w.jsx(t0, { content: s, isCondensed: !0, delay: 0, children: /* @__PURE__ */ w.jsx(
        "div",
        {
          onClick: u || void 0,
          style: {
            width: l + t * 2,
            height: h + t * 2,
            cursor: u ? "pointer" : "auto"
          }
        }
      ) })
    }
  );
}, Vu = ({
  arrowHeadName: t,
  arrowHeadRadius: e,
  startX: i,
  endX: o,
  startY: s,
  endY: u,
  stroke: f,
  strokeWidth: l,
  strokeDasharray: h = pa.STROKE_DASHARRAY,
  arrowHeadFill: d,
  arrowHeadFillOpacity: _ = 1,
  arrowHeadStrokeWidth: y = 0,
  tooltip: m,
  autoScaleRadius: T = !0,
  shapeRendering: S = Cc.AUTO,
  onArrowClick: b
}) => {
  const [M, I] = Nr(!1), C = !!m, H = Gi(null), B = D$[t], k = T ? e * B.rScaler : e, W = B.pathFunction(k), K = WA(i, s, o, u), q = `translate(${o} ${u}) rotate(${K})`, tt = d || f, X = y > 0 ? f : "none", j = HA(i, s, o, u), et = B.radiusConnection * k, nt = Math.abs(j) > Math.abs(et);
  return cc(() => {
    C && I(!0);
  }, [C]), /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    nt && /* @__PURE__ */ w.jsx(
      "line",
      {
        x1: et,
        x2: -j,
        y1: 0,
        y2: 0,
        stroke: f,
        strokeWidth: l,
        transform: q,
        strokeDasharray: h,
        strokeLinecap: "butt",
        "data-testid": "arrow-shaft",
        className: "pointer-events-none group-hover:stroke-marker-hover"
      }
    ),
    /* @__PURE__ */ w.jsx(
      "path",
      {
        ref: H,
        d: W,
        transform: q,
        fill: tt,
        fillOpacity: _,
        stroke: X,
        strokeWidth: y,
        shapeRendering: S,
        "data-testid": `arrow-head-${t}`,
        className: "pointer-events-none group-hover:fill-marker-hover group-hover:stroke-marker-hover"
      }
    ),
    C && M && /* @__PURE__ */ w.jsx(
      LP,
      {
        arrowHeadStrokeWidth: y,
        arrowRef: H,
        endX: o,
        endY: u,
        onArrowClick: b,
        rotationTransform: K,
        tooltip: m
      }
    )
  ] });
}, MP = ({
  arrows: t,
  selectedItemIds: e,
  setSelectedItemIds: i,
  onMarkerClick: o,
  highlightedItemIds: s,
  isHighlightNowPlaying: u
}) => {
  const [f, l] = Nr([]), h = [...t].sort((k, W) => k.endX - W.endX), d = !!(e && (e == null ? void 0 : e.length) > 0), _ = (k) => d && (e == null ? void 0 : e.includes(k.id)), [y, m] = xg(h, (k) => _(k)), T = h.filter((k) => s == null ? void 0 : s.includes(k.id));
  Z0(d);
  const S = !!o, b = Dt(), M = Bn({
    tokens: b,
    findKey: "colours.visualisations.dataObjects.default.n1.main"
  }), I = Bn({
    tokens: b,
    findKey: "colours.visualisations.base.background"
  }), C = Bn({
    tokens: b,
    findKey: "colours.visualisations.dataObjects.inspection"
  }), H = Bn({
    tokens: b,
    findKey: "colours.visualisations.dataObjects.focus"
  }), B = (k) => {
    const { id: W, startX: K, endX: q, startY: tt, endY: X, arrowHeadName: j, tooltip: et } = k, nt = !!et || S, yt = k.arrowHeadRadius || Ri.arrowHeadRadius, Tt = k.stroke || M, Pt = k.strokeWidth ?? Ri.strokeWidth;
    return /* @__PURE__ */ w.jsxs(
      "g",
      {
        id: `event-arrow-${W}`,
        "data-testid": `event-arrow-${W}`,
        tabIndex: S ? 0 : void 0,
        onKeyUp: S ? (gt) => {
          gt.key === "Tab" ? l([k]) : gt.key === "Escape" && e && i ? i([]) : gt.key === "Enter" && o(gt, W);
        } : void 0,
        className: ln("outline-none", { group: nt }),
        onBlur: () => l([]),
        children: [
          S && /* @__PURE__ */ w.jsx("g", { onClick: (gt) => o(gt, W), children: /* @__PURE__ */ w.jsx(
            "line",
            {
              id: `event-arrow-click-target-${W}`,
              "data-testid": `event-arrow-click-target-${W}`,
              x1: K,
              x2: q,
              y1: tt,
              y2: X,
              stroke: "transparent",
              strokeWidth: yt * 2,
              className: "cursor-pointer"
            }
          ) }),
          /* @__PURE__ */ w.jsx(
            Vu,
            {
              arrowHeadName: j,
              arrowHeadRadius: yt,
              startX: K,
              endX: q,
              startY: tt,
              endY: X,
              stroke: Tt,
              strokeWidth: Pt,
              arrowHeadFill: k.arrowHeadFill,
              arrowHeadStrokeWidth: k.arrowHeadStrokeWidth,
              strokeDasharray: k.strokeDasharray,
              tooltip: et,
              onArrowClick: S ? (gt) => o(gt, W) : void 0
            }
          )
        ]
      },
      W
    );
  };
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx("g", { className: d ? "unselected-zone" : "selected-zone", "data-testid": "unselected-arrow-group", children: m.map(B) }),
    /* @__PURE__ */ w.jsx("g", { className: "selected-zone", "data-testid": "selected-arrow-group", children: y.map(B) }),
    T.map((k) => {
      const { id: W, endX: K, endY: q } = k, tt = k.arrowHeadRadius || Ri.arrowHeadRadius;
      return /* @__PURE__ */ w.jsxs("g", { className: "pointer-events-none", children: [
        u && /* @__PURE__ */ w.jsx(
          Fi,
          {
            shapeName: "CIRCLE",
            x: K,
            y: q,
            radius: tt * 2,
            fill: I,
            fillOpacity: Zn.fillOpacityNowPlaying,
            stroke: C,
            strokeWidth: Zn.strokeWidthFocused
          }
        ),
        /* @__PURE__ */ w.jsx("use", { "data-testid": `highlighted-event-arrow-${W}`, href: `#event-arrow-${W}` })
      ] }, W);
    }),
    f.map((k) => {
      const { id: W, startX: K, endX: q, startY: tt, endY: X, arrowHeadName: j } = k, et = k.arrowHeadRadius || Ri.arrowHeadRadius, nt = Ri.strokeWidthFocused;
      return /* @__PURE__ */ w.jsx("g", { "data-testid": "focused-marker-group", style: { stroke: "none" }, children: /* @__PURE__ */ w.jsx("g", { "data-testid": `focused-shape-${W}`, className: "unselected pointer-events-none", children: /* @__PURE__ */ w.jsx(
        Vu,
        {
          arrowHeadName: j,
          arrowHeadRadius: et * 1.5,
          startX: K,
          endX: q,
          startY: tt,
          endY: X,
          stroke: H,
          strokeWidth: nt,
          arrowHeadFill: "transparent",
          arrowHeadStrokeWidth: nt
        }
      ) }) }, `event-marker-focus-${W}`);
    })
  ] });
}, PP = 3, NP = (t) => /* @__PURE__ */ w.jsx(
  "text",
  {
    className: "font-sans font-bold fill-white stroke-black stroke-1 text-anchor-middle paint-order-stroke",
    ...t
  }
), kP = ({ x: t, y: e, fontSize: i, children: o }) => /* @__PURE__ */ w.jsx(NP, { x: t, y: e, fontSize: i, children: o }), DP = ({ rotationName: t, pitchFocusZoneName: e, fallbackText: i, ...o }) => {
  const s = z0[e], u = s.focusX(0, Wn.x), f = s.focusY(0, Wn.y), l = s.width(0, Wn.x), h = s.height(0, Wn.y), d = Math.min(l, h) / 20, _ = nn[t].angle * -1, y = { transform: `translate(${u}, ${f}) rotate(${_} 0 0)` }, m = i.length;
  return /* @__PURE__ */ w.jsx("g", { ...y, ...o, children: i == null ? void 0 : i.map((T, S) => {
    const b = d * (PP * S), M = 0 - d * (m - 1);
    return /* @__PURE__ */ w.jsx(kP, { x: 0, y: M + b, fontSize: d, children: T }, T);
  }) });
}, FP = ({ zones: t, onZoneClick: e }) => {
  const i = !!e;
  return t.map(({ id: o, points: s }) => /* @__PURE__ */ w.jsx(
    "g",
    {
      "data-testid": `grid-zone-${o}`,
      tabIndex: i ? 0 : void 0,
      onClick: i ? (u) => e(u, { id: o, points: s }) : void 0,
      onKeyUp: i ? (u) => {
        u.key === "Enter" && e(u, { id: o, points: s });
      } : void 0,
      className: ln("outline-none", {
        "focus-visible:-outline-offset-1 focus-visible:outline-1 focus-visible:outline-black dark:focus-visible:outline-white": i
      }),
      children: /* @__PURE__ */ w.jsx(
        "polygon",
        {
          className: ln("fill-transparent opacity-40", { "cursor-pointer hover:fill-zone-hover": i }),
          points: s
        }
      )
    },
    o
  ));
}, HP = ({ lines: t }) => {
  const e = Dt(), i = Bn({
    tokens: e,
    findKey: "colours.visualisations.soccer.gridCells.stroke"
  });
  return /* @__PURE__ */ w.jsx("g", { className: "pointer-events-none", children: t.map(({ id: o, x1: s, y1: u, x2: f, y2: l }) => /* @__PURE__ */ w.jsx(
    "line",
    {
      x1: s,
      y1: u,
      x2: f,
      y2: l,
      className: "stroke-2 fill-none",
      stroke: i,
      vectorEffect: "non-scaling-stroke"
    },
    `grid-line${o}`
  )) });
}, Sk = ({ zones: t }) => {
  const e = Dt();
  return (t[0].zoneBackgroundColour && !t[0].fill ? t.map((s) => {
    const u = Bn({
      tokens: e,
      findKey: `colours.visualisations.soccer.gridCells.${s.zoneBackgroundColour}`
    });
    return { id: s.id, points: s.points, fill: u };
  }) : t).map(({ id: s, points: u, fill: f }) => /* @__PURE__ */ w.jsx("g", { children: /* @__PURE__ */ w.jsx("polygon", { fill: f || "transparent", points: u }) }, s));
}, Cd = {
  dark: "#1370C2",
  light: "#2B6CB0"
}, BP = {
  dark: "#CCC",
  light: "#666"
}, WP = 0.4, UP = "0.5 0.6", GP = "0.2";
/**
 * @preserve
 * Fast, destructive implemetation of Liang-Barsky line clipping algorithm.
 * It clips a 2D segment by a rectangle.
 * @author Alexander Milevski <info@w8r.name>
 * @license MIT
 */
var Zu = 1e-6, Sd = 1, jP = 0;
function aa(t, e, i) {
  var o = i[0], s = i[1];
  if (Math.abs(e) < Zu)
    return t < 0;
  var u = t / e;
  if (e > 0) {
    if (u > s)
      return 0;
    u > o && (i[0] = u);
  } else {
    if (u < o)
      return 0;
    u < s && (i[1] = u);
  }
  return 1;
}
function zP(t, e, i, o, s) {
  var u = t[0], f = t[1], l = e[0], h = e[1], d = l - u, _ = h - f;
  if (o === void 0 || s === void 0 ? (o = t, s = e) : (o[0] = t[0], o[1] = t[1], s[0] = e[0], s[1] = e[1]), Math.abs(d) < Zu && Math.abs(_) < Zu && u >= i[0] && u <= i[2] && f >= i[1] && f <= i[3])
    return Sd;
  var y = [0, 1];
  if (aa(i[0] - u, d, y) && aa(u - i[2], -d, y) && aa(i[1] - f, _, y) && aa(f - i[3], -_, y)) {
    var m = y[0], T = y[1];
    return T < 1 && (s[0] = u + T * d, s[1] = f + T * _), m > 0 && (o[0] += m * d, o[1] += m * _), Sd;
  }
  return jP;
}
const wg = (t, e, i, o) => {
  const s = Math.min(t, i), u = Math.abs(t - i), f = Math.min(e, o), l = Math.abs(e - o);
  return { x: s, y: f, width: u, height: l };
}, bd = (t, e, i) => t >= e && t <= i, XP = (t, e, i, o, s, u) => bd(t, i, i + s) && bd(e, o, o + u), KP = (t, e, i, o, s, u, f, l) => {
  const h = s + f, d = u + l;
  return !!zP([t, i], [e, o], [s, u, h, d]);
}, YP = (t) => t({ x: 0, y: 0, width: 0, height: 0 }), qP = (t, e, i, o, s, u) => {
  if (YP(s), !e) {
    u(), i(!0);
    const [f, l] = Ec(t);
    o({ x: f, y: l });
  }
}, VP = (t, e, i, o) => {
  const [s, u] = Ec(t), { x: f, y: l, width: h, height: d } = wg(e.x, e.y, s, u);
  o && i({ x: f, y: l, width: h, height: d });
}, Ag = (t, e, i, o, s, u) => {
  if (!o)
    return;
  s(!1);
  const [f, l] = Ec(t), { x: h, y: d, width: _, height: y } = wg(e.x, e.y, f, l);
  i({ x: h, y: d, width: _, height: y }), u({ x: h, y: d, width: _, height: y });
}, ZP = (t, e, i, o, s, u) => {
  var h;
  const f = (h = t.relatedTarget) == null ? void 0 : h.parentElement;
  f != null && f.id.includes("event") || Ag(
    t,
    e,
    i,
    o,
    s,
    u
  );
}, Eg = ({
  x: t = 0,
  y: e = 0,
  width: i = "100%",
  height: o = "100%",
  darkMode: s = !1,
  onDragStart: u,
  onDragEnd: f,
  selectionLayerAttributes: l,
  setSelectionLayerAttributes: h,
  children: d
}) => {
  const _ = Gi(null), [y, m] = Nr({
    x: 0,
    y: 0
  }), [T, S] = Nr(!1), b = s ? "dark" : "light", M = T ? Cd : BP, I = !!u && !!f && !!h;
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      "rect",
      {
        id: "draggable-selection-layer",
        "data-testid": "draggable-selection-layer",
        ref: _,
        x: l.x,
        y: l.y,
        width: l.width,
        height: l.height,
        fill: T ? Cd[b] : "transparent",
        fillOpacity: T ? WP : 1,
        stroke: M[b],
        strokeDasharray: T ? 0 : UP,
        strokeWidth: GP
      }
    ),
    /* @__PURE__ */ w.jsx(
      "rect",
      {
        x: t,
        y: e,
        width: i,
        height: o,
        fill: "transparent",
        stroke: "transparent",
        id: "interaction-rect",
        "data-testid": "interaction-rect",
        className: ln({ "cursor-crosshair": I }),
        onMouseDown: I ? (C) => qP(
          C,
          T,
          S,
          m,
          h,
          u
        ) : void 0,
        onMouseMove: I ? (C) => VP(C, y, h, T) : void 0,
        onMouseUp: I ? (C) => Ag(
          C,
          y,
          h,
          T,
          S,
          f
        ) : void 0,
        onMouseOut: I ? (C) => ZP(
          C,
          y,
          h,
          T,
          S,
          f
        ) : void 0
      }
    ),
    /* @__PURE__ */ w.jsx("g", { pointerEvents: T ? "none" : "auto", children: d })
  ] });
}, JP = ({
  width: t = Wn.x,
  height: e = Wn.y,
  darkMode: i = !1,
  onDragStart: o = () => {
  },
  onDragEnd: s = () => {
  },
  selectionLayerAttributes: u,
  setSelectionLayerAttributes: f,
  children: l
}) => /* @__PURE__ */ w.jsx(
  Eg,
  {
    width: t,
    height: e,
    darkMode: i,
    onDragStart: o,
    onDragEnd: s,
    selectionLayerAttributes: u,
    setSelectionLayerAttributes: f,
    children: l
  }
), QP = [
  {
    id: 1,
    points: "0,0 18,0 18,18 0,18",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 2,
    points: "0,18 18,18 18,30 0,30",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 3,
    points: "0,30 6,30 6,40 0,40",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 4,
    points: "6,30 18,30 18,40 6,40",
    zoneBackgroundColour: "tertiary"
    /* TERTIARY */
  },
  {
    id: 5,
    points: "0,40 6,40 6,50 0,50",
    zoneBackgroundColour: "tertiary"
    /* TERTIARY */
  },
  {
    id: 6,
    points: "6,40 18,40 18,50 6,50",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 7,
    points: "0,50 18,50 18,62 0,62",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 8,
    points: "0,62 18,62 18,80 0,80",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 9,
    points: "18,0 40,0 40,18 18,18",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 10,
    points: "18,18 40,18 40,30 18,30",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 11,
    points: "18,30 40,30 40,40 18,40",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 12,
    points: "18,40 40,40 40,50 18,50",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 13,
    points: "18,50 40,50 40,62 18,62",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 14,
    points: "18,62 40,62 40,80 18,80",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 15,
    points: "40,0 60,0 60,18 40,18",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 16,
    points: "40,18 60,18 60,30 40,30",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 17,
    points: "40,30 60,30 60,40 40,40",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 18,
    points: "40,40 60,40 60,50 40,50",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 19,
    points: "40,50 60,50 60,62 40,62",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 20,
    points: "40,62 60,62 60,80 40,80",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 21,
    points: "60,0 80,0 80,18 60,18",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 22,
    points: "60,18 80,18 80,30 60,30",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 23,
    points: "60,30 80,30 80,40 60,40",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 24,
    points: "60,40 80,40 80,50 60,50",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 25,
    points: "60,50 80,50 80,62 60,62",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 26,
    points: "60,62 80,62 80,80 60,80",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 27,
    points: "80,0 102,0 102,18 80,18",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 28,
    points: "80,18 102,18 102,30 80,30",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 29,
    points: "80,30 102,30 102,40 80,40",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 30,
    points: "80,40 102,40 102,50 80,50",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 31,
    points: "80,50 102,50 102,62 80,62",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 32,
    points: "80,62 102,62 102,80 80,80",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 33,
    points: "102,0 120,0 120,18 102,18",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 34,
    points: "102,18 120,18 120,30 102,30",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 35,
    points: "102,30 114,30 114,40 102,40",
    zoneBackgroundColour: "tertiary"
    /* TERTIARY */
  },
  {
    id: 36,
    points: "114,30 120,30 120,40 114,40",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 37,
    points: "102,40 114,40 114,50 102,50",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  },
  {
    id: 38,
    points: "114,40 120,40 120,50 114,50",
    zoneBackgroundColour: "tertiary"
    /* TERTIARY */
  },
  {
    id: 39,
    points: "102,50 120,50 120,62 102,62",
    zoneBackgroundColour: "secondary"
    /* SECONDARY */
  },
  {
    id: 40,
    points: "102,62 120,62 120,80 102,80",
    zoneBackgroundColour: "primary"
    /* PRIMARY */
  }
], tN = [
  { id: 1, x1: 18, y1: 0, x2: 18, y2: 80 },
  { id: 2, x1: 40, y1: 0, x2: 40, y2: 80 },
  { id: 3, x1: 80, y1: 0, x2: 80, y2: 80 },
  { id: 4, x1: 102, y1: 0, x2: 102, y2: 80 },
  { id: 5, x1: 0, y1: 18, x2: 120, y2: 18 },
  { id: 6, x1: 0, y1: 30, x2: 120, y2: 30 },
  { id: 7, x1: 0, y1: 40, x2: 120, y2: 40 },
  { id: 8, x1: 0, y1: 50, x2: 120, y2: 50 },
  { id: 9, x1: 0, y1: 62, x2: 120, y2: 62 }
], nN = {
  top: [
    { key: "xFirstThirdIds", ids: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14] },
    { key: "xMiddleThirdIds", ids: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26] },
    { key: "xFinalThirdIds", ids: [27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40] }
  ],
  left: [
    { key: "yFirstHalfIds", ids: [1, 2, 3, 4, 9, 10, 11, 15, 16, 17, 21, 22, 23, 27, 28, 29, 33, 34, 35, 36] },
    { key: "yFinalHalfIds", ids: [5, 6, 7, 8, 12, 13, 14, 18, 19, 20, 24, 25, 26, 30, 31, 32, 37, 38, 39, 40] }
  ],
  right: [
    { key: "yFirstChannelIds", ids: [1, 9, 15, 21, 27, 33], style: "h-[23%]" },
    { key: "ySecondChannelIds", ids: [2, 10, 16, 22, 28, 34], style: "h-[15%]" },
    { key: "yThirdChannelIds", ids: [3, 4, 11, 17, 23, 29, 35, 36], style: "h-[12%]" },
    { key: "yFourthChannelIds", ids: [5, 6, 12, 18, 24, 30, 37, 38], style: "h-[12%]" },
    { key: "yFifthChannelIds", ids: [7, 13, 19, 25, 31, 39], style: "h-[15%]" },
    { key: "yFinalChannelIds", ids: [8, 14, 20, 26, 32, 40], style: "h-[23%]" }
  ],
  bottom: [
    { key: "xFirstHalf", ids: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] },
    { key: "xFinalHalf", ids: [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40] }
  ]
};
var eN = Array.prototype, Tg = eN.slice;
function rN(t, e) {
  return t - e;
}
function iN(t) {
  for (var e = 0, i = t.length, o = t[i - 1][1] * t[0][0] - t[i - 1][0] * t[0][1]; ++e < i; )
    o += t[e - 1][1] * t[e][0] - t[e - 1][0] * t[e][1];
  return o;
}
const ke = (t) => () => t;
function oN(t, e) {
  for (var i = -1, o = e.length, s; ++i < o; )
    if (s = aN(t, e[i]))
      return s;
  return 0;
}
function aN(t, e) {
  for (var i = e[0], o = e[1], s = -1, u = 0, f = t.length, l = f - 1; u < f; l = u++) {
    var h = t[u], d = h[0], _ = h[1], y = t[l], m = y[0], T = y[1];
    if (sN(h, y, e))
      return 0;
    _ > o != T > o && i < (m - d) * (o - _) / (T - _) + d && (s = -s);
  }
  return s;
}
function sN(t, e, i) {
  var o;
  return uN(t, e, i) && cN(t[o = +(t[0] === e[0])], i[o], e[o]);
}
function uN(t, e, i) {
  return (e[0] - t[0]) * (i[1] - t[1]) === (i[0] - t[0]) * (e[1] - t[1]);
}
function cN(t, e, i) {
  return t <= e && e <= i || i <= e && e <= t;
}
function fN() {
}
var me = [
  [],
  [[[1, 1.5], [0.5, 1]]],
  [[[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [0.5, 1]]],
  [[[1, 0.5], [1.5, 1]]],
  [[[1, 1.5], [0.5, 1]], [[1, 0.5], [1.5, 1]]],
  [[[1, 0.5], [1, 1.5]]],
  [[[1, 0.5], [0.5, 1]]],
  [[[0.5, 1], [1, 0.5]]],
  [[[1, 1.5], [1, 0.5]]],
  [[[0.5, 1], [1, 0.5]], [[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [1, 0.5]]],
  [[[0.5, 1], [1.5, 1]]],
  [[[1, 1.5], [1.5, 1]]],
  [[[0.5, 1], [1, 1.5]]],
  []
];
function Od() {
  var t = 1, e = 1, i = Mw, o = h;
  function s(d) {
    var _ = i(d);
    if (Array.isArray(_))
      _ = _.slice().sort(rN);
    else {
      const y = Tw(d, lN);
      for (_ = fc(...Lw(y[0], y[1], _), _); _[_.length - 1] >= y[1]; )
        _.pop();
      for (; _[1] < y[0]; )
        _.shift();
    }
    return _.map((y) => u(d, y));
  }
  function u(d, _) {
    const y = _ == null ? NaN : +_;
    if (isNaN(y))
      throw new Error(`invalid value: ${_}`);
    var m = [], T = [];
    return f(d, y, function(S) {
      o(S, d, y), iN(S) > 0 ? m.push([S]) : T.push(S);
    }), T.forEach(function(S) {
      for (var b = 0, M = m.length, I; b < M; ++b)
        if (oN((I = m[b])[0], S) !== -1) {
          I.push(S);
          return;
        }
    }), {
      type: "MultiPolygon",
      value: _,
      coordinates: m
    };
  }
  function f(d, _, y) {
    var m = new Array(), T = new Array(), S, b, M, I, C, H;
    for (S = b = -1, I = Je(d[0], _), me[I << 1].forEach(B); ++S < t - 1; )
      M = I, I = Je(d[S + 1], _), me[M | I << 1].forEach(B);
    for (me[I << 0].forEach(B); ++b < e - 1; ) {
      for (S = -1, I = Je(d[b * t + t], _), C = Je(d[b * t], _), me[I << 1 | C << 2].forEach(B); ++S < t - 1; )
        M = I, I = Je(d[b * t + t + S + 1], _), H = C, C = Je(d[b * t + S + 1], _), me[M | I << 1 | C << 2 | H << 3].forEach(B);
      me[I | C << 3].forEach(B);
    }
    for (S = -1, C = d[b * t] >= _, me[C << 2].forEach(B); ++S < t - 1; )
      H = C, C = Je(d[b * t + S + 1], _), me[C << 2 | H << 3].forEach(B);
    me[C << 3].forEach(B);
    function B(k) {
      var W = [k[0][0] + S, k[0][1] + b], K = [k[1][0] + S, k[1][1] + b], q = l(W), tt = l(K), X, j;
      (X = T[q]) ? (j = m[tt]) ? (delete T[X.end], delete m[j.start], X === j ? (X.ring.push(K), y(X.ring)) : m[X.start] = T[j.end] = { start: X.start, end: j.end, ring: X.ring.concat(j.ring) }) : (delete T[X.end], X.ring.push(K), T[X.end = tt] = X) : (X = m[tt]) ? (j = T[q]) ? (delete m[X.start], delete T[j.end], X === j ? (X.ring.push(K), y(X.ring)) : m[j.start] = T[X.end] = { start: j.start, end: X.end, ring: j.ring.concat(X.ring) }) : (delete m[X.start], X.ring.unshift(W), m[X.start = q] = X) : m[q] = T[tt] = { start: q, end: tt, ring: [W, K] };
    }
  }
  function l(d) {
    return d[0] * 2 + d[1] * (t + 1) * 4;
  }
  function h(d, _, y) {
    d.forEach(function(m) {
      var T = m[0], S = m[1], b = T | 0, M = S | 0, I = wu(_[M * t + b]);
      T > 0 && T < t && b === T && (m[0] = Id(T, wu(_[M * t + b - 1]), I, y)), S > 0 && S < e && M === S && (m[1] = Id(S, wu(_[(M - 1) * t + b]), I, y));
    });
  }
  return s.contour = u, s.size = function(d) {
    if (!arguments.length)
      return [t, e];
    var _ = Math.floor(d[0]), y = Math.floor(d[1]);
    if (!(_ >= 0 && y >= 0))
      throw new Error("invalid size");
    return t = _, e = y, s;
  }, s.thresholds = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : Array.isArray(d) ? ke(Tg.call(d)) : ke(d), s) : i;
  }, s.smooth = function(d) {
    return arguments.length ? (o = d ? h : fN, s) : o === h;
  }, s;
}
function lN(t) {
  return isFinite(t) ? t : NaN;
}
function Je(t, e) {
  return t == null ? !1 : +t >= e;
}
function wu(t) {
  return t == null || isNaN(t = +t) ? -1 / 0 : t;
}
function Id(t, e, i, o) {
  const s = o - e, u = i - e, f = isFinite(s) || isFinite(u) ? s / u : Math.sign(s) / Math.sign(u);
  return isNaN(f) ? t : t + f - 0.5;
}
function hN(t) {
  return t[0];
}
function dN(t) {
  return t[1];
}
function gN() {
  return 1;
}
function pN() {
  var t = hN, e = dN, i = gN, o = 960, s = 500, u = 20, f = 2, l = u * 3, h = o + l * 2 >> f, d = s + l * 2 >> f, _ = ke(20);
  function y(C) {
    var H = new Float32Array(h * d), B = Math.pow(2, -f), k = -1;
    for (const nt of C) {
      var W = (t(nt, ++k, C) + l) * B, K = (e(nt, k, C) + l) * B, q = +i(nt, k, C);
      if (q && W >= 0 && W < h && K >= 0 && K < d) {
        var tt = Math.floor(W), X = Math.floor(K), j = W - tt - 0.5, et = K - X - 0.5;
        H[tt + X * h] += (1 - j) * (1 - et) * q, H[tt + 1 + X * h] += j * (1 - et) * q, H[tt + 1 + (X + 1) * h] += j * et * q, H[tt + (X + 1) * h] += (1 - j) * et * q;
      }
    }
    return yw({ data: H, width: h, height: d }, u * B), H;
  }
  function m(C) {
    var H = y(C), B = _(H), k = Math.pow(2, 2 * f);
    return Array.isArray(B) || (B = fc(Number.MIN_VALUE, _h(H) / k, B)), Od().size([h, d]).thresholds(B.map((W) => W * k))(H).map((W, K) => (W.value = +B[K], T(W)));
  }
  m.contours = function(C) {
    var H = y(C), B = Od().size([h, d]), k = Math.pow(2, 2 * f), W = (K) => {
      K = +K;
      var q = T(B.contour(H, K * k));
      return q.value = K, q;
    };
    return Object.defineProperty(W, "max", { get: () => _h(H) / k }), W;
  };
  function T(C) {
    return C.coordinates.forEach(S), C;
  }
  function S(C) {
    C.forEach(b);
  }
  function b(C) {
    C.forEach(M);
  }
  function M(C) {
    C[0] = C[0] * Math.pow(2, f) - l, C[1] = C[1] * Math.pow(2, f) - l;
  }
  function I() {
    return l = u * 3, h = o + l * 2 >> f, d = s + l * 2 >> f, m;
  }
  return m.x = function(C) {
    return arguments.length ? (t = typeof C == "function" ? C : ke(+C), m) : t;
  }, m.y = function(C) {
    return arguments.length ? (e = typeof C == "function" ? C : ke(+C), m) : e;
  }, m.weight = function(C) {
    return arguments.length ? (i = typeof C == "function" ? C : ke(+C), m) : i;
  }, m.size = function(C) {
    if (!arguments.length)
      return [o, s];
    var H = +C[0], B = +C[1];
    if (!(H >= 0 && B >= 0))
      throw new Error("invalid size");
    return o = H, s = B, I();
  }, m.cellSize = function(C) {
    if (!arguments.length)
      return 1 << f;
    if (!((C = +C) >= 1))
      throw new Error("invalid cell size");
    return f = Math.floor(Math.log(C) / Math.LN2), I();
  }, m.thresholds = function(C) {
    return arguments.length ? (_ = typeof C == "function" ? C : Array.isArray(C) ? ke(Tg.call(C)) : ke(C), m) : _;
  }, m.bandwidth = function(C) {
    if (!arguments.length)
      return Math.sqrt(u * (u + 1));
    if (!((C = +C) >= 0))
      throw new Error("invalid bandwidth");
    return u = (Math.sqrt(4 * C * C + 1) - 1) / 2, I();
  }, m;
}
var _N = Math.PI, vN = _N * 2, mN = Math.abs, kc = Math.sqrt;
function Un() {
}
function Oa(t, e) {
  t && Md.hasOwnProperty(t.type) && Md[t.type](t, e);
}
var Ld = {
  Feature: function(t, e) {
    Oa(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var i = t.features, o = -1, s = i.length; ++o < s; )
      Oa(i[o].geometry, e);
  }
}, Md = {
  Sphere: function(t, e) {
    e.sphere();
  },
  Point: function(t, e) {
    t = t.coordinates, e.point(t[0], t[1], t[2]);
  },
  MultiPoint: function(t, e) {
    for (var i = t.coordinates, o = -1, s = i.length; ++o < s; )
      t = i[o], e.point(t[0], t[1], t[2]);
  },
  LineString: function(t, e) {
    Ju(t.coordinates, e, 0);
  },
  MultiLineString: function(t, e) {
    for (var i = t.coordinates, o = -1, s = i.length; ++o < s; )
      Ju(i[o], e, 0);
  },
  Polygon: function(t, e) {
    Pd(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var i = t.coordinates, o = -1, s = i.length; ++o < s; )
      Pd(i[o], e);
  },
  GeometryCollection: function(t, e) {
    for (var i = t.geometries, o = -1, s = i.length; ++o < s; )
      Oa(i[o], e);
  }
};
function Ju(t, e, i) {
  var o = -1, s = t.length - i, u;
  for (e.lineStart(); ++o < s; )
    u = t[o], e.point(u[0], u[1], u[2]);
  e.lineEnd();
}
function Pd(t, e) {
  var i = -1, o = t.length;
  for (e.polygonStart(); ++i < o; )
    Ju(t[i], e, 1);
  e.polygonEnd();
}
function Si(t, e) {
  t && Ld.hasOwnProperty(t.type) ? Ld[t.type](t, e) : Oa(t, e);
}
const yN = (t) => t;
var Au = new kr(), Qu = new kr(), $g, Rg, tc, nc, De = {
  point: Un,
  lineStart: Un,
  lineEnd: Un,
  polygonStart: function() {
    De.lineStart = xN, De.lineEnd = AN;
  },
  polygonEnd: function() {
    De.lineStart = De.lineEnd = De.point = Un, Au.add(mN(Qu)), Qu = new kr();
  },
  result: function() {
    var t = Au / 2;
    return Au = new kr(), t;
  }
};
function xN() {
  De.point = wN;
}
function wN(t, e) {
  De.point = Cg, $g = tc = t, Rg = nc = e;
}
function Cg(t, e) {
  Qu.add(nc * t - tc * e), tc = t, nc = e;
}
function AN() {
  Cg($g, Rg);
}
const Nd = De;
var Wr = 1 / 0, Ia = Wr, Ki = -Wr, La = Ki, EN = {
  point: TN,
  lineStart: Un,
  lineEnd: Un,
  polygonStart: Un,
  polygonEnd: Un,
  result: function() {
    var t = [[Wr, Ia], [Ki, La]];
    return Ki = La = -(Ia = Wr = 1 / 0), t;
  }
};
function TN(t, e) {
  t < Wr && (Wr = t), t > Ki && (Ki = t), e < Ia && (Ia = e), e > La && (La = e);
}
const kd = EN;
var ec = 0, rc = 0, Li = 0, Ma = 0, Pa = 0, Mr = 0, ic = 0, oc = 0, Mi = 0, Sg, bg, Jn, Qn, Hn = {
  point: ar,
  lineStart: Dd,
  lineEnd: Fd,
  polygonStart: function() {
    Hn.lineStart = CN, Hn.lineEnd = SN;
  },
  polygonEnd: function() {
    Hn.point = ar, Hn.lineStart = Dd, Hn.lineEnd = Fd;
  },
  result: function() {
    var t = Mi ? [ic / Mi, oc / Mi] : Mr ? [Ma / Mr, Pa / Mr] : Li ? [ec / Li, rc / Li] : [NaN, NaN];
    return ec = rc = Li = Ma = Pa = Mr = ic = oc = Mi = 0, t;
  }
};
function ar(t, e) {
  ec += t, rc += e, ++Li;
}
function Dd() {
  Hn.point = $N;
}
function $N(t, e) {
  Hn.point = RN, ar(Jn = t, Qn = e);
}
function RN(t, e) {
  var i = t - Jn, o = e - Qn, s = kc(i * i + o * o);
  Ma += s * (Jn + t) / 2, Pa += s * (Qn + e) / 2, Mr += s, ar(Jn = t, Qn = e);
}
function Fd() {
  Hn.point = ar;
}
function CN() {
  Hn.point = bN;
}
function SN() {
  Og(Sg, bg);
}
function bN(t, e) {
  Hn.point = Og, ar(Sg = Jn = t, bg = Qn = e);
}
function Og(t, e) {
  var i = t - Jn, o = e - Qn, s = kc(i * i + o * o);
  Ma += s * (Jn + t) / 2, Pa += s * (Qn + e) / 2, Mr += s, s = Qn * t - Jn * e, ic += s * (Jn + t), oc += s * (Qn + e), Mi += s * 3, ar(Jn = t, Qn = e);
}
const Hd = Hn;
function Ig(t) {
  this._context = t;
}
Ig.prototype = {
  _radius: 4.5,
  pointRadius: function(t) {
    return this._radius = t, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(t, e), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(t, e);
        break;
      }
      default: {
        this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, vN);
        break;
      }
    }
  },
  result: Un
};
var ac = new kr(), Eu, Lg, Mg, Pi, Ni, Na = {
  point: Un,
  lineStart: function() {
    Na.point = ON;
  },
  lineEnd: function() {
    Eu && Pg(Lg, Mg), Na.point = Un;
  },
  polygonStart: function() {
    Eu = !0;
  },
  polygonEnd: function() {
    Eu = null;
  },
  result: function() {
    var t = +ac;
    return ac = new kr(), t;
  }
};
function ON(t, e) {
  Na.point = Pg, Lg = Pi = t, Mg = Ni = e;
}
function Pg(t, e) {
  Pi -= t, Ni -= e, ac.add(kc(Pi * Pi + Ni * Ni)), Pi = t, Ni = e;
}
const Bd = Na;
let Wd, ka, Ud, Gd;
class jd {
  constructor(e) {
    this._append = e == null ? Ng : IN(e), this._radius = 4.5, this._ = "";
  }
  pointRadius(e) {
    return this._radius = +e, this;
  }
  polygonStart() {
    this._line = 0;
  }
  polygonEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    this._line === 0 && (this._ += "Z"), this._point = NaN;
  }
  point(e, i) {
    switch (this._point) {
      case 0: {
        this._append`M${e},${i}`, this._point = 1;
        break;
      }
      case 1: {
        this._append`L${e},${i}`;
        break;
      }
      default: {
        if (this._append`M${e},${i}`, this._radius !== Ud || this._append !== ka) {
          const o = this._radius, s = this._;
          this._ = "", this._append`m0,${o}a${o},${o} 0 1,1 0,${-2 * o}a${o},${o} 0 1,1 0,${2 * o}z`, Ud = o, ka = this._append, Gd = this._, this._ = s;
        }
        this._ += Gd;
        break;
      }
    }
  }
  result() {
    const e = this._;
    return this._ = "", e.length ? e : null;
  }
}
function Ng(t) {
  let e = 1;
  this._ += t[0];
  for (const i = t.length; e < i; ++e)
    this._ += arguments[e] + t[e];
}
function IN(t) {
  const e = Math.floor(t);
  if (!(e >= 0))
    throw new RangeError(`invalid digits: ${t}`);
  if (e > 15)
    return Ng;
  if (e !== Wd) {
    const i = 10 ** e;
    Wd = e, ka = function(s) {
      let u = 1;
      this._ += s[0];
      for (const f = s.length; u < f; ++u)
        this._ += Math.round(arguments[u] * i) / i + s[u];
    };
  }
  return ka;
}
function LN(t, e) {
  let i = 3, o = 4.5, s, u;
  function f(l) {
    return l && (typeof o == "function" && u.pointRadius(+o.apply(this, arguments)), Si(l, s(u))), u.result();
  }
  return f.area = function(l) {
    return Si(l, s(Nd)), Nd.result();
  }, f.measure = function(l) {
    return Si(l, s(Bd)), Bd.result();
  }, f.bounds = function(l) {
    return Si(l, s(kd)), kd.result();
  }, f.centroid = function(l) {
    return Si(l, s(Hd)), Hd.result();
  }, f.projection = function(l) {
    return arguments.length ? (s = l == null ? (t = null, yN) : (t = l).stream, f) : t;
  }, f.context = function(l) {
    return arguments.length ? (u = l == null ? (e = null, new jd(i)) : new Ig(e = l), typeof o != "function" && u.pointRadius(o), f) : e;
  }, f.pointRadius = function(l) {
    return arguments.length ? (o = typeof l == "function" ? l : (u.pointRadius(+l), +l), f) : o;
  }, f.digits = function(l) {
    if (!arguments.length)
      return i;
    if (l == null)
      i = null;
    else {
      const h = Math.floor(l);
      if (!(h >= 0))
        throw new RangeError(`invalid digits: ${l}`);
      i = h;
    }
    return e === null && (u = new jd(i)), f;
  }, f.projection(t).digits(i).context(e);
}
const MN = {
  low: 20,
  medium: 30,
  high: 40
}, PN = "-heatmap-clip-path", kg = ({ gradientColours: t, customDomain: e }) => {
  if (t.length === 0)
    return () => "#999";
  if (t.length === 1)
    return () => t[0];
  const i = [...Array(t.length).keys()].map((u) => u / (t.length - 1)), o = (e == null ? void 0 : e.length) === t.length ? e : i;
  return xe(o, t).clamp(!0);
}, Ya = (t, e) => {
  const o = Dt().colours.visualisations.dataGradients[t], s = kg({ gradientColours: o, customDomain: e });
  return { gradientColours: o, gradientScale: s };
}, Dg = ({
  data: t,
  width: e,
  height: i,
  scaleFactor: o,
  smoothing: s = "medium",
  visibleWidth: u,
  posX: f = 0
}) => {
  const l = Qx(), { gradientScale: h } = Ya("heatmap"), d = `${l}${PN}`, _ = e * o, y = i * o, m = t.map(({ x: I, y: C }) => [I, C]), T = xe([0, e], [0, _]), S = xe([0, i], [0, y]), b = pN().x((I) => T(I[0])).y((I) => S(I[1])).size([_, y]).bandwidth(MN[s])(m), M = Math.max(...b.map(({ value: I }) => I));
  return /* @__PURE__ */ w.jsxs("g", { id: "heatmapZone", transform: `scale(${1 / o})`, clipPath: `url(#${d})`, children: [
    /* @__PURE__ */ w.jsx("clipPath", { id: d, children: /* @__PURE__ */ w.jsx("rect", { width: u || _, height: y, x: f }) }),
    b.map((I, C) => /* @__PURE__ */ w.jsx(
      "path",
      {
        "data-testid": `density-${C + 1}`,
        d: LN()(I) || void 0,
        fill: String(h(I.value / M))
      },
      I.value
    ))
  ] });
}, Ir = { height: 100, width: 100, radius: 50 }, NN = ({ numberOfSpokes: t, spokeIndex: e }) => {
  const i = vc / t, o = i * e, s = i * (e + 1), u = Ph(o), f = Ph(s), l = Vi(t), h = -(qi(l) / 2), d = yc(u, f, Ir.radius);
  return /* @__PURE__ */ w.jsx(
    "svg",
    {
      id: `radar-spoke-${e}`,
      "data-testid": `radar-spoke-${e}`,
      width: "100%",
      viewBox: `0 0 ${Ir.height} ${Ir.width}`,
      children: /* @__PURE__ */ w.jsxs(
        "g",
        {
          id: `spoke-${e}`,
          "data-testid": `spoke-${e}`,
          transform: `translate(${Ir.height / 2},${Ir.width / 2})`,
          children: [
            /* @__PURE__ */ w.jsx("circle", { id: "spoke-circle", "data-testid": "spoke-circle", r: Ir.radius, className: "fill-primary-main" }),
            /* @__PURE__ */ w.jsx(
              "g",
              {
                id: `spoke-slice-${e}`,
                "data-testid": `spoke-slice-${e}`,
                transform: `rotate(${h})`,
                children: /* @__PURE__ */ w.jsx("path", { d, className: "fill-radar-primary" })
              }
            )
          ]
        }
      )
    }
  );
}, kN = ({ shapes: t, shapeRendering: e = "geometricPrecision" }) => {
  const i = Dt(), o = Bn({ tokens: i, findKey: "colours.interface.main" });
  return t.map(({ id: s, points: u, fill: f }) => /* @__PURE__ */ w.jsx(
    "polygon",
    {
      "data-testid": `custom-shape-${s}`,
      points: u,
      fill: f || o,
      shapeRendering: e
    },
    s
  ));
}, DN = ({ jumpToLast: t, jumpToFirst: e, children: i }) => {
  const o = Gi(null), s = Gi(null), u = "outline-none pointer-events-none absolute opacity-0 focus-visible:opacity-100";
  return /* @__PURE__ */ w.jsxs("div", { className: "w-full h-full relative", children: [
    /* @__PURE__ */ w.jsx(
      "button",
      {
        "data-testid": "jump-to-end",
        className: ln(u, "top-0 left-0"),
        type: "button",
        onKeyUp: (f) => {
          s.current && f.key === "Enter" && s.current.focus();
        },
        ref: o,
        children: t
      }
    ),
    i,
    /* @__PURE__ */ w.jsx(
      "button",
      {
        "data-testid": "jump-to-start",
        className: ln(u, "bottom-0 right-0"),
        type: "button",
        onKeyUp: (f) => {
          o.current && f.key === "Enter" && o.current.focus();
        },
        ref: s,
        children: e
      }
    )
  ] });
}, sa = ({ onBumperClick: t, group: e, axis: i }) => {
  const o = !!t;
  return e.map(({ key: s, ids: u, style: f }) => {
    const l = i === "x" ? "w-full" : "h-full";
    return /* @__PURE__ */ w.jsx(
      "button",
      {
        "data-testid": s,
        type: "button",
        className: ln(
          "bg-primary-main rounded-sm invisible sm:visible",
          i === "x" ? "h-2" : "w-2",
          f || l,
          { "hover:bg-primary-strong": o }
        ),
        onClick: o ? (h) => t(h, { ids: u }) : void 0,
        disabled: !o
      },
      s
    );
  });
}, FN = ({ onBumperClick: t, gridZoneGroups: e, children: i }) => {
  const { top: o, left: s, right: u, bottom: f } = e;
  return /* @__PURE__ */ w.jsxs("div", { className: "grid grid-rows-[12px_auto_12px] grid-cols-[12px_auto_12px]", children: [
    /* @__PURE__ */ w.jsx("div", { className: "col-start-2 flex w-full gap-2", children: /* @__PURE__ */ w.jsx(sa, { onBumperClick: t, group: o, axis: "x" }) }),
    /* @__PURE__ */ w.jsx("div", { className: "row-start-2 flex flex-col h-full gap-2", children: /* @__PURE__ */ w.jsx(sa, { onBumperClick: t, group: s, axis: "y" }) }),
    /* @__PURE__ */ w.jsx("div", { className: "row-start-2 col-start-3 flex flex-col h-full gap-2 items-end", children: /* @__PURE__ */ w.jsx(sa, { onBumperClick: t, group: u, axis: "y" }) }),
    /* @__PURE__ */ w.jsx("div", { className: "col-start-2 flex w-full gap-2 items-end", children: /* @__PURE__ */ w.jsx(sa, { onBumperClick: t, group: f, axis: "x" }) }),
    /* @__PURE__ */ w.jsx("div", { className: "col-start-2 row-start-2", children: i })
  ] });
}, HN = ({ data: t, width: e, height: i, scaleFactor: o, smoothing: s = "medium" }) => /* @__PURE__ */ w.jsx(Dg, { data: t, width: e, height: i, scaleFactor: o, smoothing: s }), zd = {
  REGULAR: 1.5,
  LARGE: 3.5
}, Tu = {
  REGULAR: "3.25px",
  LARGE: "4.25px"
}, Xd = 5.7125, Kd = 0.75, BN = () => {
  const e = Dt().colours.visualisations;
  return (o, s) => s ? e.dataObjects.neutral.main : o ? e.dataObjects.default.n2.ink : e.text.visualisation.label;
}, WN = ({ playerPositions: t, onPositionClick: e }) => {
  const i = Dt(), o = i.colours.visualisations.dataObjects.neutral.main, s = BN(), u = t.some((l) => l.value), f = !!e && !u;
  return /* @__PURE__ */ w.jsx("g", { children: t.map(({ key: l, label: h, colour: d, cx: _, cy: y, isSelected: m, isMuted: T, value: S }) => {
    const b = T ? o : d, M = s(m, T);
    return /* @__PURE__ */ w.jsxs(
      "g",
      {
        "data-testid": `position-${l}`,
        className: ln(
          { "cursor-pointer": f },
          "outline-none",
          "focus-visible:-outline-offset-[0.25px]",
          "focus-visible:outline-1",
          "focus-visible:outline-black",
          "dark:focus-visible:outline-white"
        ),
        onClick: f ? () => e(l) : void 0,
        onKeyUp: f ? (I) => {
          I.key === "Enter" && e(l);
        } : void 0,
        tabIndex: f ? 0 : void 0,
        children: [
          /* @__PURE__ */ w.jsx(
            "circle",
            {
              cx: _,
              cy: y,
              r: Xd,
              fill: i.colours.visualisations.base.background,
              stroke: b,
              strokeWidth: Kd
            }
          ),
          /* @__PURE__ */ w.jsx(
            "circle",
            {
              cx: _,
              cy: y,
              r: Xd,
              className: ln(m ? "opacity-100" : "opacity-0", {
                "hover:opacity-40": f && !m
              }),
              fill: b,
              stroke: b,
              strokeWidth: Kd
            }
          ),
          S && /* @__PURE__ */ w.jsx(
            "text",
            {
              x: _,
              y,
              fill: M,
              fontSize: Tu.LARGE,
              className: "font-semibold text-anchor-middle leading-none tracking-tight pointer-events-none",
              children: S
            }
          ),
          /* @__PURE__ */ w.jsx(
            "text",
            {
              x: _,
              y: y + (u ? zd.LARGE : zd.REGULAR),
              fill: M,
              fontSize: u ? Tu.REGULAR : Tu.LARGE,
              className: "font-semibold text-anchor-middle leading-none tracking-tight pointer-events-none",
              children: h
            }
          )
        ]
      },
      l
    );
  }) });
}, Yd = 12, sc = 6, Hi = 5, UN = {
  viewBox: `0 0 ${2 * sc} ${2 * Hi}`,
  refX: sc,
  refY: Hi,
  markerWidth: Yd,
  markerHeight: Yd,
  orient: "auto"
}, GN = (t, e) => `M ${t} ${e}`, qd = (t, e) => `${t} ${e}`, jN = (...t) => t.join(" "), zN = ({ colour: t = "", classes: e = [] }) => /* @__PURE__ */ w.jsx(
  "path",
  {
    "data-testid": "chevron",
    d: jN(GN(2, Hi - 4), qd(sc, Hi), qd(2, Hi + 4)),
    className: ln(...e, "fill-none"),
    stroke: t,
    strokeLinecap: "round"
  }
), kn = {
  FONT: { SIZE: 12, WEIGHT: 400, LINE_HEIGHT: 18, BASELINE: 0.73 },
  VIS_WIDTH: 200,
  SHAFT: 50
}, XN = ({
  rotationName: t = "HORIZONTAL",
  text: e = "Attacking Direction"
}) => {
  const i = t === nn.HORIZONTAL_REVERSE.key, o = i ? kn.SHAFT : kn.VIS_WIDTH - kn.SHAFT, s = i ? 0 : kn.VIS_WIDTH, u = kn.FONT.LINE_HEIGHT, f = fh(() => ({ width: kn.VIS_WIDTH, height: kn.FONT.LINE_HEIGHT }), []), l = i ? nn.HORIZONTAL.key : t, h = Br(t) ? u : kn.VIS_WIDTH, d = Br(t) ? kn.VIS_WIDTH : u, _ = fh(() => ({ width: h, height: d }), [h, d]), y = "arrow-end-direction-of-play", m = Dt(), T = Bn({
    tokens: m,
    findKey: "colours.visualisations.text.legend.primary"
  });
  return /* @__PURE__ */ w.jsxs("svg", { viewBox: `0 0 ${h} ${d}`, width: `${h}px`, children: [
    /* @__PURE__ */ w.jsx("defs", { children: /* @__PURE__ */ w.jsx("marker", { id: y, ...UN, children: /* @__PURE__ */ w.jsx(zN, { colour: T }) }) }),
    /* @__PURE__ */ w.jsxs(q0, { rotationName: l, window: _, displayedObject: f, children: [
      /* @__PURE__ */ w.jsx(
        "line",
        {
          x1: o,
          y1: u / 2,
          x2: s,
          y2: u / 2,
          strokeWidth: 1,
          markerEnd: `url(#${y})`,
          "data-testid": "direction-of-play-arrow",
          stroke: T
        }
      ),
      /* @__PURE__ */ w.jsx(
        Gn,
        {
          variant: "bodyMedium",
          as: "text",
          x: o,
          y: kn.FONT.LINE_HEIGHT * kn.FONT.BASELINE,
          textAnchor: i ? "start" : "end",
          "data-testid": "direction-of-play-text",
          fill: T,
          children: e
        }
      )
    ] })
  ] });
}, KN = ({
  legendRef: t,
  children: e
}) => /* @__PURE__ */ w.jsx("figcaption", { ref: t, className: "w-full gap-y-4", children: e }), YN = (t) => t.isDark ? "dark" : "light", Vd = (t) => Number(t.replace("rem", "")) * ow, Fg = ({ fontWeight: t, fontSize: e, lineHeight: i }) => ({
  fontWeight: t,
  fontSize: Vd(e),
  lineHeight: Vd(i)
}), Fe = 250, Bi = 18, qN = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100], Hg = [
  0,
  5,
  10,
  15,
  20,
  25,
  30,
  35,
  40,
  45,
  50,
  55,
  60,
  65,
  70,
  75,
  80,
  85,
  90,
  95,
  100
], Mt = {
  RADIUS: 16,
  MARGIN: 6,
  STROKE_WIDTH: 2,
  RADIUS_CX: 9,
  RADIUS_CY: 9
}, $u = {
  END_X: 41
}, VN = (t) => Math.floor(t / Fe) * Fe, Bg = (t, e) => {
  const i = VN(t), o = Fe * e;
  return i >= o ? o : i;
}, qa = ({ title: t, children: e }) => /* @__PURE__ */ w.jsxs("div", { className: "flex flex-col", children: [
  /* @__PURE__ */ w.jsx(Gn, { variant: "headingSmall", children: t }),
  e
] }), ZN = ({
  minText: t,
  maxText: e,
  title: i,
  colSpan: o = 1,
  gradientName: s = "heatmap",
  legendWidth: u
}) => {
  const f = Dt(), l = `gradient-${YN(f)}-${s}`, { gradientColours: h } = Ya(s), d = Bg(u, o);
  return /* @__PURE__ */ w.jsx(qa, { title: i, children: /* @__PURE__ */ w.jsxs("div", { style: { maxWidth: d }, className: "flex flex-col", children: [
    /* @__PURE__ */ w.jsxs("svg", { height: Bi, children: [
      /* @__PURE__ */ w.jsx("defs", { children: /* @__PURE__ */ w.jsx("linearGradient", { id: l, x1: "0%", x2: "100%", y1: "0%", y2: "0%", children: Hg.map((_, y) => /* @__PURE__ */ w.jsx("stop", { offset: `${_}%`, stopColor: h[y], stopOpacity: 1 }, y)) }) }),
      /* @__PURE__ */ w.jsx("rect", { height: Bi, width: "100%", fill: `url(#${l})` })
    ] }),
    /* @__PURE__ */ w.jsxs("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ w.jsx(Gn, { as: "span", variant: "bodyMedium", children: t }),
      /* @__PURE__ */ w.jsx(Gn, { as: "span", variant: "bodyMedium", children: e })
    ] })
  ] }) });
}, JN = ({
  labelValues: t,
  title: e,
  colSpan: i = 1,
  gradientName: o = "valued",
  legendWidth: s
}) => {
  const u = Dt(), { gradientColours: f } = Ya(o), { fontSize: l, lineHeight: h } = Fg(u.typography.bodyMedium), d = Bg(s, i), _ = i > 1 && d !== Fe, y = _ ? Hg : qN, m = xe().domain([0, y.length - 1]).range([Mt.RADIUS_CX, d - Mt.RADIUS_CX]), T = 100 / (t.length - 1), S = (M) => {
    const I = _ ? M : M * 2;
    return f[I];
  }, b = (M) => {
    if (M === 0)
      return {
        textAnchor: "start",
        textX: 0
      };
    if (M === t.length - 1)
      return {
        textAnchor: "end",
        textX: d
      };
    const I = _ ? M * 2 : M;
    return {
      textAnchor: "middle",
      textX: m(I * T / 10)
    };
  };
  return /* @__PURE__ */ w.jsx(qa, { title: e, children: /* @__PURE__ */ w.jsxs("svg", { style: { maxWidth: d }, height: Bi * 2, width: "100%", children: [
    /* @__PURE__ */ w.jsx("g", { height: Bi, children: y.map((M, I) => {
      const C = S(I);
      return /* @__PURE__ */ w.jsx(
        "circle",
        {
          cx: m(I),
          cy: Mt.RADIUS_CY,
          r: Mt.RADIUS / 2,
          fill: C,
          stroke: C,
          strokeWidth: Mt.STROKE_WIDTH
        },
        M
      );
    }) }),
    /* @__PURE__ */ w.jsx("g", { transform: `translate(0, ${Bi})`, children: t.map((M, I) => {
      const { textAnchor: C, textX: H } = b(I), B = aw(h, l);
      return /* @__PURE__ */ w.jsx(
        Gn,
        {
          fill: u.colours.ink.primary.main,
          as: "text",
          variant: "bodyMedium",
          textAnchor: C,
          x: H,
          y: B,
          children: M
        },
        M
      );
    }) })
  ] }) });
}, QN = ["BLOCK_CHEVRON", "BOOMERANG", "HEART_SPADE"], Wg = ({ title: t, markers: e }) => {
  const i = Mt.RADIUS + Mt.MARGIN, o = Mt.RADIUS / 2, s = Mt.STROKE_WIDTH / 2, u = (f) => {
    if (f)
      return QN.includes(f) ? y0 : 0;
  };
  return /* @__PURE__ */ w.jsx(qa, { title: t, children: /* @__PURE__ */ w.jsx("div", { className: "flex flex-wrap", children: e.map(({ shape: f, colour: l, label: h }) => /* @__PURE__ */ w.jsxs("div", { className: "flex", style: { width: Fe }, children: [
    /* @__PURE__ */ w.jsx("svg", { height: i, width: i, style: { overflow: "visible" }, children: /* @__PURE__ */ w.jsx(
      Fi,
      {
        shapeName: f || "CIRCLE",
        radius: o,
        x: o + s,
        y: o + Mt.STROKE_WIDTH,
        strokeWidth: Mt.STROKE_WIDTH,
        stroke: l,
        fill: l,
        rotation: u(f)
      }
    ) }),
    /* @__PURE__ */ w.jsx(
      Gn,
      {
        as: "span",
        variant: "bodyMedium",
        className: "truncate",
        style: { maxWidth: Fe - i },
        title: h,
        children: h
      },
      h
    )
  ] }, h)) }) });
}, tk = ({ title: t, markers: e }) => {
  const o = Dt().colours.visualisations.dataObjects.neutral.main;
  return /* @__PURE__ */ w.jsx(
    Wg,
    {
      title: t,
      markers: e.map((s) => ({
        ...s,
        colour: o
      }))
    }
  );
}, nk = ({
  title: t,
  arrowMarkers: e
}) => {
  const i = Mt.RADIUS + Mt.MARGIN;
  return /* @__PURE__ */ w.jsx(qa, { title: t, children: /* @__PURE__ */ w.jsx("div", { className: "flex flex-wrap", children: e.map(({ arrowHead: o, strokeColour: s, fillColour: u, label: f, strokeDashArray: l }) => /* @__PURE__ */ w.jsxs("div", { className: "flex", style: { width: Fe }, children: [
    /* @__PURE__ */ w.jsx("svg", { height: i, width: $u.END_X + Mt.STROKE_WIDTH * 2, children: o ? /* @__PURE__ */ w.jsx(
      Vu,
      {
        arrowHeadName: o,
        arrowHeadRadius: Mt.RADIUS / 2,
        startX: 0,
        endX: $u.END_X,
        startY: Mt.RADIUS_CY,
        endY: Mt.RADIUS_CY,
        strokeWidth: Mt.STROKE_WIDTH,
        stroke: s,
        strokeDasharray: l,
        arrowHeadFill: u || s
      }
    ) : /* @__PURE__ */ w.jsx(
      "line",
      {
        x1: 0,
        x2: $u.END_X,
        y1: Mt.RADIUS_CY,
        y2: Mt.RADIUS_CY,
        stroke: s,
        strokeWidth: Mt.STROKE_WIDTH,
        strokeDasharray: l,
        children: f
      }
    ) }),
    /* @__PURE__ */ w.jsx(
      Gn,
      {
        as: "span",
        variant: "bodyMedium",
        className: "truncate",
        style: { maxWidth: Fe - i },
        title: f,
        children: f
      },
      f
    )
  ] }, f)) }) });
}, ek = () => {
  const e = Dt().colours.visualisations.dataGradients.thermometer;
  return kg({ gradientColours: e, customDomain: [
    0,
    0.0125,
    0.025,
    0.0375,
    0.05,
    0.0625,
    0.075,
    0.0825,
    0.1,
    0.125,
    0.15,
    0.175,
    0.2,
    0.275,
    0.35,
    0.425,
    0.5,
    0.675,
    0.75,
    0.825,
    1
  ] });
}, rk = 500, ik = 500, Ur = 16, uc = Ur * 2, Zd = 7, Ug = 18, Yt = {
  LENGTH: 4,
  STROKE_WIDTH: 1
}, Wi = {
  CATEGORICAL: 18,
  NUMERICAL: 14
}, Ru = {
  CATEGORICAL: Yt.LENGTH + Wi.CATEGORICAL,
  NUMERICAL_WITH_LABEL: Yt.LENGTH + Wi.NUMERICAL + Ug,
  NUMERICAL_WITHOUT_LABEL: Yt.LENGTH + Wi.NUMERICAL
}, ok = 116, Jd = 32, Cu = {
  CATEGORICAL: ok + Yt.LENGTH,
  NUMERICAL_WITH_LABEL: Ug + Yt.LENGTH + Jd,
  NUMERICAL_WITHOUT_LABEL: Yt.LENGTH + Jd
}, ak = (t, e, i, { value: o, endValue: s, category: u, colour: f }) => {
  const l = e(o);
  return {
    x: t(u),
    y: s ? e(s) : l,
    height: s ? l - e(s) : i - l,
    fill: f,
    width: t.bandwidth()
  };
}, sk = (t, e, { value: i, endValue: o, category: s, colour: u }) => {
  const f = t(i);
  return {
    x: o ? f : 0,
    y: e(s),
    width: o ? t(o) - f : f,
    height: e.bandwidth(),
    fill: u
  };
}, uk = (t, e, i, o, s) => s ? ak(t, e, o, i) : sk(t, e, i), ck = (t, e, i, o) => i ? i * t : (o || rk) - uc - e, Gg = (t, e, i) => {
  const o = Dt(), s = Fg(o.typography.bodyMedium), u = o.colours.visualisations.base.chartLines.axis, f = {
    stroke: u,
    strokeWidth: Yt.STROKE_WIDTH
  }, l = i != null && i.format && i.format !== "text" ? {
    fontVariantNumeric: "tabular-nums",
    letterSpacing: "-0.05em"
  } : {};
  return {
    tickSizeInner: Yt.LENGTH - Yt.STROKE_WIDTH,
    tickSizeOuter: 0,
    tickLineProps: {
      ...f,
      /* this is either the x2 property or y2 property
      depending on the axis paramter passed in.
      x = x2
      y = y2 */
      [`${t}2`]: e ? Yt.LENGTH : -Yt.LENGTH
    },
    tickTextProps: {
      fontSize: s.fontSize,
      fontWeight: s.fontWeight,
      style: {
        ...l,
        lineHeight: s.lineHeight
      },
      fontFamily: o.font.family,
      fill: u,
      [t]: e ? Yt.LENGTH + Yt.STROKE_WIDTH * 2 : -Yt.LENGTH - Yt.STROKE_WIDTH
    },
    domainPathProps: f
  };
};
var Dc = /* @__PURE__ */ ((t) => (t.X = "x", t.Y = "y", t))(Dc || {});
function Ui() {
  return Ui = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
    }
    return t;
  }, Ui.apply(this, arguments);
}
function fk(t) {
  return t;
}
var Kt;
(function(t) {
  t[t.top = 1] = "top", t[t.right = 2] = "right", t[t.bottom = 3] = "bottom", t[t.left = 4] = "left";
})(Kt || (Kt = {}));
function lk(t) {
  return "translate(" + t + ",0)";
}
function hk(t) {
  return "translate(0," + t + ")";
}
var jg = function(e) {
  var i, o, s = e.scale, u = e.ticks, f = e.tickArguments, l = f === void 0 ? [] : f, h = e.tickValues, d = h === void 0 ? null : h, _ = e.tickFormat, y = _ === void 0 ? null : _, m = e.tickSize, T = e.tickSizeInner, S = T === void 0 ? 6 : T, b = e.tickSizeOuter, M = b === void 0 ? 6 : b, I = e.tickPadding, C = I === void 0 ? 3 : I, H = e.tickTextProps, B = H === void 0 ? {} : H, k = e.tickLineProps, W = k === void 0 ? {} : k, K = e.domainPathProps, q = K === void 0 ? {} : K, tt = e.orient, X = tt === void 0 ? Kt.bottom : tt, j = e.offset, et = j === void 0 ? typeof window < "u" && window.devicePixelRatio > 1 ? 0 : 0.5 : j;
  m && (S = m, M = m), u && (l = u);
  function nt(kt) {
    return function(Ft) {
      var bn = kt(Ft);
      return bn === void 0 ? 0 : +bn;
    };
  }
  function yt(kt, Ft) {
    return kt.bandwidth && (Ft = Math.max(0, kt.bandwidth() - Ft * 2) / 2), kt.round() && (Ft = Math.round(Ft)), function(bn) {
      var ie = kt(bn);
      return ie === void 0 ? 0 : ie + Ft;
    };
  }
  var Tt = X === Kt.top || X === Kt.left ? -1 : 1, Pt = X === Kt.left || X === Kt.right ? "x" : "y", gt = X === Kt.top || X === Kt.bottom ? lk : hk, St = d ?? (s.ticks ? s.ticks.apply(s, l) : s.domain()), Nt = y ?? ("tickFormat" in s ? s.tickFormat.apply(s, l) : fk), Wt = Math.max(S, 0) + C, Gt = s.range(), ee = +Gt[0] + et, re = +Gt[Gt.length - 1] + et, qr = (s.bandwidth ? yt : nt)(s.copy(), et), zn = X === Kt.left || X === Kt.right ? M ? "M" + Tt * M + "," + ee + "H" + et + "V" + re + "H" + Tt * M : "M" + et + "," + ee + "V" + re : M ? "M" + ee + "," + Tt * M + "V" + et + "H" + re + "V" + Tt * M : "M" + ee + "," + et + "H" + re, Xn = (i = {}, i[Pt + "2"] = Tt * S, i), He = (o = {}, o[Pt] = Tt * Wt, o);
  return /* @__PURE__ */ nr.createElement("g", null, St.map(function(kt, Ft) {
    return /* @__PURE__ */ nr.createElement("g", {
      className: "tick",
      key: Ft,
      transform: gt(qr(kt) + et)
    }, W && /* @__PURE__ */ nr.createElement("line", Ui({
      stroke: "currentColor"
    }, Xn, W)), B && /* @__PURE__ */ nr.createElement("text", Ui({
      fill: "currentColor",
      dy: X === Kt.top ? "0em" : X === Kt.bottom ? "0.71em" : "0.32em",
      fontSize: "10",
      fontFamily: "sans-serif",
      textAnchor: X === Kt.right ? "start" : X === Kt.left ? "end" : "middle"
    }, He, B), Nt(kt)));
  }), q && /* @__PURE__ */ nr.createElement("path", Ui({
    className: "domain",
    stroke: "currentColor",
    fill: "transparent",
    d: zn
  }, q)));
}, Da = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Da.exports;
(function(t, e) {
  (function() {
    var i, o = "4.17.21", s = 200, u = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", f = "Expected a function", l = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", d = 500, _ = "__lodash_placeholder__", y = 1, m = 2, T = 4, S = 1, b = 2, M = 1, I = 2, C = 4, H = 8, B = 16, k = 32, W = 64, K = 128, q = 256, tt = 512, X = 30, j = "...", et = 800, nt = 16, yt = 1, Tt = 2, Pt = 3, gt = 1 / 0, St = 9007199254740991, Nt = 17976931348623157e292, Wt = 0 / 0, Gt = 4294967295, ee = Gt - 1, re = Gt >>> 1, qr = [
      ["ary", K],
      ["bind", M],
      ["bindKey", I],
      ["curry", H],
      ["curryRight", B],
      ["flip", tt],
      ["partial", k],
      ["partialRight", W],
      ["rearg", q]
    ], zn = "[object Arguments]", Xn = "[object Array]", He = "[object AsyncFunction]", kt = "[object Boolean]", Ft = "[object Date]", bn = "[object DOMException]", ie = "[object Error]", Be = "[object Function]", no = "[object GeneratorFunction]", hn = "[object Map]", Kn = "[object Number]", sr = "[object Null]", xn = "[object Object]", Vr = "[object Promise]", ur = "[object Proxy]", We = "[object RegExp]", dn = "[object Set]", oe = "[object String]", cr = "[object Symbol]", Va = "[object Undefined]", Te = "[object WeakMap]", eo = "[object WeakSet]", On = "[object ArrayBuffer]", $e = "[object DataView]", fr = "[object Float32Array]", lr = "[object Float64Array]", Ue = "[object Int8Array]", Zr = "[object Int16Array]", Jr = "[object Int32Array]", Qr = "[object Uint8Array]", ti = "[object Uint8ClampedArray]", ni = "[object Uint16Array]", ei = "[object Uint32Array]", Za = /\b__p \+= '';/g, ri = /\b(__p \+=) '' \+/g, ro = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ae = /&(?:amp|lt|gt|quot|#39);/g, hr = /[&<>"']/g, ii = RegExp(ae.source), io = RegExp(hr.source), Ja = /<%-([\s\S]+?)%>/g, oo = /<%([\s\S]+?)%>/g, ao = /<%=([\s\S]+?)%>/g, so = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, uo = /^\w*$/, Qa = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, oi = /[\\^$.*+?()[\]{}|]/g, co = RegExp(oi.source), ai = /^\s+/, ts = /\s/, ns = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, es = /\{\n\/\* \[wrapped with (.+)\] \*/, A = /,? & /, F = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, U = /[()=,{}\[\]\/\s]/, Q = /\\(\\)?/g, dt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, _t = /\w*$/, ft = /^[-+]0x[0-9a-f]+$/i, ut = /^0b[01]+$/i, jt = /^\[object .+?Constructor\]$/, Rt = /^0o[0-7]+$/i, bt = /^(?:0|[1-9]\d*)$/, rn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, In = /($^)/, fo = /['\n\r\u2028\u2029\\]/g, on = "\\ud800-\\udfff", Xg = "\\u0300-\\u036f", Kg = "\\ufe20-\\ufe2f", Yg = "\\u20d0-\\u20ff", Fc = Xg + Kg + Yg, Hc = "\\u2700-\\u27bf", Bc = "a-z\\xdf-\\xf6\\xf8-\\xff", qg = "\\xac\\xb1\\xd7\\xf7", Vg = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Zg = "\\u2000-\\u206f", Jg = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Wc = "A-Z\\xc0-\\xd6\\xd8-\\xde", Uc = "\\ufe0e\\ufe0f", Gc = qg + Vg + Zg + Jg, rs = "['’]", Qg = "[" + on + "]", jc = "[" + Gc + "]", lo = "[" + Fc + "]", zc = "\\d+", tp = "[" + Hc + "]", Xc = "[" + Bc + "]", Kc = "[^" + on + Gc + zc + Hc + Bc + Wc + "]", is = "\\ud83c[\\udffb-\\udfff]", np = "(?:" + lo + "|" + is + ")", Yc = "[^" + on + "]", os = "(?:\\ud83c[\\udde6-\\uddff]){2}", as = "[\\ud800-\\udbff][\\udc00-\\udfff]", dr = "[" + Wc + "]", qc = "\\u200d", Vc = "(?:" + Xc + "|" + Kc + ")", ep = "(?:" + dr + "|" + Kc + ")", Zc = "(?:" + rs + "(?:d|ll|m|re|s|t|ve))?", Jc = "(?:" + rs + "(?:D|LL|M|RE|S|T|VE))?", Qc = np + "?", tf = "[" + Uc + "]?", rp = "(?:" + qc + "(?:" + [Yc, os, as].join("|") + ")" + tf + Qc + ")*", ip = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", op = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", nf = tf + Qc + rp, ap = "(?:" + [tp, os, as].join("|") + ")" + nf, sp = "(?:" + [Yc + lo + "?", lo, os, as, Qg].join("|") + ")", up = RegExp(rs, "g"), cp = RegExp(lo, "g"), ss = RegExp(is + "(?=" + is + ")|" + sp + nf, "g"), fp = RegExp([
      dr + "?" + Xc + "+" + Zc + "(?=" + [jc, dr, "$"].join("|") + ")",
      ep + "+" + Jc + "(?=" + [jc, dr + Vc, "$"].join("|") + ")",
      dr + "?" + Vc + "+" + Zc,
      dr + "+" + Jc,
      op,
      ip,
      zc,
      ap
    ].join("|"), "g"), lp = RegExp("[" + qc + on + Fc + Uc + "]"), hp = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, dp = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], gp = -1, At = {};
    At[fr] = At[lr] = At[Ue] = At[Zr] = At[Jr] = At[Qr] = At[ti] = At[ni] = At[ei] = !0, At[zn] = At[Xn] = At[On] = At[kt] = At[$e] = At[Ft] = At[ie] = At[Be] = At[hn] = At[Kn] = At[xn] = At[We] = At[dn] = At[oe] = At[Te] = !1;
    var wt = {};
    wt[zn] = wt[Xn] = wt[On] = wt[$e] = wt[kt] = wt[Ft] = wt[fr] = wt[lr] = wt[Ue] = wt[Zr] = wt[Jr] = wt[hn] = wt[Kn] = wt[xn] = wt[We] = wt[dn] = wt[oe] = wt[cr] = wt[Qr] = wt[ti] = wt[ni] = wt[ei] = !0, wt[ie] = wt[Be] = wt[Te] = !1;
    var pp = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, _p = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, vp = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, mp = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, yp = parseFloat, xp = parseInt, ef = typeof ye == "object" && ye && ye.Object === Object && ye, wp = typeof self == "object" && self && self.Object === Object && self, zt = ef || wp || Function("return this")(), us = e && !e.nodeType && e, Ge = us && !0 && t && !t.nodeType && t, rf = Ge && Ge.exports === us, cs = rf && ef.process, wn = function() {
      try {
        var $ = Ge && Ge.require && Ge.require("util").types;
        return $ || cs && cs.binding && cs.binding("util");
      } catch {
      }
    }(), of = wn && wn.isArrayBuffer, af = wn && wn.isDate, sf = wn && wn.isMap, uf = wn && wn.isRegExp, cf = wn && wn.isSet, ff = wn && wn.isTypedArray;
    function gn($, L, O) {
      switch (O.length) {
        case 0:
          return $.call(L);
        case 1:
          return $.call(L, O[0]);
        case 2:
          return $.call(L, O[0], O[1]);
        case 3:
          return $.call(L, O[0], O[1], O[2]);
      }
      return $.apply(L, O);
    }
    function Ap($, L, O, z) {
      for (var rt = -1, pt = $ == null ? 0 : $.length; ++rt < pt; ) {
        var Ht = $[rt];
        L(z, Ht, O(Ht), $);
      }
      return z;
    }
    function An($, L) {
      for (var O = -1, z = $ == null ? 0 : $.length; ++O < z && L($[O], O, $) !== !1; )
        ;
      return $;
    }
    function Ep($, L) {
      for (var O = $ == null ? 0 : $.length; O-- && L($[O], O, $) !== !1; )
        ;
      return $;
    }
    function lf($, L) {
      for (var O = -1, z = $ == null ? 0 : $.length; ++O < z; )
        if (!L($[O], O, $))
          return !1;
      return !0;
    }
    function Re($, L) {
      for (var O = -1, z = $ == null ? 0 : $.length, rt = 0, pt = []; ++O < z; ) {
        var Ht = $[O];
        L(Ht, O, $) && (pt[rt++] = Ht);
      }
      return pt;
    }
    function ho($, L) {
      var O = $ == null ? 0 : $.length;
      return !!O && gr($, L, 0) > -1;
    }
    function fs($, L, O) {
      for (var z = -1, rt = $ == null ? 0 : $.length; ++z < rt; )
        if (O(L, $[z]))
          return !0;
      return !1;
    }
    function $t($, L) {
      for (var O = -1, z = $ == null ? 0 : $.length, rt = Array(z); ++O < z; )
        rt[O] = L($[O], O, $);
      return rt;
    }
    function Ce($, L) {
      for (var O = -1, z = L.length, rt = $.length; ++O < z; )
        $[rt + O] = L[O];
      return $;
    }
    function ls($, L, O, z) {
      var rt = -1, pt = $ == null ? 0 : $.length;
      for (z && pt && (O = $[++rt]); ++rt < pt; )
        O = L(O, $[rt], rt, $);
      return O;
    }
    function Tp($, L, O, z) {
      var rt = $ == null ? 0 : $.length;
      for (z && rt && (O = $[--rt]); rt--; )
        O = L(O, $[rt], rt, $);
      return O;
    }
    function hs($, L) {
      for (var O = -1, z = $ == null ? 0 : $.length; ++O < z; )
        if (L($[O], O, $))
          return !0;
      return !1;
    }
    var $p = ds("length");
    function Rp($) {
      return $.split("");
    }
    function Cp($) {
      return $.match(F) || [];
    }
    function hf($, L, O) {
      var z;
      return O($, function(rt, pt, Ht) {
        if (L(rt, pt, Ht))
          return z = pt, !1;
      }), z;
    }
    function go($, L, O, z) {
      for (var rt = $.length, pt = O + (z ? 1 : -1); z ? pt-- : ++pt < rt; )
        if (L($[pt], pt, $))
          return pt;
      return -1;
    }
    function gr($, L, O) {
      return L === L ? Hp($, L, O) : go($, df, O);
    }
    function Sp($, L, O, z) {
      for (var rt = O - 1, pt = $.length; ++rt < pt; )
        if (z($[rt], L))
          return rt;
      return -1;
    }
    function df($) {
      return $ !== $;
    }
    function gf($, L) {
      var O = $ == null ? 0 : $.length;
      return O ? ps($, L) / O : Wt;
    }
    function ds($) {
      return function(L) {
        return L == null ? i : L[$];
      };
    }
    function gs($) {
      return function(L) {
        return $ == null ? i : $[L];
      };
    }
    function pf($, L, O, z, rt) {
      return rt($, function(pt, Ht, xt) {
        O = z ? (z = !1, pt) : L(O, pt, Ht, xt);
      }), O;
    }
    function bp($, L) {
      var O = $.length;
      for ($.sort(L); O--; )
        $[O] = $[O].value;
      return $;
    }
    function ps($, L) {
      for (var O, z = -1, rt = $.length; ++z < rt; ) {
        var pt = L($[z]);
        pt !== i && (O = O === i ? pt : O + pt);
      }
      return O;
    }
    function _s($, L) {
      for (var O = -1, z = Array($); ++O < $; )
        z[O] = L(O);
      return z;
    }
    function Op($, L) {
      return $t(L, function(O) {
        return [O, $[O]];
      });
    }
    function _f($) {
      return $ && $.slice(0, xf($) + 1).replace(ai, "");
    }
    function pn($) {
      return function(L) {
        return $(L);
      };
    }
    function vs($, L) {
      return $t(L, function(O) {
        return $[O];
      });
    }
    function si($, L) {
      return $.has(L);
    }
    function vf($, L) {
      for (var O = -1, z = $.length; ++O < z && gr(L, $[O], 0) > -1; )
        ;
      return O;
    }
    function mf($, L) {
      for (var O = $.length; O-- && gr(L, $[O], 0) > -1; )
        ;
      return O;
    }
    function Ip($, L) {
      for (var O = $.length, z = 0; O--; )
        $[O] === L && ++z;
      return z;
    }
    var Lp = gs(pp), Mp = gs(_p);
    function Pp($) {
      return "\\" + mp[$];
    }
    function Np($, L) {
      return $ == null ? i : $[L];
    }
    function pr($) {
      return lp.test($);
    }
    function kp($) {
      return hp.test($);
    }
    function Dp($) {
      for (var L, O = []; !(L = $.next()).done; )
        O.push(L.value);
      return O;
    }
    function ms($) {
      var L = -1, O = Array($.size);
      return $.forEach(function(z, rt) {
        O[++L] = [rt, z];
      }), O;
    }
    function yf($, L) {
      return function(O) {
        return $(L(O));
      };
    }
    function Se($, L) {
      for (var O = -1, z = $.length, rt = 0, pt = []; ++O < z; ) {
        var Ht = $[O];
        (Ht === L || Ht === _) && ($[O] = _, pt[rt++] = O);
      }
      return pt;
    }
    function po($) {
      var L = -1, O = Array($.size);
      return $.forEach(function(z) {
        O[++L] = z;
      }), O;
    }
    function Fp($) {
      var L = -1, O = Array($.size);
      return $.forEach(function(z) {
        O[++L] = [z, z];
      }), O;
    }
    function Hp($, L, O) {
      for (var z = O - 1, rt = $.length; ++z < rt; )
        if ($[z] === L)
          return z;
      return -1;
    }
    function Bp($, L, O) {
      for (var z = O + 1; z--; )
        if ($[z] === L)
          return z;
      return z;
    }
    function _r($) {
      return pr($) ? Up($) : $p($);
    }
    function Ln($) {
      return pr($) ? Gp($) : Rp($);
    }
    function xf($) {
      for (var L = $.length; L-- && ts.test($.charAt(L)); )
        ;
      return L;
    }
    var Wp = gs(vp);
    function Up($) {
      for (var L = ss.lastIndex = 0; ss.test($); )
        ++L;
      return L;
    }
    function Gp($) {
      return $.match(ss) || [];
    }
    function jp($) {
      return $.match(fp) || [];
    }
    var zp = function $(L) {
      L = L == null ? zt : vr.defaults(zt.Object(), L, vr.pick(zt, dp));
      var O = L.Array, z = L.Date, rt = L.Error, pt = L.Function, Ht = L.Math, xt = L.Object, ys = L.RegExp, Xp = L.String, En = L.TypeError, _o = O.prototype, Kp = pt.prototype, mr = xt.prototype, vo = L["__core-js_shared__"], mo = Kp.toString, mt = mr.hasOwnProperty, Yp = 0, wf = function() {
        var n = /[^.]+$/.exec(vo && vo.keys && vo.keys.IE_PROTO || "");
        return n ? "Symbol(src)_1." + n : "";
      }(), yo = mr.toString, qp = mo.call(xt), Vp = zt._, Zp = ys(
        "^" + mo.call(mt).replace(oi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), xo = rf ? L.Buffer : i, be = L.Symbol, wo = L.Uint8Array, Af = xo ? xo.allocUnsafe : i, Ao = yf(xt.getPrototypeOf, xt), Ef = xt.create, Tf = mr.propertyIsEnumerable, Eo = _o.splice, $f = be ? be.isConcatSpreadable : i, ui = be ? be.iterator : i, je = be ? be.toStringTag : i, To = function() {
        try {
          var n = qe(xt, "defineProperty");
          return n({}, "", {}), n;
        } catch {
        }
      }(), Jp = L.clearTimeout !== zt.clearTimeout && L.clearTimeout, Qp = z && z.now !== zt.Date.now && z.now, t_ = L.setTimeout !== zt.setTimeout && L.setTimeout, $o = Ht.ceil, Ro = Ht.floor, xs = xt.getOwnPropertySymbols, n_ = xo ? xo.isBuffer : i, Rf = L.isFinite, e_ = _o.join, r_ = yf(xt.keys, xt), Bt = Ht.max, qt = Ht.min, i_ = z.now, o_ = L.parseInt, Cf = Ht.random, a_ = _o.reverse, ws = qe(L, "DataView"), ci = qe(L, "Map"), As = qe(L, "Promise"), yr = qe(L, "Set"), fi = qe(L, "WeakMap"), li = qe(xt, "create"), Co = fi && new fi(), xr = {}, s_ = Ve(ws), u_ = Ve(ci), c_ = Ve(As), f_ = Ve(yr), l_ = Ve(fi), So = be ? be.prototype : i, hi = So ? So.valueOf : i, Sf = So ? So.toString : i;
      function p(n) {
        if (Ot(n) && !it(n) && !(n instanceof lt)) {
          if (n instanceof Tn)
            return n;
          if (mt.call(n, "__wrapped__"))
            return bl(n);
        }
        return new Tn(n);
      }
      var wr = function() {
        function n() {
        }
        return function(r) {
          if (!Ct(r))
            return {};
          if (Ef)
            return Ef(r);
          n.prototype = r;
          var a = new n();
          return n.prototype = i, a;
        };
      }();
      function bo() {
      }
      function Tn(n, r) {
        this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = i;
      }
      p.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Ja,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: oo,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: ao,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: p
        }
      }, p.prototype = bo.prototype, p.prototype.constructor = p, Tn.prototype = wr(bo.prototype), Tn.prototype.constructor = Tn;
      function lt(n) {
        this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Gt, this.__views__ = [];
      }
      function h_() {
        var n = new lt(this.__wrapped__);
        return n.__actions__ = an(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = an(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = an(this.__views__), n;
      }
      function d_() {
        if (this.__filtered__) {
          var n = new lt(this);
          n.__dir__ = -1, n.__filtered__ = !0;
        } else
          n = this.clone(), n.__dir__ *= -1;
        return n;
      }
      function g_() {
        var n = this.__wrapped__.value(), r = this.__dir__, a = it(n), c = r < 0, g = a ? n.length : 0, v = Rv(0, g, this.__views__), x = v.start, E = v.end, R = E - x, P = c ? E : x - 1, N = this.__iteratees__, D = N.length, G = 0, Y = qt(R, this.__takeCount__);
        if (!a || !c && g == R && Y == R)
          return Jf(n, this.__actions__);
        var Z = [];
        t:
          for (; R-- && G < Y; ) {
            P += r;
            for (var at = -1, J = n[P]; ++at < D; ) {
              var ct = N[at], ht = ct.iteratee, mn = ct.type, tn = ht(J);
              if (mn == Tt)
                J = tn;
              else if (!tn) {
                if (mn == yt)
                  continue t;
                break t;
              }
            }
            Z[G++] = J;
          }
        return Z;
      }
      lt.prototype = wr(bo.prototype), lt.prototype.constructor = lt;
      function ze(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.clear(); ++r < a; ) {
          var c = n[r];
          this.set(c[0], c[1]);
        }
      }
      function p_() {
        this.__data__ = li ? li(null) : {}, this.size = 0;
      }
      function __(n) {
        var r = this.has(n) && delete this.__data__[n];
        return this.size -= r ? 1 : 0, r;
      }
      function v_(n) {
        var r = this.__data__;
        if (li) {
          var a = r[n];
          return a === h ? i : a;
        }
        return mt.call(r, n) ? r[n] : i;
      }
      function m_(n) {
        var r = this.__data__;
        return li ? r[n] !== i : mt.call(r, n);
      }
      function y_(n, r) {
        var a = this.__data__;
        return this.size += this.has(n) ? 0 : 1, a[n] = li && r === i ? h : r, this;
      }
      ze.prototype.clear = p_, ze.prototype.delete = __, ze.prototype.get = v_, ze.prototype.has = m_, ze.prototype.set = y_;
      function se(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.clear(); ++r < a; ) {
          var c = n[r];
          this.set(c[0], c[1]);
        }
      }
      function x_() {
        this.__data__ = [], this.size = 0;
      }
      function w_(n) {
        var r = this.__data__, a = Oo(r, n);
        if (a < 0)
          return !1;
        var c = r.length - 1;
        return a == c ? r.pop() : Eo.call(r, a, 1), --this.size, !0;
      }
      function A_(n) {
        var r = this.__data__, a = Oo(r, n);
        return a < 0 ? i : r[a][1];
      }
      function E_(n) {
        return Oo(this.__data__, n) > -1;
      }
      function T_(n, r) {
        var a = this.__data__, c = Oo(a, n);
        return c < 0 ? (++this.size, a.push([n, r])) : a[c][1] = r, this;
      }
      se.prototype.clear = x_, se.prototype.delete = w_, se.prototype.get = A_, se.prototype.has = E_, se.prototype.set = T_;
      function ue(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.clear(); ++r < a; ) {
          var c = n[r];
          this.set(c[0], c[1]);
        }
      }
      function $_() {
        this.size = 0, this.__data__ = {
          hash: new ze(),
          map: new (ci || se)(),
          string: new ze()
        };
      }
      function R_(n) {
        var r = Uo(this, n).delete(n);
        return this.size -= r ? 1 : 0, r;
      }
      function C_(n) {
        return Uo(this, n).get(n);
      }
      function S_(n) {
        return Uo(this, n).has(n);
      }
      function b_(n, r) {
        var a = Uo(this, n), c = a.size;
        return a.set(n, r), this.size += a.size == c ? 0 : 1, this;
      }
      ue.prototype.clear = $_, ue.prototype.delete = R_, ue.prototype.get = C_, ue.prototype.has = S_, ue.prototype.set = b_;
      function Xe(n) {
        var r = -1, a = n == null ? 0 : n.length;
        for (this.__data__ = new ue(); ++r < a; )
          this.add(n[r]);
      }
      function O_(n) {
        return this.__data__.set(n, h), this;
      }
      function I_(n) {
        return this.__data__.has(n);
      }
      Xe.prototype.add = Xe.prototype.push = O_, Xe.prototype.has = I_;
      function Mn(n) {
        var r = this.__data__ = new se(n);
        this.size = r.size;
      }
      function L_() {
        this.__data__ = new se(), this.size = 0;
      }
      function M_(n) {
        var r = this.__data__, a = r.delete(n);
        return this.size = r.size, a;
      }
      function P_(n) {
        return this.__data__.get(n);
      }
      function N_(n) {
        return this.__data__.has(n);
      }
      function k_(n, r) {
        var a = this.__data__;
        if (a instanceof se) {
          var c = a.__data__;
          if (!ci || c.length < s - 1)
            return c.push([n, r]), this.size = ++a.size, this;
          a = this.__data__ = new ue(c);
        }
        return a.set(n, r), this.size = a.size, this;
      }
      Mn.prototype.clear = L_, Mn.prototype.delete = M_, Mn.prototype.get = P_, Mn.prototype.has = N_, Mn.prototype.set = k_;
      function bf(n, r) {
        var a = it(n), c = !a && Ze(n), g = !a && !c && Pe(n), v = !a && !c && !g && $r(n), x = a || c || g || v, E = x ? _s(n.length, Xp) : [], R = E.length;
        for (var P in n)
          (r || mt.call(n, P)) && !(x && // Safari 9 has enumerable `arguments.length` in strict mode.
          (P == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          g && (P == "offset" || P == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          v && (P == "buffer" || P == "byteLength" || P == "byteOffset") || // Skip index properties.
          he(P, R))) && E.push(P);
        return E;
      }
      function Of(n) {
        var r = n.length;
        return r ? n[Ms(0, r - 1)] : i;
      }
      function D_(n, r) {
        return Go(an(n), Ke(r, 0, n.length));
      }
      function F_(n) {
        return Go(an(n));
      }
      function Es(n, r, a) {
        (a !== i && !Pn(n[r], a) || a === i && !(r in n)) && ce(n, r, a);
      }
      function di(n, r, a) {
        var c = n[r];
        (!(mt.call(n, r) && Pn(c, a)) || a === i && !(r in n)) && ce(n, r, a);
      }
      function Oo(n, r) {
        for (var a = n.length; a--; )
          if (Pn(n[a][0], r))
            return a;
        return -1;
      }
      function H_(n, r, a, c) {
        return Oe(n, function(g, v, x) {
          r(c, g, a(g), x);
        }), c;
      }
      function If(n, r) {
        return n && qn(r, Ut(r), n);
      }
      function B_(n, r) {
        return n && qn(r, un(r), n);
      }
      function ce(n, r, a) {
        r == "__proto__" && To ? To(n, r, {
          configurable: !0,
          enumerable: !0,
          value: a,
          writable: !0
        }) : n[r] = a;
      }
      function Ts(n, r) {
        for (var a = -1, c = r.length, g = O(c), v = n == null; ++a < c; )
          g[a] = v ? i : iu(n, r[a]);
        return g;
      }
      function Ke(n, r, a) {
        return n === n && (a !== i && (n = n <= a ? n : a), r !== i && (n = n >= r ? n : r)), n;
      }
      function $n(n, r, a, c, g, v) {
        var x, E = r & y, R = r & m, P = r & T;
        if (a && (x = g ? a(n, c, g, v) : a(n)), x !== i)
          return x;
        if (!Ct(n))
          return n;
        var N = it(n);
        if (N) {
          if (x = Sv(n), !E)
            return an(n, x);
        } else {
          var D = Vt(n), G = D == Be || D == no;
          if (Pe(n))
            return nl(n, E);
          if (D == xn || D == zn || G && !g) {
            if (x = R || G ? {} : xl(n), !E)
              return R ? vv(n, B_(x, n)) : _v(n, If(x, n));
          } else {
            if (!wt[D])
              return g ? n : {};
            x = bv(n, D, E);
          }
        }
        v || (v = new Mn());
        var Y = v.get(n);
        if (Y)
          return Y;
        v.set(n, x), ql(n) ? n.forEach(function(J) {
          x.add($n(J, r, a, J, n, v));
        }) : Kl(n) && n.forEach(function(J, ct) {
          x.set(ct, $n(J, r, a, ct, n, v));
        });
        var Z = P ? R ? js : Gs : R ? un : Ut, at = N ? i : Z(n);
        return An(at || n, function(J, ct) {
          at && (ct = J, J = n[ct]), di(x, ct, $n(J, r, a, ct, n, v));
        }), x;
      }
      function W_(n) {
        var r = Ut(n);
        return function(a) {
          return Lf(a, n, r);
        };
      }
      function Lf(n, r, a) {
        var c = a.length;
        if (n == null)
          return !c;
        for (n = xt(n); c--; ) {
          var g = a[c], v = r[g], x = n[g];
          if (x === i && !(g in n) || !v(x))
            return !1;
        }
        return !0;
      }
      function Mf(n, r, a) {
        if (typeof n != "function")
          throw new En(f);
        return xi(function() {
          n.apply(i, a);
        }, r);
      }
      function gi(n, r, a, c) {
        var g = -1, v = ho, x = !0, E = n.length, R = [], P = r.length;
        if (!E)
          return R;
        a && (r = $t(r, pn(a))), c ? (v = fs, x = !1) : r.length >= s && (v = si, x = !1, r = new Xe(r));
        t:
          for (; ++g < E; ) {
            var N = n[g], D = a == null ? N : a(N);
            if (N = c || N !== 0 ? N : 0, x && D === D) {
              for (var G = P; G--; )
                if (r[G] === D)
                  continue t;
              R.push(N);
            } else
              v(r, D, c) || R.push(N);
          }
        return R;
      }
      var Oe = al(Yn), Pf = al(Rs, !0);
      function U_(n, r) {
        var a = !0;
        return Oe(n, function(c, g, v) {
          return a = !!r(c, g, v), a;
        }), a;
      }
      function Io(n, r, a) {
        for (var c = -1, g = n.length; ++c < g; ) {
          var v = n[c], x = r(v);
          if (x != null && (E === i ? x === x && !vn(x) : a(x, E)))
            var E = x, R = v;
        }
        return R;
      }
      function G_(n, r, a, c) {
        var g = n.length;
        for (a = ot(a), a < 0 && (a = -a > g ? 0 : g + a), c = c === i || c > g ? g : ot(c), c < 0 && (c += g), c = a > c ? 0 : Zl(c); a < c; )
          n[a++] = r;
        return n;
      }
      function Nf(n, r) {
        var a = [];
        return Oe(n, function(c, g, v) {
          r(c, g, v) && a.push(c);
        }), a;
      }
      function Xt(n, r, a, c, g) {
        var v = -1, x = n.length;
        for (a || (a = Iv), g || (g = []); ++v < x; ) {
          var E = n[v];
          r > 0 && a(E) ? r > 1 ? Xt(E, r - 1, a, c, g) : Ce(g, E) : c || (g[g.length] = E);
        }
        return g;
      }
      var $s = sl(), kf = sl(!0);
      function Yn(n, r) {
        return n && $s(n, r, Ut);
      }
      function Rs(n, r) {
        return n && kf(n, r, Ut);
      }
      function Lo(n, r) {
        return Re(r, function(a) {
          return de(n[a]);
        });
      }
      function Ye(n, r) {
        r = Le(r, n);
        for (var a = 0, c = r.length; n != null && a < c; )
          n = n[Vn(r[a++])];
        return a && a == c ? n : i;
      }
      function Df(n, r, a) {
        var c = r(n);
        return it(n) ? c : Ce(c, a(n));
      }
      function Jt(n) {
        return n == null ? n === i ? Va : sr : je && je in xt(n) ? $v(n) : Fv(n);
      }
      function Cs(n, r) {
        return n > r;
      }
      function j_(n, r) {
        return n != null && mt.call(n, r);
      }
      function z_(n, r) {
        return n != null && r in xt(n);
      }
      function X_(n, r, a) {
        return n >= qt(r, a) && n < Bt(r, a);
      }
      function Ss(n, r, a) {
        for (var c = a ? fs : ho, g = n[0].length, v = n.length, x = v, E = O(v), R = 1 / 0, P = []; x--; ) {
          var N = n[x];
          x && r && (N = $t(N, pn(r))), R = qt(N.length, R), E[x] = !a && (r || g >= 120 && N.length >= 120) ? new Xe(x && N) : i;
        }
        N = n[0];
        var D = -1, G = E[0];
        t:
          for (; ++D < g && P.length < R; ) {
            var Y = N[D], Z = r ? r(Y) : Y;
            if (Y = a || Y !== 0 ? Y : 0, !(G ? si(G, Z) : c(P, Z, a))) {
              for (x = v; --x; ) {
                var at = E[x];
                if (!(at ? si(at, Z) : c(n[x], Z, a)))
                  continue t;
              }
              G && G.push(Z), P.push(Y);
            }
          }
        return P;
      }
      function K_(n, r, a, c) {
        return Yn(n, function(g, v, x) {
          r(c, a(g), v, x);
        }), c;
      }
      function pi(n, r, a) {
        r = Le(r, n), n = Tl(n, r);
        var c = n == null ? n : n[Vn(Cn(r))];
        return c == null ? i : gn(c, n, a);
      }
      function Ff(n) {
        return Ot(n) && Jt(n) == zn;
      }
      function Y_(n) {
        return Ot(n) && Jt(n) == On;
      }
      function q_(n) {
        return Ot(n) && Jt(n) == Ft;
      }
      function _i(n, r, a, c, g) {
        return n === r ? !0 : n == null || r == null || !Ot(n) && !Ot(r) ? n !== n && r !== r : V_(n, r, a, c, _i, g);
      }
      function V_(n, r, a, c, g, v) {
        var x = it(n), E = it(r), R = x ? Xn : Vt(n), P = E ? Xn : Vt(r);
        R = R == zn ? xn : R, P = P == zn ? xn : P;
        var N = R == xn, D = P == xn, G = R == P;
        if (G && Pe(n)) {
          if (!Pe(r))
            return !1;
          x = !0, N = !1;
        }
        if (G && !N)
          return v || (v = new Mn()), x || $r(n) ? vl(n, r, a, c, g, v) : Ev(n, r, R, a, c, g, v);
        if (!(a & S)) {
          var Y = N && mt.call(n, "__wrapped__"), Z = D && mt.call(r, "__wrapped__");
          if (Y || Z) {
            var at = Y ? n.value() : n, J = Z ? r.value() : r;
            return v || (v = new Mn()), g(at, J, a, c, v);
          }
        }
        return G ? (v || (v = new Mn()), Tv(n, r, a, c, g, v)) : !1;
      }
      function Z_(n) {
        return Ot(n) && Vt(n) == hn;
      }
      function bs(n, r, a, c) {
        var g = a.length, v = g, x = !c;
        if (n == null)
          return !v;
        for (n = xt(n); g--; ) {
          var E = a[g];
          if (x && E[2] ? E[1] !== n[E[0]] : !(E[0] in n))
            return !1;
        }
        for (; ++g < v; ) {
          E = a[g];
          var R = E[0], P = n[R], N = E[1];
          if (x && E[2]) {
            if (P === i && !(R in n))
              return !1;
          } else {
            var D = new Mn();
            if (c)
              var G = c(P, N, R, n, r, D);
            if (!(G === i ? _i(N, P, S | b, c, D) : G))
              return !1;
          }
        }
        return !0;
      }
      function Hf(n) {
        if (!Ct(n) || Mv(n))
          return !1;
        var r = de(n) ? Zp : jt;
        return r.test(Ve(n));
      }
      function J_(n) {
        return Ot(n) && Jt(n) == We;
      }
      function Q_(n) {
        return Ot(n) && Vt(n) == dn;
      }
      function tv(n) {
        return Ot(n) && qo(n.length) && !!At[Jt(n)];
      }
      function Bf(n) {
        return typeof n == "function" ? n : n == null ? cn : typeof n == "object" ? it(n) ? Gf(n[0], n[1]) : Uf(n) : uh(n);
      }
      function Os(n) {
        if (!yi(n))
          return r_(n);
        var r = [];
        for (var a in xt(n))
          mt.call(n, a) && a != "constructor" && r.push(a);
        return r;
      }
      function nv(n) {
        if (!Ct(n))
          return Dv(n);
        var r = yi(n), a = [];
        for (var c in n)
          c == "constructor" && (r || !mt.call(n, c)) || a.push(c);
        return a;
      }
      function Is(n, r) {
        return n < r;
      }
      function Wf(n, r) {
        var a = -1, c = sn(n) ? O(n.length) : [];
        return Oe(n, function(g, v, x) {
          c[++a] = r(g, v, x);
        }), c;
      }
      function Uf(n) {
        var r = Xs(n);
        return r.length == 1 && r[0][2] ? Al(r[0][0], r[0][1]) : function(a) {
          return a === n || bs(a, n, r);
        };
      }
      function Gf(n, r) {
        return Ys(n) && wl(r) ? Al(Vn(n), r) : function(a) {
          var c = iu(a, n);
          return c === i && c === r ? ou(a, n) : _i(r, c, S | b);
        };
      }
      function Mo(n, r, a, c, g) {
        n !== r && $s(r, function(v, x) {
          if (g || (g = new Mn()), Ct(v))
            ev(n, r, x, a, Mo, c, g);
          else {
            var E = c ? c(Vs(n, x), v, x + "", n, r, g) : i;
            E === i && (E = v), Es(n, x, E);
          }
        }, un);
      }
      function ev(n, r, a, c, g, v, x) {
        var E = Vs(n, a), R = Vs(r, a), P = x.get(R);
        if (P) {
          Es(n, a, P);
          return;
        }
        var N = v ? v(E, R, a + "", n, r, x) : i, D = N === i;
        if (D) {
          var G = it(R), Y = !G && Pe(R), Z = !G && !Y && $r(R);
          N = R, G || Y || Z ? it(E) ? N = E : It(E) ? N = an(E) : Y ? (D = !1, N = nl(R, !0)) : Z ? (D = !1, N = el(R, !0)) : N = [] : wi(R) || Ze(R) ? (N = E, Ze(E) ? N = Jl(E) : (!Ct(E) || de(E)) && (N = xl(R))) : D = !1;
        }
        D && (x.set(R, N), g(N, R, c, v, x), x.delete(R)), Es(n, a, N);
      }
      function jf(n, r) {
        var a = n.length;
        if (a)
          return r += r < 0 ? a : 0, he(r, a) ? n[r] : i;
      }
      function zf(n, r, a) {
        r.length ? r = $t(r, function(v) {
          return it(v) ? function(x) {
            return Ye(x, v.length === 1 ? v[0] : v);
          } : v;
        }) : r = [cn];
        var c = -1;
        r = $t(r, pn(V()));
        var g = Wf(n, function(v, x, E) {
          var R = $t(r, function(P) {
            return P(v);
          });
          return { criteria: R, index: ++c, value: v };
        });
        return bp(g, function(v, x) {
          return pv(v, x, a);
        });
      }
      function rv(n, r) {
        return Xf(n, r, function(a, c) {
          return ou(n, c);
        });
      }
      function Xf(n, r, a) {
        for (var c = -1, g = r.length, v = {}; ++c < g; ) {
          var x = r[c], E = Ye(n, x);
          a(E, x) && vi(v, Le(x, n), E);
        }
        return v;
      }
      function iv(n) {
        return function(r) {
          return Ye(r, n);
        };
      }
      function Ls(n, r, a, c) {
        var g = c ? Sp : gr, v = -1, x = r.length, E = n;
        for (n === r && (r = an(r)), a && (E = $t(n, pn(a))); ++v < x; )
          for (var R = 0, P = r[v], N = a ? a(P) : P; (R = g(E, N, R, c)) > -1; )
            E !== n && Eo.call(E, R, 1), Eo.call(n, R, 1);
        return n;
      }
      function Kf(n, r) {
        for (var a = n ? r.length : 0, c = a - 1; a--; ) {
          var g = r[a];
          if (a == c || g !== v) {
            var v = g;
            he(g) ? Eo.call(n, g, 1) : ks(n, g);
          }
        }
        return n;
      }
      function Ms(n, r) {
        return n + Ro(Cf() * (r - n + 1));
      }
      function ov(n, r, a, c) {
        for (var g = -1, v = Bt($o((r - n) / (a || 1)), 0), x = O(v); v--; )
          x[c ? v : ++g] = n, n += a;
        return x;
      }
      function Ps(n, r) {
        var a = "";
        if (!n || r < 1 || r > St)
          return a;
        do
          r % 2 && (a += n), r = Ro(r / 2), r && (n += n);
        while (r);
        return a;
      }
      function st(n, r) {
        return Zs(El(n, r, cn), n + "");
      }
      function av(n) {
        return Of(Rr(n));
      }
      function sv(n, r) {
        var a = Rr(n);
        return Go(a, Ke(r, 0, a.length));
      }
      function vi(n, r, a, c) {
        if (!Ct(n))
          return n;
        r = Le(r, n);
        for (var g = -1, v = r.length, x = v - 1, E = n; E != null && ++g < v; ) {
          var R = Vn(r[g]), P = a;
          if (R === "__proto__" || R === "constructor" || R === "prototype")
            return n;
          if (g != x) {
            var N = E[R];
            P = c ? c(N, R, E) : i, P === i && (P = Ct(N) ? N : he(r[g + 1]) ? [] : {});
          }
          di(E, R, P), E = E[R];
        }
        return n;
      }
      var Yf = Co ? function(n, r) {
        return Co.set(n, r), n;
      } : cn, uv = To ? function(n, r) {
        return To(n, "toString", {
          configurable: !0,
          enumerable: !1,
          value: su(r),
          writable: !0
        });
      } : cn;
      function cv(n) {
        return Go(Rr(n));
      }
      function Rn(n, r, a) {
        var c = -1, g = n.length;
        r < 0 && (r = -r > g ? 0 : g + r), a = a > g ? g : a, a < 0 && (a += g), g = r > a ? 0 : a - r >>> 0, r >>>= 0;
        for (var v = O(g); ++c < g; )
          v[c] = n[c + r];
        return v;
      }
      function fv(n, r) {
        var a;
        return Oe(n, function(c, g, v) {
          return a = r(c, g, v), !a;
        }), !!a;
      }
      function Po(n, r, a) {
        var c = 0, g = n == null ? c : n.length;
        if (typeof r == "number" && r === r && g <= re) {
          for (; c < g; ) {
            var v = c + g >>> 1, x = n[v];
            x !== null && !vn(x) && (a ? x <= r : x < r) ? c = v + 1 : g = v;
          }
          return g;
        }
        return Ns(n, r, cn, a);
      }
      function Ns(n, r, a, c) {
        var g = 0, v = n == null ? 0 : n.length;
        if (v === 0)
          return 0;
        r = a(r);
        for (var x = r !== r, E = r === null, R = vn(r), P = r === i; g < v; ) {
          var N = Ro((g + v) / 2), D = a(n[N]), G = D !== i, Y = D === null, Z = D === D, at = vn(D);
          if (x)
            var J = c || Z;
          else
            P ? J = Z && (c || G) : E ? J = Z && G && (c || !Y) : R ? J = Z && G && !Y && (c || !at) : Y || at ? J = !1 : J = c ? D <= r : D < r;
          J ? g = N + 1 : v = N;
        }
        return qt(v, ee);
      }
      function qf(n, r) {
        for (var a = -1, c = n.length, g = 0, v = []; ++a < c; ) {
          var x = n[a], E = r ? r(x) : x;
          if (!a || !Pn(E, R)) {
            var R = E;
            v[g++] = x === 0 ? 0 : x;
          }
        }
        return v;
      }
      function Vf(n) {
        return typeof n == "number" ? n : vn(n) ? Wt : +n;
      }
      function _n(n) {
        if (typeof n == "string")
          return n;
        if (it(n))
          return $t(n, _n) + "";
        if (vn(n))
          return Sf ? Sf.call(n) : "";
        var r = n + "";
        return r == "0" && 1 / n == -gt ? "-0" : r;
      }
      function Ie(n, r, a) {
        var c = -1, g = ho, v = n.length, x = !0, E = [], R = E;
        if (a)
          x = !1, g = fs;
        else if (v >= s) {
          var P = r ? null : wv(n);
          if (P)
            return po(P);
          x = !1, g = si, R = new Xe();
        } else
          R = r ? [] : E;
        t:
          for (; ++c < v; ) {
            var N = n[c], D = r ? r(N) : N;
            if (N = a || N !== 0 ? N : 0, x && D === D) {
              for (var G = R.length; G--; )
                if (R[G] === D)
                  continue t;
              r && R.push(D), E.push(N);
            } else
              g(R, D, a) || (R !== E && R.push(D), E.push(N));
          }
        return E;
      }
      function ks(n, r) {
        return r = Le(r, n), n = Tl(n, r), n == null || delete n[Vn(Cn(r))];
      }
      function Zf(n, r, a, c) {
        return vi(n, r, a(Ye(n, r)), c);
      }
      function No(n, r, a, c) {
        for (var g = n.length, v = c ? g : -1; (c ? v-- : ++v < g) && r(n[v], v, n); )
          ;
        return a ? Rn(n, c ? 0 : v, c ? v + 1 : g) : Rn(n, c ? v + 1 : 0, c ? g : v);
      }
      function Jf(n, r) {
        var a = n;
        return a instanceof lt && (a = a.value()), ls(r, function(c, g) {
          return g.func.apply(g.thisArg, Ce([c], g.args));
        }, a);
      }
      function Ds(n, r, a) {
        var c = n.length;
        if (c < 2)
          return c ? Ie(n[0]) : [];
        for (var g = -1, v = O(c); ++g < c; )
          for (var x = n[g], E = -1; ++E < c; )
            E != g && (v[g] = gi(v[g] || x, n[E], r, a));
        return Ie(Xt(v, 1), r, a);
      }
      function Qf(n, r, a) {
        for (var c = -1, g = n.length, v = r.length, x = {}; ++c < g; ) {
          var E = c < v ? r[c] : i;
          a(x, n[c], E);
        }
        return x;
      }
      function Fs(n) {
        return It(n) ? n : [];
      }
      function Hs(n) {
        return typeof n == "function" ? n : cn;
      }
      function Le(n, r) {
        return it(n) ? n : Ys(n, r) ? [n] : Sl(vt(n));
      }
      var lv = st;
      function Me(n, r, a) {
        var c = n.length;
        return a = a === i ? c : a, !r && a >= c ? n : Rn(n, r, a);
      }
      var tl = Jp || function(n) {
        return zt.clearTimeout(n);
      };
      function nl(n, r) {
        if (r)
          return n.slice();
        var a = n.length, c = Af ? Af(a) : new n.constructor(a);
        return n.copy(c), c;
      }
      function Bs(n) {
        var r = new n.constructor(n.byteLength);
        return new wo(r).set(new wo(n)), r;
      }
      function hv(n, r) {
        var a = r ? Bs(n.buffer) : n.buffer;
        return new n.constructor(a, n.byteOffset, n.byteLength);
      }
      function dv(n) {
        var r = new n.constructor(n.source, _t.exec(n));
        return r.lastIndex = n.lastIndex, r;
      }
      function gv(n) {
        return hi ? xt(hi.call(n)) : {};
      }
      function el(n, r) {
        var a = r ? Bs(n.buffer) : n.buffer;
        return new n.constructor(a, n.byteOffset, n.length);
      }
      function rl(n, r) {
        if (n !== r) {
          var a = n !== i, c = n === null, g = n === n, v = vn(n), x = r !== i, E = r === null, R = r === r, P = vn(r);
          if (!E && !P && !v && n > r || v && x && R && !E && !P || c && x && R || !a && R || !g)
            return 1;
          if (!c && !v && !P && n < r || P && a && g && !c && !v || E && a && g || !x && g || !R)
            return -1;
        }
        return 0;
      }
      function pv(n, r, a) {
        for (var c = -1, g = n.criteria, v = r.criteria, x = g.length, E = a.length; ++c < x; ) {
          var R = rl(g[c], v[c]);
          if (R) {
            if (c >= E)
              return R;
            var P = a[c];
            return R * (P == "desc" ? -1 : 1);
          }
        }
        return n.index - r.index;
      }
      function il(n, r, a, c) {
        for (var g = -1, v = n.length, x = a.length, E = -1, R = r.length, P = Bt(v - x, 0), N = O(R + P), D = !c; ++E < R; )
          N[E] = r[E];
        for (; ++g < x; )
          (D || g < v) && (N[a[g]] = n[g]);
        for (; P--; )
          N[E++] = n[g++];
        return N;
      }
      function ol(n, r, a, c) {
        for (var g = -1, v = n.length, x = -1, E = a.length, R = -1, P = r.length, N = Bt(v - E, 0), D = O(N + P), G = !c; ++g < N; )
          D[g] = n[g];
        for (var Y = g; ++R < P; )
          D[Y + R] = r[R];
        for (; ++x < E; )
          (G || g < v) && (D[Y + a[x]] = n[g++]);
        return D;
      }
      function an(n, r) {
        var a = -1, c = n.length;
        for (r || (r = O(c)); ++a < c; )
          r[a] = n[a];
        return r;
      }
      function qn(n, r, a, c) {
        var g = !a;
        a || (a = {});
        for (var v = -1, x = r.length; ++v < x; ) {
          var E = r[v], R = c ? c(a[E], n[E], E, a, n) : i;
          R === i && (R = n[E]), g ? ce(a, E, R) : di(a, E, R);
        }
        return a;
      }
      function _v(n, r) {
        return qn(n, Ks(n), r);
      }
      function vv(n, r) {
        return qn(n, ml(n), r);
      }
      function ko(n, r) {
        return function(a, c) {
          var g = it(a) ? Ap : H_, v = r ? r() : {};
          return g(a, n, V(c, 2), v);
        };
      }
      function Ar(n) {
        return st(function(r, a) {
          var c = -1, g = a.length, v = g > 1 ? a[g - 1] : i, x = g > 2 ? a[2] : i;
          for (v = n.length > 3 && typeof v == "function" ? (g--, v) : i, x && Qt(a[0], a[1], x) && (v = g < 3 ? i : v, g = 1), r = xt(r); ++c < g; ) {
            var E = a[c];
            E && n(r, E, c, v);
          }
          return r;
        });
      }
      function al(n, r) {
        return function(a, c) {
          if (a == null)
            return a;
          if (!sn(a))
            return n(a, c);
          for (var g = a.length, v = r ? g : -1, x = xt(a); (r ? v-- : ++v < g) && c(x[v], v, x) !== !1; )
            ;
          return a;
        };
      }
      function sl(n) {
        return function(r, a, c) {
          for (var g = -1, v = xt(r), x = c(r), E = x.length; E--; ) {
            var R = x[n ? E : ++g];
            if (a(v[R], R, v) === !1)
              break;
          }
          return r;
        };
      }
      function mv(n, r, a) {
        var c = r & M, g = mi(n);
        function v() {
          var x = this && this !== zt && this instanceof v ? g : n;
          return x.apply(c ? a : this, arguments);
        }
        return v;
      }
      function ul(n) {
        return function(r) {
          r = vt(r);
          var a = pr(r) ? Ln(r) : i, c = a ? a[0] : r.charAt(0), g = a ? Me(a, 1).join("") : r.slice(1);
          return c[n]() + g;
        };
      }
      function Er(n) {
        return function(r) {
          return ls(ah(oh(r).replace(up, "")), n, "");
        };
      }
      function mi(n) {
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return new n();
            case 1:
              return new n(r[0]);
            case 2:
              return new n(r[0], r[1]);
            case 3:
              return new n(r[0], r[1], r[2]);
            case 4:
              return new n(r[0], r[1], r[2], r[3]);
            case 5:
              return new n(r[0], r[1], r[2], r[3], r[4]);
            case 6:
              return new n(r[0], r[1], r[2], r[3], r[4], r[5]);
            case 7:
              return new n(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
          }
          var a = wr(n.prototype), c = n.apply(a, r);
          return Ct(c) ? c : a;
        };
      }
      function yv(n, r, a) {
        var c = mi(n);
        function g() {
          for (var v = arguments.length, x = O(v), E = v, R = Tr(g); E--; )
            x[E] = arguments[E];
          var P = v < 3 && x[0] !== R && x[v - 1] !== R ? [] : Se(x, R);
          if (v -= P.length, v < a)
            return dl(
              n,
              r,
              Do,
              g.placeholder,
              i,
              x,
              P,
              i,
              i,
              a - v
            );
          var N = this && this !== zt && this instanceof g ? c : n;
          return gn(N, this, x);
        }
        return g;
      }
      function cl(n) {
        return function(r, a, c) {
          var g = xt(r);
          if (!sn(r)) {
            var v = V(a, 3);
            r = Ut(r), a = function(E) {
              return v(g[E], E, g);
            };
          }
          var x = n(r, a, c);
          return x > -1 ? g[v ? r[x] : x] : i;
        };
      }
      function fl(n) {
        return le(function(r) {
          var a = r.length, c = a, g = Tn.prototype.thru;
          for (n && r.reverse(); c--; ) {
            var v = r[c];
            if (typeof v != "function")
              throw new En(f);
            if (g && !x && Wo(v) == "wrapper")
              var x = new Tn([], !0);
          }
          for (c = x ? c : a; ++c < a; ) {
            v = r[c];
            var E = Wo(v), R = E == "wrapper" ? zs(v) : i;
            R && qs(R[0]) && R[1] == (K | H | k | q) && !R[4].length && R[9] == 1 ? x = x[Wo(R[0])].apply(x, R[3]) : x = v.length == 1 && qs(v) ? x[E]() : x.thru(v);
          }
          return function() {
            var P = arguments, N = P[0];
            if (x && P.length == 1 && it(N))
              return x.plant(N).value();
            for (var D = 0, G = a ? r[D].apply(this, P) : N; ++D < a; )
              G = r[D].call(this, G);
            return G;
          };
        });
      }
      function Do(n, r, a, c, g, v, x, E, R, P) {
        var N = r & K, D = r & M, G = r & I, Y = r & (H | B), Z = r & tt, at = G ? i : mi(n);
        function J() {
          for (var ct = arguments.length, ht = O(ct), mn = ct; mn--; )
            ht[mn] = arguments[mn];
          if (Y)
            var tn = Tr(J), yn = Ip(ht, tn);
          if (c && (ht = il(ht, c, g, Y)), v && (ht = ol(ht, v, x, Y)), ct -= yn, Y && ct < P) {
            var Lt = Se(ht, tn);
            return dl(
              n,
              r,
              Do,
              J.placeholder,
              a,
              ht,
              Lt,
              E,
              R,
              P - ct
            );
          }
          var Nn = D ? a : this, pe = G ? Nn[n] : n;
          return ct = ht.length, E ? ht = Hv(ht, E) : Z && ct > 1 && ht.reverse(), N && R < ct && (ht.length = R), this && this !== zt && this instanceof J && (pe = at || mi(pe)), pe.apply(Nn, ht);
        }
        return J;
      }
      function ll(n, r) {
        return function(a, c) {
          return K_(a, n, r(c), {});
        };
      }
      function Fo(n, r) {
        return function(a, c) {
          var g;
          if (a === i && c === i)
            return r;
          if (a !== i && (g = a), c !== i) {
            if (g === i)
              return c;
            typeof a == "string" || typeof c == "string" ? (a = _n(a), c = _n(c)) : (a = Vf(a), c = Vf(c)), g = n(a, c);
          }
          return g;
        };
      }
      function Ws(n) {
        return le(function(r) {
          return r = $t(r, pn(V())), st(function(a) {
            var c = this;
            return n(r, function(g) {
              return gn(g, c, a);
            });
          });
        });
      }
      function Ho(n, r) {
        r = r === i ? " " : _n(r);
        var a = r.length;
        if (a < 2)
          return a ? Ps(r, n) : r;
        var c = Ps(r, $o(n / _r(r)));
        return pr(r) ? Me(Ln(c), 0, n).join("") : c.slice(0, n);
      }
      function xv(n, r, a, c) {
        var g = r & M, v = mi(n);
        function x() {
          for (var E = -1, R = arguments.length, P = -1, N = c.length, D = O(N + R), G = this && this !== zt && this instanceof x ? v : n; ++P < N; )
            D[P] = c[P];
          for (; R--; )
            D[P++] = arguments[++E];
          return gn(G, g ? a : this, D);
        }
        return x;
      }
      function hl(n) {
        return function(r, a, c) {
          return c && typeof c != "number" && Qt(r, a, c) && (a = c = i), r = ge(r), a === i ? (a = r, r = 0) : a = ge(a), c = c === i ? r < a ? 1 : -1 : ge(c), ov(r, a, c, n);
        };
      }
      function Bo(n) {
        return function(r, a) {
          return typeof r == "string" && typeof a == "string" || (r = Sn(r), a = Sn(a)), n(r, a);
        };
      }
      function dl(n, r, a, c, g, v, x, E, R, P) {
        var N = r & H, D = N ? x : i, G = N ? i : x, Y = N ? v : i, Z = N ? i : v;
        r |= N ? k : W, r &= ~(N ? W : k), r & C || (r &= ~(M | I));
        var at = [
          n,
          r,
          g,
          Y,
          D,
          Z,
          G,
          E,
          R,
          P
        ], J = a.apply(i, at);
        return qs(n) && $l(J, at), J.placeholder = c, Rl(J, n, r);
      }
      function Us(n) {
        var r = Ht[n];
        return function(a, c) {
          if (a = Sn(a), c = c == null ? 0 : qt(ot(c), 292), c && Rf(a)) {
            var g = (vt(a) + "e").split("e"), v = r(g[0] + "e" + (+g[1] + c));
            return g = (vt(v) + "e").split("e"), +(g[0] + "e" + (+g[1] - c));
          }
          return r(a);
        };
      }
      var wv = yr && 1 / po(new yr([, -0]))[1] == gt ? function(n) {
        return new yr(n);
      } : fu;
      function gl(n) {
        return function(r) {
          var a = Vt(r);
          return a == hn ? ms(r) : a == dn ? Fp(r) : Op(r, n(r));
        };
      }
      function fe(n, r, a, c, g, v, x, E) {
        var R = r & I;
        if (!R && typeof n != "function")
          throw new En(f);
        var P = c ? c.length : 0;
        if (P || (r &= ~(k | W), c = g = i), x = x === i ? x : Bt(ot(x), 0), E = E === i ? E : ot(E), P -= g ? g.length : 0, r & W) {
          var N = c, D = g;
          c = g = i;
        }
        var G = R ? i : zs(n), Y = [
          n,
          r,
          a,
          c,
          g,
          N,
          D,
          v,
          x,
          E
        ];
        if (G && kv(Y, G), n = Y[0], r = Y[1], a = Y[2], c = Y[3], g = Y[4], E = Y[9] = Y[9] === i ? R ? 0 : n.length : Bt(Y[9] - P, 0), !E && r & (H | B) && (r &= ~(H | B)), !r || r == M)
          var Z = mv(n, r, a);
        else
          r == H || r == B ? Z = yv(n, r, E) : (r == k || r == (M | k)) && !g.length ? Z = xv(n, r, a, c) : Z = Do.apply(i, Y);
        var at = G ? Yf : $l;
        return Rl(at(Z, Y), n, r);
      }
      function pl(n, r, a, c) {
        return n === i || Pn(n, mr[a]) && !mt.call(c, a) ? r : n;
      }
      function _l(n, r, a, c, g, v) {
        return Ct(n) && Ct(r) && (v.set(r, n), Mo(n, r, i, _l, v), v.delete(r)), n;
      }
      function Av(n) {
        return wi(n) ? i : n;
      }
      function vl(n, r, a, c, g, v) {
        var x = a & S, E = n.length, R = r.length;
        if (E != R && !(x && R > E))
          return !1;
        var P = v.get(n), N = v.get(r);
        if (P && N)
          return P == r && N == n;
        var D = -1, G = !0, Y = a & b ? new Xe() : i;
        for (v.set(n, r), v.set(r, n); ++D < E; ) {
          var Z = n[D], at = r[D];
          if (c)
            var J = x ? c(at, Z, D, r, n, v) : c(Z, at, D, n, r, v);
          if (J !== i) {
            if (J)
              continue;
            G = !1;
            break;
          }
          if (Y) {
            if (!hs(r, function(ct, ht) {
              if (!si(Y, ht) && (Z === ct || g(Z, ct, a, c, v)))
                return Y.push(ht);
            })) {
              G = !1;
              break;
            }
          } else if (!(Z === at || g(Z, at, a, c, v))) {
            G = !1;
            break;
          }
        }
        return v.delete(n), v.delete(r), G;
      }
      function Ev(n, r, a, c, g, v, x) {
        switch (a) {
          case $e:
            if (n.byteLength != r.byteLength || n.byteOffset != r.byteOffset)
              return !1;
            n = n.buffer, r = r.buffer;
          case On:
            return !(n.byteLength != r.byteLength || !v(new wo(n), new wo(r)));
          case kt:
          case Ft:
          case Kn:
            return Pn(+n, +r);
          case ie:
            return n.name == r.name && n.message == r.message;
          case We:
          case oe:
            return n == r + "";
          case hn:
            var E = ms;
          case dn:
            var R = c & S;
            if (E || (E = po), n.size != r.size && !R)
              return !1;
            var P = x.get(n);
            if (P)
              return P == r;
            c |= b, x.set(n, r);
            var N = vl(E(n), E(r), c, g, v, x);
            return x.delete(n), N;
          case cr:
            if (hi)
              return hi.call(n) == hi.call(r);
        }
        return !1;
      }
      function Tv(n, r, a, c, g, v) {
        var x = a & S, E = Gs(n), R = E.length, P = Gs(r), N = P.length;
        if (R != N && !x)
          return !1;
        for (var D = R; D--; ) {
          var G = E[D];
          if (!(x ? G in r : mt.call(r, G)))
            return !1;
        }
        var Y = v.get(n), Z = v.get(r);
        if (Y && Z)
          return Y == r && Z == n;
        var at = !0;
        v.set(n, r), v.set(r, n);
        for (var J = x; ++D < R; ) {
          G = E[D];
          var ct = n[G], ht = r[G];
          if (c)
            var mn = x ? c(ht, ct, G, r, n, v) : c(ct, ht, G, n, r, v);
          if (!(mn === i ? ct === ht || g(ct, ht, a, c, v) : mn)) {
            at = !1;
            break;
          }
          J || (J = G == "constructor");
        }
        if (at && !J) {
          var tn = n.constructor, yn = r.constructor;
          tn != yn && "constructor" in n && "constructor" in r && !(typeof tn == "function" && tn instanceof tn && typeof yn == "function" && yn instanceof yn) && (at = !1);
        }
        return v.delete(n), v.delete(r), at;
      }
      function le(n) {
        return Zs(El(n, i, Ll), n + "");
      }
      function Gs(n) {
        return Df(n, Ut, Ks);
      }
      function js(n) {
        return Df(n, un, ml);
      }
      var zs = Co ? function(n) {
        return Co.get(n);
      } : fu;
      function Wo(n) {
        for (var r = n.name + "", a = xr[r], c = mt.call(xr, r) ? a.length : 0; c--; ) {
          var g = a[c], v = g.func;
          if (v == null || v == n)
            return g.name;
        }
        return r;
      }
      function Tr(n) {
        var r = mt.call(p, "placeholder") ? p : n;
        return r.placeholder;
      }
      function V() {
        var n = p.iteratee || uu;
        return n = n === uu ? Bf : n, arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function Uo(n, r) {
        var a = n.__data__;
        return Lv(r) ? a[typeof r == "string" ? "string" : "hash"] : a.map;
      }
      function Xs(n) {
        for (var r = Ut(n), a = r.length; a--; ) {
          var c = r[a], g = n[c];
          r[a] = [c, g, wl(g)];
        }
        return r;
      }
      function qe(n, r) {
        var a = Np(n, r);
        return Hf(a) ? a : i;
      }
      function $v(n) {
        var r = mt.call(n, je), a = n[je];
        try {
          n[je] = i;
          var c = !0;
        } catch {
        }
        var g = yo.call(n);
        return c && (r ? n[je] = a : delete n[je]), g;
      }
      var Ks = xs ? function(n) {
        return n == null ? [] : (n = xt(n), Re(xs(n), function(r) {
          return Tf.call(n, r);
        }));
      } : lu, ml = xs ? function(n) {
        for (var r = []; n; )
          Ce(r, Ks(n)), n = Ao(n);
        return r;
      } : lu, Vt = Jt;
      (ws && Vt(new ws(new ArrayBuffer(1))) != $e || ci && Vt(new ci()) != hn || As && Vt(As.resolve()) != Vr || yr && Vt(new yr()) != dn || fi && Vt(new fi()) != Te) && (Vt = function(n) {
        var r = Jt(n), a = r == xn ? n.constructor : i, c = a ? Ve(a) : "";
        if (c)
          switch (c) {
            case s_:
              return $e;
            case u_:
              return hn;
            case c_:
              return Vr;
            case f_:
              return dn;
            case l_:
              return Te;
          }
        return r;
      });
      function Rv(n, r, a) {
        for (var c = -1, g = a.length; ++c < g; ) {
          var v = a[c], x = v.size;
          switch (v.type) {
            case "drop":
              n += x;
              break;
            case "dropRight":
              r -= x;
              break;
            case "take":
              r = qt(r, n + x);
              break;
            case "takeRight":
              n = Bt(n, r - x);
              break;
          }
        }
        return { start: n, end: r };
      }
      function Cv(n) {
        var r = n.match(es);
        return r ? r[1].split(A) : [];
      }
      function yl(n, r, a) {
        r = Le(r, n);
        for (var c = -1, g = r.length, v = !1; ++c < g; ) {
          var x = Vn(r[c]);
          if (!(v = n != null && a(n, x)))
            break;
          n = n[x];
        }
        return v || ++c != g ? v : (g = n == null ? 0 : n.length, !!g && qo(g) && he(x, g) && (it(n) || Ze(n)));
      }
      function Sv(n) {
        var r = n.length, a = new n.constructor(r);
        return r && typeof n[0] == "string" && mt.call(n, "index") && (a.index = n.index, a.input = n.input), a;
      }
      function xl(n) {
        return typeof n.constructor == "function" && !yi(n) ? wr(Ao(n)) : {};
      }
      function bv(n, r, a) {
        var c = n.constructor;
        switch (r) {
          case On:
            return Bs(n);
          case kt:
          case Ft:
            return new c(+n);
          case $e:
            return hv(n, a);
          case fr:
          case lr:
          case Ue:
          case Zr:
          case Jr:
          case Qr:
          case ti:
          case ni:
          case ei:
            return el(n, a);
          case hn:
            return new c();
          case Kn:
          case oe:
            return new c(n);
          case We:
            return dv(n);
          case dn:
            return new c();
          case cr:
            return gv(n);
        }
      }
      function Ov(n, r) {
        var a = r.length;
        if (!a)
          return n;
        var c = a - 1;
        return r[c] = (a > 1 ? "& " : "") + r[c], r = r.join(a > 2 ? ", " : " "), n.replace(ns, `{
/* [wrapped with ` + r + `] */
`);
      }
      function Iv(n) {
        return it(n) || Ze(n) || !!($f && n && n[$f]);
      }
      function he(n, r) {
        var a = typeof n;
        return r = r ?? St, !!r && (a == "number" || a != "symbol" && bt.test(n)) && n > -1 && n % 1 == 0 && n < r;
      }
      function Qt(n, r, a) {
        if (!Ct(a))
          return !1;
        var c = typeof r;
        return (c == "number" ? sn(a) && he(r, a.length) : c == "string" && r in a) ? Pn(a[r], n) : !1;
      }
      function Ys(n, r) {
        if (it(n))
          return !1;
        var a = typeof n;
        return a == "number" || a == "symbol" || a == "boolean" || n == null || vn(n) ? !0 : uo.test(n) || !so.test(n) || r != null && n in xt(r);
      }
      function Lv(n) {
        var r = typeof n;
        return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
      }
      function qs(n) {
        var r = Wo(n), a = p[r];
        if (typeof a != "function" || !(r in lt.prototype))
          return !1;
        if (n === a)
          return !0;
        var c = zs(a);
        return !!c && n === c[0];
      }
      function Mv(n) {
        return !!wf && wf in n;
      }
      var Pv = vo ? de : hu;
      function yi(n) {
        var r = n && n.constructor, a = typeof r == "function" && r.prototype || mr;
        return n === a;
      }
      function wl(n) {
        return n === n && !Ct(n);
      }
      function Al(n, r) {
        return function(a) {
          return a == null ? !1 : a[n] === r && (r !== i || n in xt(a));
        };
      }
      function Nv(n) {
        var r = Ko(n, function(c) {
          return a.size === d && a.clear(), c;
        }), a = r.cache;
        return r;
      }
      function kv(n, r) {
        var a = n[1], c = r[1], g = a | c, v = g < (M | I | K), x = c == K && a == H || c == K && a == q && n[7].length <= r[8] || c == (K | q) && r[7].length <= r[8] && a == H;
        if (!(v || x))
          return n;
        c & M && (n[2] = r[2], g |= a & M ? 0 : C);
        var E = r[3];
        if (E) {
          var R = n[3];
          n[3] = R ? il(R, E, r[4]) : E, n[4] = R ? Se(n[3], _) : r[4];
        }
        return E = r[5], E && (R = n[5], n[5] = R ? ol(R, E, r[6]) : E, n[6] = R ? Se(n[5], _) : r[6]), E = r[7], E && (n[7] = E), c & K && (n[8] = n[8] == null ? r[8] : qt(n[8], r[8])), n[9] == null && (n[9] = r[9]), n[0] = r[0], n[1] = g, n;
      }
      function Dv(n) {
        var r = [];
        if (n != null)
          for (var a in xt(n))
            r.push(a);
        return r;
      }
      function Fv(n) {
        return yo.call(n);
      }
      function El(n, r, a) {
        return r = Bt(r === i ? n.length - 1 : r, 0), function() {
          for (var c = arguments, g = -1, v = Bt(c.length - r, 0), x = O(v); ++g < v; )
            x[g] = c[r + g];
          g = -1;
          for (var E = O(r + 1); ++g < r; )
            E[g] = c[g];
          return E[r] = a(x), gn(n, this, E);
        };
      }
      function Tl(n, r) {
        return r.length < 2 ? n : Ye(n, Rn(r, 0, -1));
      }
      function Hv(n, r) {
        for (var a = n.length, c = qt(r.length, a), g = an(n); c--; ) {
          var v = r[c];
          n[c] = he(v, a) ? g[v] : i;
        }
        return n;
      }
      function Vs(n, r) {
        if (!(r === "constructor" && typeof n[r] == "function") && r != "__proto__")
          return n[r];
      }
      var $l = Cl(Yf), xi = t_ || function(n, r) {
        return zt.setTimeout(n, r);
      }, Zs = Cl(uv);
      function Rl(n, r, a) {
        var c = r + "";
        return Zs(n, Ov(c, Bv(Cv(c), a)));
      }
      function Cl(n) {
        var r = 0, a = 0;
        return function() {
          var c = i_(), g = nt - (c - a);
          if (a = c, g > 0) {
            if (++r >= et)
              return arguments[0];
          } else
            r = 0;
          return n.apply(i, arguments);
        };
      }
      function Go(n, r) {
        var a = -1, c = n.length, g = c - 1;
        for (r = r === i ? c : r; ++a < r; ) {
          var v = Ms(a, g), x = n[v];
          n[v] = n[a], n[a] = x;
        }
        return n.length = r, n;
      }
      var Sl = Nv(function(n) {
        var r = [];
        return n.charCodeAt(0) === 46 && r.push(""), n.replace(Qa, function(a, c, g, v) {
          r.push(g ? v.replace(Q, "$1") : c || a);
        }), r;
      });
      function Vn(n) {
        if (typeof n == "string" || vn(n))
          return n;
        var r = n + "";
        return r == "0" && 1 / n == -gt ? "-0" : r;
      }
      function Ve(n) {
        if (n != null) {
          try {
            return mo.call(n);
          } catch {
          }
          try {
            return n + "";
          } catch {
          }
        }
        return "";
      }
      function Bv(n, r) {
        return An(qr, function(a) {
          var c = "_." + a[0];
          r & a[1] && !ho(n, c) && n.push(c);
        }), n.sort();
      }
      function bl(n) {
        if (n instanceof lt)
          return n.clone();
        var r = new Tn(n.__wrapped__, n.__chain__);
        return r.__actions__ = an(n.__actions__), r.__index__ = n.__index__, r.__values__ = n.__values__, r;
      }
      function Wv(n, r, a) {
        (a ? Qt(n, r, a) : r === i) ? r = 1 : r = Bt(ot(r), 0);
        var c = n == null ? 0 : n.length;
        if (!c || r < 1)
          return [];
        for (var g = 0, v = 0, x = O($o(c / r)); g < c; )
          x[v++] = Rn(n, g, g += r);
        return x;
      }
      function Uv(n) {
        for (var r = -1, a = n == null ? 0 : n.length, c = 0, g = []; ++r < a; ) {
          var v = n[r];
          v && (g[c++] = v);
        }
        return g;
      }
      function Gv() {
        var n = arguments.length;
        if (!n)
          return [];
        for (var r = O(n - 1), a = arguments[0], c = n; c--; )
          r[c - 1] = arguments[c];
        return Ce(it(a) ? an(a) : [a], Xt(r, 1));
      }
      var jv = st(function(n, r) {
        return It(n) ? gi(n, Xt(r, 1, It, !0)) : [];
      }), zv = st(function(n, r) {
        var a = Cn(r);
        return It(a) && (a = i), It(n) ? gi(n, Xt(r, 1, It, !0), V(a, 2)) : [];
      }), Xv = st(function(n, r) {
        var a = Cn(r);
        return It(a) && (a = i), It(n) ? gi(n, Xt(r, 1, It, !0), i, a) : [];
      });
      function Kv(n, r, a) {
        var c = n == null ? 0 : n.length;
        return c ? (r = a || r === i ? 1 : ot(r), Rn(n, r < 0 ? 0 : r, c)) : [];
      }
      function Yv(n, r, a) {
        var c = n == null ? 0 : n.length;
        return c ? (r = a || r === i ? 1 : ot(r), r = c - r, Rn(n, 0, r < 0 ? 0 : r)) : [];
      }
      function qv(n, r) {
        return n && n.length ? No(n, V(r, 3), !0, !0) : [];
      }
      function Vv(n, r) {
        return n && n.length ? No(n, V(r, 3), !0) : [];
      }
      function Zv(n, r, a, c) {
        var g = n == null ? 0 : n.length;
        return g ? (a && typeof a != "number" && Qt(n, r, a) && (a = 0, c = g), G_(n, r, a, c)) : [];
      }
      function Ol(n, r, a) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var g = a == null ? 0 : ot(a);
        return g < 0 && (g = Bt(c + g, 0)), go(n, V(r, 3), g);
      }
      function Il(n, r, a) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var g = c - 1;
        return a !== i && (g = ot(a), g = a < 0 ? Bt(c + g, 0) : qt(g, c - 1)), go(n, V(r, 3), g, !0);
      }
      function Ll(n) {
        var r = n == null ? 0 : n.length;
        return r ? Xt(n, 1) : [];
      }
      function Jv(n) {
        var r = n == null ? 0 : n.length;
        return r ? Xt(n, gt) : [];
      }
      function Qv(n, r) {
        var a = n == null ? 0 : n.length;
        return a ? (r = r === i ? 1 : ot(r), Xt(n, r)) : [];
      }
      function t1(n) {
        for (var r = -1, a = n == null ? 0 : n.length, c = {}; ++r < a; ) {
          var g = n[r];
          c[g[0]] = g[1];
        }
        return c;
      }
      function Ml(n) {
        return n && n.length ? n[0] : i;
      }
      function n1(n, r, a) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var g = a == null ? 0 : ot(a);
        return g < 0 && (g = Bt(c + g, 0)), gr(n, r, g);
      }
      function e1(n) {
        var r = n == null ? 0 : n.length;
        return r ? Rn(n, 0, -1) : [];
      }
      var r1 = st(function(n) {
        var r = $t(n, Fs);
        return r.length && r[0] === n[0] ? Ss(r) : [];
      }), i1 = st(function(n) {
        var r = Cn(n), a = $t(n, Fs);
        return r === Cn(a) ? r = i : a.pop(), a.length && a[0] === n[0] ? Ss(a, V(r, 2)) : [];
      }), o1 = st(function(n) {
        var r = Cn(n), a = $t(n, Fs);
        return r = typeof r == "function" ? r : i, r && a.pop(), a.length && a[0] === n[0] ? Ss(a, i, r) : [];
      });
      function a1(n, r) {
        return n == null ? "" : e_.call(n, r);
      }
      function Cn(n) {
        var r = n == null ? 0 : n.length;
        return r ? n[r - 1] : i;
      }
      function s1(n, r, a) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var g = c;
        return a !== i && (g = ot(a), g = g < 0 ? Bt(c + g, 0) : qt(g, c - 1)), r === r ? Bp(n, r, g) : go(n, df, g, !0);
      }
      function u1(n, r) {
        return n && n.length ? jf(n, ot(r)) : i;
      }
      var c1 = st(Pl);
      function Pl(n, r) {
        return n && n.length && r && r.length ? Ls(n, r) : n;
      }
      function f1(n, r, a) {
        return n && n.length && r && r.length ? Ls(n, r, V(a, 2)) : n;
      }
      function l1(n, r, a) {
        return n && n.length && r && r.length ? Ls(n, r, i, a) : n;
      }
      var h1 = le(function(n, r) {
        var a = n == null ? 0 : n.length, c = Ts(n, r);
        return Kf(n, $t(r, function(g) {
          return he(g, a) ? +g : g;
        }).sort(rl)), c;
      });
      function d1(n, r) {
        var a = [];
        if (!(n && n.length))
          return a;
        var c = -1, g = [], v = n.length;
        for (r = V(r, 3); ++c < v; ) {
          var x = n[c];
          r(x, c, n) && (a.push(x), g.push(c));
        }
        return Kf(n, g), a;
      }
      function Js(n) {
        return n == null ? n : a_.call(n);
      }
      function g1(n, r, a) {
        var c = n == null ? 0 : n.length;
        return c ? (a && typeof a != "number" && Qt(n, r, a) ? (r = 0, a = c) : (r = r == null ? 0 : ot(r), a = a === i ? c : ot(a)), Rn(n, r, a)) : [];
      }
      function p1(n, r) {
        return Po(n, r);
      }
      function _1(n, r, a) {
        return Ns(n, r, V(a, 2));
      }
      function v1(n, r) {
        var a = n == null ? 0 : n.length;
        if (a) {
          var c = Po(n, r);
          if (c < a && Pn(n[c], r))
            return c;
        }
        return -1;
      }
      function m1(n, r) {
        return Po(n, r, !0);
      }
      function y1(n, r, a) {
        return Ns(n, r, V(a, 2), !0);
      }
      function x1(n, r) {
        var a = n == null ? 0 : n.length;
        if (a) {
          var c = Po(n, r, !0) - 1;
          if (Pn(n[c], r))
            return c;
        }
        return -1;
      }
      function w1(n) {
        return n && n.length ? qf(n) : [];
      }
      function A1(n, r) {
        return n && n.length ? qf(n, V(r, 2)) : [];
      }
      function E1(n) {
        var r = n == null ? 0 : n.length;
        return r ? Rn(n, 1, r) : [];
      }
      function T1(n, r, a) {
        return n && n.length ? (r = a || r === i ? 1 : ot(r), Rn(n, 0, r < 0 ? 0 : r)) : [];
      }
      function $1(n, r, a) {
        var c = n == null ? 0 : n.length;
        return c ? (r = a || r === i ? 1 : ot(r), r = c - r, Rn(n, r < 0 ? 0 : r, c)) : [];
      }
      function R1(n, r) {
        return n && n.length ? No(n, V(r, 3), !1, !0) : [];
      }
      function C1(n, r) {
        return n && n.length ? No(n, V(r, 3)) : [];
      }
      var S1 = st(function(n) {
        return Ie(Xt(n, 1, It, !0));
      }), b1 = st(function(n) {
        var r = Cn(n);
        return It(r) && (r = i), Ie(Xt(n, 1, It, !0), V(r, 2));
      }), O1 = st(function(n) {
        var r = Cn(n);
        return r = typeof r == "function" ? r : i, Ie(Xt(n, 1, It, !0), i, r);
      });
      function I1(n) {
        return n && n.length ? Ie(n) : [];
      }
      function L1(n, r) {
        return n && n.length ? Ie(n, V(r, 2)) : [];
      }
      function M1(n, r) {
        return r = typeof r == "function" ? r : i, n && n.length ? Ie(n, i, r) : [];
      }
      function Qs(n) {
        if (!(n && n.length))
          return [];
        var r = 0;
        return n = Re(n, function(a) {
          if (It(a))
            return r = Bt(a.length, r), !0;
        }), _s(r, function(a) {
          return $t(n, ds(a));
        });
      }
      function Nl(n, r) {
        if (!(n && n.length))
          return [];
        var a = Qs(n);
        return r == null ? a : $t(a, function(c) {
          return gn(r, i, c);
        });
      }
      var P1 = st(function(n, r) {
        return It(n) ? gi(n, r) : [];
      }), N1 = st(function(n) {
        return Ds(Re(n, It));
      }), k1 = st(function(n) {
        var r = Cn(n);
        return It(r) && (r = i), Ds(Re(n, It), V(r, 2));
      }), D1 = st(function(n) {
        var r = Cn(n);
        return r = typeof r == "function" ? r : i, Ds(Re(n, It), i, r);
      }), F1 = st(Qs);
      function H1(n, r) {
        return Qf(n || [], r || [], di);
      }
      function B1(n, r) {
        return Qf(n || [], r || [], vi);
      }
      var W1 = st(function(n) {
        var r = n.length, a = r > 1 ? n[r - 1] : i;
        return a = typeof a == "function" ? (n.pop(), a) : i, Nl(n, a);
      });
      function kl(n) {
        var r = p(n);
        return r.__chain__ = !0, r;
      }
      function U1(n, r) {
        return r(n), n;
      }
      function jo(n, r) {
        return r(n);
      }
      var G1 = le(function(n) {
        var r = n.length, a = r ? n[0] : 0, c = this.__wrapped__, g = function(v) {
          return Ts(v, n);
        };
        return r > 1 || this.__actions__.length || !(c instanceof lt) || !he(a) ? this.thru(g) : (c = c.slice(a, +a + (r ? 1 : 0)), c.__actions__.push({
          func: jo,
          args: [g],
          thisArg: i
        }), new Tn(c, this.__chain__).thru(function(v) {
          return r && !v.length && v.push(i), v;
        }));
      });
      function j1() {
        return kl(this);
      }
      function z1() {
        return new Tn(this.value(), this.__chain__);
      }
      function X1() {
        this.__values__ === i && (this.__values__ = Vl(this.value()));
        var n = this.__index__ >= this.__values__.length, r = n ? i : this.__values__[this.__index__++];
        return { done: n, value: r };
      }
      function K1() {
        return this;
      }
      function Y1(n) {
        for (var r, a = this; a instanceof bo; ) {
          var c = bl(a);
          c.__index__ = 0, c.__values__ = i, r ? g.__wrapped__ = c : r = c;
          var g = c;
          a = a.__wrapped__;
        }
        return g.__wrapped__ = n, r;
      }
      function q1() {
        var n = this.__wrapped__;
        if (n instanceof lt) {
          var r = n;
          return this.__actions__.length && (r = new lt(this)), r = r.reverse(), r.__actions__.push({
            func: jo,
            args: [Js],
            thisArg: i
          }), new Tn(r, this.__chain__);
        }
        return this.thru(Js);
      }
      function V1() {
        return Jf(this.__wrapped__, this.__actions__);
      }
      var Z1 = ko(function(n, r, a) {
        mt.call(n, a) ? ++n[a] : ce(n, a, 1);
      });
      function J1(n, r, a) {
        var c = it(n) ? lf : U_;
        return a && Qt(n, r, a) && (r = i), c(n, V(r, 3));
      }
      function Q1(n, r) {
        var a = it(n) ? Re : Nf;
        return a(n, V(r, 3));
      }
      var tm = cl(Ol), nm = cl(Il);
      function em(n, r) {
        return Xt(zo(n, r), 1);
      }
      function rm(n, r) {
        return Xt(zo(n, r), gt);
      }
      function im(n, r, a) {
        return a = a === i ? 1 : ot(a), Xt(zo(n, r), a);
      }
      function Dl(n, r) {
        var a = it(n) ? An : Oe;
        return a(n, V(r, 3));
      }
      function Fl(n, r) {
        var a = it(n) ? Ep : Pf;
        return a(n, V(r, 3));
      }
      var om = ko(function(n, r, a) {
        mt.call(n, a) ? n[a].push(r) : ce(n, a, [r]);
      });
      function am(n, r, a, c) {
        n = sn(n) ? n : Rr(n), a = a && !c ? ot(a) : 0;
        var g = n.length;
        return a < 0 && (a = Bt(g + a, 0)), Vo(n) ? a <= g && n.indexOf(r, a) > -1 : !!g && gr(n, r, a) > -1;
      }
      var sm = st(function(n, r, a) {
        var c = -1, g = typeof r == "function", v = sn(n) ? O(n.length) : [];
        return Oe(n, function(x) {
          v[++c] = g ? gn(r, x, a) : pi(x, r, a);
        }), v;
      }), um = ko(function(n, r, a) {
        ce(n, a, r);
      });
      function zo(n, r) {
        var a = it(n) ? $t : Wf;
        return a(n, V(r, 3));
      }
      function cm(n, r, a, c) {
        return n == null ? [] : (it(r) || (r = r == null ? [] : [r]), a = c ? i : a, it(a) || (a = a == null ? [] : [a]), zf(n, r, a));
      }
      var fm = ko(function(n, r, a) {
        n[a ? 0 : 1].push(r);
      }, function() {
        return [[], []];
      });
      function lm(n, r, a) {
        var c = it(n) ? ls : pf, g = arguments.length < 3;
        return c(n, V(r, 4), a, g, Oe);
      }
      function hm(n, r, a) {
        var c = it(n) ? Tp : pf, g = arguments.length < 3;
        return c(n, V(r, 4), a, g, Pf);
      }
      function dm(n, r) {
        var a = it(n) ? Re : Nf;
        return a(n, Yo(V(r, 3)));
      }
      function gm(n) {
        var r = it(n) ? Of : av;
        return r(n);
      }
      function pm(n, r, a) {
        (a ? Qt(n, r, a) : r === i) ? r = 1 : r = ot(r);
        var c = it(n) ? D_ : sv;
        return c(n, r);
      }
      function _m(n) {
        var r = it(n) ? F_ : cv;
        return r(n);
      }
      function vm(n) {
        if (n == null)
          return 0;
        if (sn(n))
          return Vo(n) ? _r(n) : n.length;
        var r = Vt(n);
        return r == hn || r == dn ? n.size : Os(n).length;
      }
      function mm(n, r, a) {
        var c = it(n) ? hs : fv;
        return a && Qt(n, r, a) && (r = i), c(n, V(r, 3));
      }
      var ym = st(function(n, r) {
        if (n == null)
          return [];
        var a = r.length;
        return a > 1 && Qt(n, r[0], r[1]) ? r = [] : a > 2 && Qt(r[0], r[1], r[2]) && (r = [r[0]]), zf(n, Xt(r, 1), []);
      }), Xo = Qp || function() {
        return zt.Date.now();
      };
      function xm(n, r) {
        if (typeof r != "function")
          throw new En(f);
        return n = ot(n), function() {
          if (--n < 1)
            return r.apply(this, arguments);
        };
      }
      function Hl(n, r, a) {
        return r = a ? i : r, r = n && r == null ? n.length : r, fe(n, K, i, i, i, i, r);
      }
      function Bl(n, r) {
        var a;
        if (typeof r != "function")
          throw new En(f);
        return n = ot(n), function() {
          return --n > 0 && (a = r.apply(this, arguments)), n <= 1 && (r = i), a;
        };
      }
      var tu = st(function(n, r, a) {
        var c = M;
        if (a.length) {
          var g = Se(a, Tr(tu));
          c |= k;
        }
        return fe(n, c, r, a, g);
      }), Wl = st(function(n, r, a) {
        var c = M | I;
        if (a.length) {
          var g = Se(a, Tr(Wl));
          c |= k;
        }
        return fe(r, c, n, a, g);
      });
      function Ul(n, r, a) {
        r = a ? i : r;
        var c = fe(n, H, i, i, i, i, i, r);
        return c.placeholder = Ul.placeholder, c;
      }
      function Gl(n, r, a) {
        r = a ? i : r;
        var c = fe(n, B, i, i, i, i, i, r);
        return c.placeholder = Gl.placeholder, c;
      }
      function jl(n, r, a) {
        var c, g, v, x, E, R, P = 0, N = !1, D = !1, G = !0;
        if (typeof n != "function")
          throw new En(f);
        r = Sn(r) || 0, Ct(a) && (N = !!a.leading, D = "maxWait" in a, v = D ? Bt(Sn(a.maxWait) || 0, r) : v, G = "trailing" in a ? !!a.trailing : G);
        function Y(Lt) {
          var Nn = c, pe = g;
          return c = g = i, P = Lt, x = n.apply(pe, Nn), x;
        }
        function Z(Lt) {
          return P = Lt, E = xi(ct, r), N ? Y(Lt) : x;
        }
        function at(Lt) {
          var Nn = Lt - R, pe = Lt - P, ch = r - Nn;
          return D ? qt(ch, v - pe) : ch;
        }
        function J(Lt) {
          var Nn = Lt - R, pe = Lt - P;
          return R === i || Nn >= r || Nn < 0 || D && pe >= v;
        }
        function ct() {
          var Lt = Xo();
          if (J(Lt))
            return ht(Lt);
          E = xi(ct, at(Lt));
        }
        function ht(Lt) {
          return E = i, G && c ? Y(Lt) : (c = g = i, x);
        }
        function mn() {
          E !== i && tl(E), P = 0, c = R = g = E = i;
        }
        function tn() {
          return E === i ? x : ht(Xo());
        }
        function yn() {
          var Lt = Xo(), Nn = J(Lt);
          if (c = arguments, g = this, R = Lt, Nn) {
            if (E === i)
              return Z(R);
            if (D)
              return tl(E), E = xi(ct, r), Y(R);
          }
          return E === i && (E = xi(ct, r)), x;
        }
        return yn.cancel = mn, yn.flush = tn, yn;
      }
      var wm = st(function(n, r) {
        return Mf(n, 1, r);
      }), Am = st(function(n, r, a) {
        return Mf(n, Sn(r) || 0, a);
      });
      function Em(n) {
        return fe(n, tt);
      }
      function Ko(n, r) {
        if (typeof n != "function" || r != null && typeof r != "function")
          throw new En(f);
        var a = function() {
          var c = arguments, g = r ? r.apply(this, c) : c[0], v = a.cache;
          if (v.has(g))
            return v.get(g);
          var x = n.apply(this, c);
          return a.cache = v.set(g, x) || v, x;
        };
        return a.cache = new (Ko.Cache || ue)(), a;
      }
      Ko.Cache = ue;
      function Yo(n) {
        if (typeof n != "function")
          throw new En(f);
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, r[0]);
            case 2:
              return !n.call(this, r[0], r[1]);
            case 3:
              return !n.call(this, r[0], r[1], r[2]);
          }
          return !n.apply(this, r);
        };
      }
      function Tm(n) {
        return Bl(2, n);
      }
      var $m = lv(function(n, r) {
        r = r.length == 1 && it(r[0]) ? $t(r[0], pn(V())) : $t(Xt(r, 1), pn(V()));
        var a = r.length;
        return st(function(c) {
          for (var g = -1, v = qt(c.length, a); ++g < v; )
            c[g] = r[g].call(this, c[g]);
          return gn(n, this, c);
        });
      }), nu = st(function(n, r) {
        var a = Se(r, Tr(nu));
        return fe(n, k, i, r, a);
      }), zl = st(function(n, r) {
        var a = Se(r, Tr(zl));
        return fe(n, W, i, r, a);
      }), Rm = le(function(n, r) {
        return fe(n, q, i, i, i, r);
      });
      function Cm(n, r) {
        if (typeof n != "function")
          throw new En(f);
        return r = r === i ? r : ot(r), st(n, r);
      }
      function Sm(n, r) {
        if (typeof n != "function")
          throw new En(f);
        return r = r == null ? 0 : Bt(ot(r), 0), st(function(a) {
          var c = a[r], g = Me(a, 0, r);
          return c && Ce(g, c), gn(n, this, g);
        });
      }
      function bm(n, r, a) {
        var c = !0, g = !0;
        if (typeof n != "function")
          throw new En(f);
        return Ct(a) && (c = "leading" in a ? !!a.leading : c, g = "trailing" in a ? !!a.trailing : g), jl(n, r, {
          leading: c,
          maxWait: r,
          trailing: g
        });
      }
      function Om(n) {
        return Hl(n, 1);
      }
      function Im(n, r) {
        return nu(Hs(r), n);
      }
      function Lm() {
        if (!arguments.length)
          return [];
        var n = arguments[0];
        return it(n) ? n : [n];
      }
      function Mm(n) {
        return $n(n, T);
      }
      function Pm(n, r) {
        return r = typeof r == "function" ? r : i, $n(n, T, r);
      }
      function Nm(n) {
        return $n(n, y | T);
      }
      function km(n, r) {
        return r = typeof r == "function" ? r : i, $n(n, y | T, r);
      }
      function Dm(n, r) {
        return r == null || Lf(n, r, Ut(r));
      }
      function Pn(n, r) {
        return n === r || n !== n && r !== r;
      }
      var Fm = Bo(Cs), Hm = Bo(function(n, r) {
        return n >= r;
      }), Ze = Ff(function() {
        return arguments;
      }()) ? Ff : function(n) {
        return Ot(n) && mt.call(n, "callee") && !Tf.call(n, "callee");
      }, it = O.isArray, Bm = of ? pn(of) : Y_;
      function sn(n) {
        return n != null && qo(n.length) && !de(n);
      }
      function It(n) {
        return Ot(n) && sn(n);
      }
      function Wm(n) {
        return n === !0 || n === !1 || Ot(n) && Jt(n) == kt;
      }
      var Pe = n_ || hu, Um = af ? pn(af) : q_;
      function Gm(n) {
        return Ot(n) && n.nodeType === 1 && !wi(n);
      }
      function jm(n) {
        if (n == null)
          return !0;
        if (sn(n) && (it(n) || typeof n == "string" || typeof n.splice == "function" || Pe(n) || $r(n) || Ze(n)))
          return !n.length;
        var r = Vt(n);
        if (r == hn || r == dn)
          return !n.size;
        if (yi(n))
          return !Os(n).length;
        for (var a in n)
          if (mt.call(n, a))
            return !1;
        return !0;
      }
      function zm(n, r) {
        return _i(n, r);
      }
      function Xm(n, r, a) {
        a = typeof a == "function" ? a : i;
        var c = a ? a(n, r) : i;
        return c === i ? _i(n, r, i, a) : !!c;
      }
      function eu(n) {
        if (!Ot(n))
          return !1;
        var r = Jt(n);
        return r == ie || r == bn || typeof n.message == "string" && typeof n.name == "string" && !wi(n);
      }
      function Km(n) {
        return typeof n == "number" && Rf(n);
      }
      function de(n) {
        if (!Ct(n))
          return !1;
        var r = Jt(n);
        return r == Be || r == no || r == He || r == ur;
      }
      function Xl(n) {
        return typeof n == "number" && n == ot(n);
      }
      function qo(n) {
        return typeof n == "number" && n > -1 && n % 1 == 0 && n <= St;
      }
      function Ct(n) {
        var r = typeof n;
        return n != null && (r == "object" || r == "function");
      }
      function Ot(n) {
        return n != null && typeof n == "object";
      }
      var Kl = sf ? pn(sf) : Z_;
      function Ym(n, r) {
        return n === r || bs(n, r, Xs(r));
      }
      function qm(n, r, a) {
        return a = typeof a == "function" ? a : i, bs(n, r, Xs(r), a);
      }
      function Vm(n) {
        return Yl(n) && n != +n;
      }
      function Zm(n) {
        if (Pv(n))
          throw new rt(u);
        return Hf(n);
      }
      function Jm(n) {
        return n === null;
      }
      function Qm(n) {
        return n == null;
      }
      function Yl(n) {
        return typeof n == "number" || Ot(n) && Jt(n) == Kn;
      }
      function wi(n) {
        if (!Ot(n) || Jt(n) != xn)
          return !1;
        var r = Ao(n);
        if (r === null)
          return !0;
        var a = mt.call(r, "constructor") && r.constructor;
        return typeof a == "function" && a instanceof a && mo.call(a) == qp;
      }
      var ru = uf ? pn(uf) : J_;
      function ty(n) {
        return Xl(n) && n >= -St && n <= St;
      }
      var ql = cf ? pn(cf) : Q_;
      function Vo(n) {
        return typeof n == "string" || !it(n) && Ot(n) && Jt(n) == oe;
      }
      function vn(n) {
        return typeof n == "symbol" || Ot(n) && Jt(n) == cr;
      }
      var $r = ff ? pn(ff) : tv;
      function ny(n) {
        return n === i;
      }
      function ey(n) {
        return Ot(n) && Vt(n) == Te;
      }
      function ry(n) {
        return Ot(n) && Jt(n) == eo;
      }
      var iy = Bo(Is), oy = Bo(function(n, r) {
        return n <= r;
      });
      function Vl(n) {
        if (!n)
          return [];
        if (sn(n))
          return Vo(n) ? Ln(n) : an(n);
        if (ui && n[ui])
          return Dp(n[ui]());
        var r = Vt(n), a = r == hn ? ms : r == dn ? po : Rr;
        return a(n);
      }
      function ge(n) {
        if (!n)
          return n === 0 ? n : 0;
        if (n = Sn(n), n === gt || n === -gt) {
          var r = n < 0 ? -1 : 1;
          return r * Nt;
        }
        return n === n ? n : 0;
      }
      function ot(n) {
        var r = ge(n), a = r % 1;
        return r === r ? a ? r - a : r : 0;
      }
      function Zl(n) {
        return n ? Ke(ot(n), 0, Gt) : 0;
      }
      function Sn(n) {
        if (typeof n == "number")
          return n;
        if (vn(n))
          return Wt;
        if (Ct(n)) {
          var r = typeof n.valueOf == "function" ? n.valueOf() : n;
          n = Ct(r) ? r + "" : r;
        }
        if (typeof n != "string")
          return n === 0 ? n : +n;
        n = _f(n);
        var a = ut.test(n);
        return a || Rt.test(n) ? xp(n.slice(2), a ? 2 : 8) : ft.test(n) ? Wt : +n;
      }
      function Jl(n) {
        return qn(n, un(n));
      }
      function ay(n) {
        return n ? Ke(ot(n), -St, St) : n === 0 ? n : 0;
      }
      function vt(n) {
        return n == null ? "" : _n(n);
      }
      var sy = Ar(function(n, r) {
        if (yi(r) || sn(r)) {
          qn(r, Ut(r), n);
          return;
        }
        for (var a in r)
          mt.call(r, a) && di(n, a, r[a]);
      }), Ql = Ar(function(n, r) {
        qn(r, un(r), n);
      }), Zo = Ar(function(n, r, a, c) {
        qn(r, un(r), n, c);
      }), uy = Ar(function(n, r, a, c) {
        qn(r, Ut(r), n, c);
      }), cy = le(Ts);
      function fy(n, r) {
        var a = wr(n);
        return r == null ? a : If(a, r);
      }
      var ly = st(function(n, r) {
        n = xt(n);
        var a = -1, c = r.length, g = c > 2 ? r[2] : i;
        for (g && Qt(r[0], r[1], g) && (c = 1); ++a < c; )
          for (var v = r[a], x = un(v), E = -1, R = x.length; ++E < R; ) {
            var P = x[E], N = n[P];
            (N === i || Pn(N, mr[P]) && !mt.call(n, P)) && (n[P] = v[P]);
          }
        return n;
      }), hy = st(function(n) {
        return n.push(i, _l), gn(th, i, n);
      });
      function dy(n, r) {
        return hf(n, V(r, 3), Yn);
      }
      function gy(n, r) {
        return hf(n, V(r, 3), Rs);
      }
      function py(n, r) {
        return n == null ? n : $s(n, V(r, 3), un);
      }
      function _y(n, r) {
        return n == null ? n : kf(n, V(r, 3), un);
      }
      function vy(n, r) {
        return n && Yn(n, V(r, 3));
      }
      function my(n, r) {
        return n && Rs(n, V(r, 3));
      }
      function yy(n) {
        return n == null ? [] : Lo(n, Ut(n));
      }
      function xy(n) {
        return n == null ? [] : Lo(n, un(n));
      }
      function iu(n, r, a) {
        var c = n == null ? i : Ye(n, r);
        return c === i ? a : c;
      }
      function wy(n, r) {
        return n != null && yl(n, r, j_);
      }
      function ou(n, r) {
        return n != null && yl(n, r, z_);
      }
      var Ay = ll(function(n, r, a) {
        r != null && typeof r.toString != "function" && (r = yo.call(r)), n[r] = a;
      }, su(cn)), Ey = ll(function(n, r, a) {
        r != null && typeof r.toString != "function" && (r = yo.call(r)), mt.call(n, r) ? n[r].push(a) : n[r] = [a];
      }, V), Ty = st(pi);
      function Ut(n) {
        return sn(n) ? bf(n) : Os(n);
      }
      function un(n) {
        return sn(n) ? bf(n, !0) : nv(n);
      }
      function $y(n, r) {
        var a = {};
        return r = V(r, 3), Yn(n, function(c, g, v) {
          ce(a, r(c, g, v), c);
        }), a;
      }
      function Ry(n, r) {
        var a = {};
        return r = V(r, 3), Yn(n, function(c, g, v) {
          ce(a, g, r(c, g, v));
        }), a;
      }
      var Cy = Ar(function(n, r, a) {
        Mo(n, r, a);
      }), th = Ar(function(n, r, a, c) {
        Mo(n, r, a, c);
      }), Sy = le(function(n, r) {
        var a = {};
        if (n == null)
          return a;
        var c = !1;
        r = $t(r, function(v) {
          return v = Le(v, n), c || (c = v.length > 1), v;
        }), qn(n, js(n), a), c && (a = $n(a, y | m | T, Av));
        for (var g = r.length; g--; )
          ks(a, r[g]);
        return a;
      });
      function by(n, r) {
        return nh(n, Yo(V(r)));
      }
      var Oy = le(function(n, r) {
        return n == null ? {} : rv(n, r);
      });
      function nh(n, r) {
        if (n == null)
          return {};
        var a = $t(js(n), function(c) {
          return [c];
        });
        return r = V(r), Xf(n, a, function(c, g) {
          return r(c, g[0]);
        });
      }
      function Iy(n, r, a) {
        r = Le(r, n);
        var c = -1, g = r.length;
        for (g || (g = 1, n = i); ++c < g; ) {
          var v = n == null ? i : n[Vn(r[c])];
          v === i && (c = g, v = a), n = de(v) ? v.call(n) : v;
        }
        return n;
      }
      function Ly(n, r, a) {
        return n == null ? n : vi(n, r, a);
      }
      function My(n, r, a, c) {
        return c = typeof c == "function" ? c : i, n == null ? n : vi(n, r, a, c);
      }
      var eh = gl(Ut), rh = gl(un);
      function Py(n, r, a) {
        var c = it(n), g = c || Pe(n) || $r(n);
        if (r = V(r, 4), a == null) {
          var v = n && n.constructor;
          g ? a = c ? new v() : [] : Ct(n) ? a = de(v) ? wr(Ao(n)) : {} : a = {};
        }
        return (g ? An : Yn)(n, function(x, E, R) {
          return r(a, x, E, R);
        }), a;
      }
      function Ny(n, r) {
        return n == null ? !0 : ks(n, r);
      }
      function ky(n, r, a) {
        return n == null ? n : Zf(n, r, Hs(a));
      }
      function Dy(n, r, a, c) {
        return c = typeof c == "function" ? c : i, n == null ? n : Zf(n, r, Hs(a), c);
      }
      function Rr(n) {
        return n == null ? [] : vs(n, Ut(n));
      }
      function Fy(n) {
        return n == null ? [] : vs(n, un(n));
      }
      function Hy(n, r, a) {
        return a === i && (a = r, r = i), a !== i && (a = Sn(a), a = a === a ? a : 0), r !== i && (r = Sn(r), r = r === r ? r : 0), Ke(Sn(n), r, a);
      }
      function By(n, r, a) {
        return r = ge(r), a === i ? (a = r, r = 0) : a = ge(a), n = Sn(n), X_(n, r, a);
      }
      function Wy(n, r, a) {
        if (a && typeof a != "boolean" && Qt(n, r, a) && (r = a = i), a === i && (typeof r == "boolean" ? (a = r, r = i) : typeof n == "boolean" && (a = n, n = i)), n === i && r === i ? (n = 0, r = 1) : (n = ge(n), r === i ? (r = n, n = 0) : r = ge(r)), n > r) {
          var c = n;
          n = r, r = c;
        }
        if (a || n % 1 || r % 1) {
          var g = Cf();
          return qt(n + g * (r - n + yp("1e-" + ((g + "").length - 1))), r);
        }
        return Ms(n, r);
      }
      var Uy = Er(function(n, r, a) {
        return r = r.toLowerCase(), n + (a ? ih(r) : r);
      });
      function ih(n) {
        return au(vt(n).toLowerCase());
      }
      function oh(n) {
        return n = vt(n), n && n.replace(rn, Lp).replace(cp, "");
      }
      function Gy(n, r, a) {
        n = vt(n), r = _n(r);
        var c = n.length;
        a = a === i ? c : Ke(ot(a), 0, c);
        var g = a;
        return a -= r.length, a >= 0 && n.slice(a, g) == r;
      }
      function jy(n) {
        return n = vt(n), n && io.test(n) ? n.replace(hr, Mp) : n;
      }
      function zy(n) {
        return n = vt(n), n && co.test(n) ? n.replace(oi, "\\$&") : n;
      }
      var Xy = Er(function(n, r, a) {
        return n + (a ? "-" : "") + r.toLowerCase();
      }), Ky = Er(function(n, r, a) {
        return n + (a ? " " : "") + r.toLowerCase();
      }), Yy = ul("toLowerCase");
      function qy(n, r, a) {
        n = vt(n), r = ot(r);
        var c = r ? _r(n) : 0;
        if (!r || c >= r)
          return n;
        var g = (r - c) / 2;
        return Ho(Ro(g), a) + n + Ho($o(g), a);
      }
      function Vy(n, r, a) {
        n = vt(n), r = ot(r);
        var c = r ? _r(n) : 0;
        return r && c < r ? n + Ho(r - c, a) : n;
      }
      function Zy(n, r, a) {
        n = vt(n), r = ot(r);
        var c = r ? _r(n) : 0;
        return r && c < r ? Ho(r - c, a) + n : n;
      }
      function Jy(n, r, a) {
        return a || r == null ? r = 0 : r && (r = +r), o_(vt(n).replace(ai, ""), r || 0);
      }
      function Qy(n, r, a) {
        return (a ? Qt(n, r, a) : r === i) ? r = 1 : r = ot(r), Ps(vt(n), r);
      }
      function tx() {
        var n = arguments, r = vt(n[0]);
        return n.length < 3 ? r : r.replace(n[1], n[2]);
      }
      var nx = Er(function(n, r, a) {
        return n + (a ? "_" : "") + r.toLowerCase();
      });
      function ex(n, r, a) {
        return a && typeof a != "number" && Qt(n, r, a) && (r = a = i), a = a === i ? Gt : a >>> 0, a ? (n = vt(n), n && (typeof r == "string" || r != null && !ru(r)) && (r = _n(r), !r && pr(n)) ? Me(Ln(n), 0, a) : n.split(r, a)) : [];
      }
      var rx = Er(function(n, r, a) {
        return n + (a ? " " : "") + au(r);
      });
      function ix(n, r, a) {
        return n = vt(n), a = a == null ? 0 : Ke(ot(a), 0, n.length), r = _n(r), n.slice(a, a + r.length) == r;
      }
      function ox(n, r, a) {
        var c = p.templateSettings;
        a && Qt(n, r, a) && (r = i), n = vt(n), r = Zo({}, r, c, pl);
        var g = Zo({}, r.imports, c.imports, pl), v = Ut(g), x = vs(g, v), E, R, P = 0, N = r.interpolate || In, D = "__p += '", G = ys(
          (r.escape || In).source + "|" + N.source + "|" + (N === ao ? dt : In).source + "|" + (r.evaluate || In).source + "|$",
          "g"
        ), Y = "//# sourceURL=" + (mt.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++gp + "]") + `
`;
        n.replace(G, function(J, ct, ht, mn, tn, yn) {
          return ht || (ht = mn), D += n.slice(P, yn).replace(fo, Pp), ct && (E = !0, D += `' +
__e(` + ct + `) +
'`), tn && (R = !0, D += `';
` + tn + `;
__p += '`), ht && (D += `' +
((__t = (` + ht + `)) == null ? '' : __t) +
'`), P = yn + J.length, J;
        }), D += `';
`;
        var Z = mt.call(r, "variable") && r.variable;
        if (!Z)
          D = `with (obj) {
` + D + `
}
`;
        else if (U.test(Z))
          throw new rt(l);
        D = (R ? D.replace(Za, "") : D).replace(ri, "$1").replace(ro, "$1;"), D = "function(" + (Z || "obj") + `) {
` + (Z ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (E ? ", __e = _.escape" : "") + (R ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + D + `return __p
}`;
        var at = sh(function() {
          return pt(v, Y + "return " + D).apply(i, x);
        });
        if (at.source = D, eu(at))
          throw at;
        return at;
      }
      function ax(n) {
        return vt(n).toLowerCase();
      }
      function sx(n) {
        return vt(n).toUpperCase();
      }
      function ux(n, r, a) {
        if (n = vt(n), n && (a || r === i))
          return _f(n);
        if (!n || !(r = _n(r)))
          return n;
        var c = Ln(n), g = Ln(r), v = vf(c, g), x = mf(c, g) + 1;
        return Me(c, v, x).join("");
      }
      function cx(n, r, a) {
        if (n = vt(n), n && (a || r === i))
          return n.slice(0, xf(n) + 1);
        if (!n || !(r = _n(r)))
          return n;
        var c = Ln(n), g = mf(c, Ln(r)) + 1;
        return Me(c, 0, g).join("");
      }
      function fx(n, r, a) {
        if (n = vt(n), n && (a || r === i))
          return n.replace(ai, "");
        if (!n || !(r = _n(r)))
          return n;
        var c = Ln(n), g = vf(c, Ln(r));
        return Me(c, g).join("");
      }
      function lx(n, r) {
        var a = X, c = j;
        if (Ct(r)) {
          var g = "separator" in r ? r.separator : g;
          a = "length" in r ? ot(r.length) : a, c = "omission" in r ? _n(r.omission) : c;
        }
        n = vt(n);
        var v = n.length;
        if (pr(n)) {
          var x = Ln(n);
          v = x.length;
        }
        if (a >= v)
          return n;
        var E = a - _r(c);
        if (E < 1)
          return c;
        var R = x ? Me(x, 0, E).join("") : n.slice(0, E);
        if (g === i)
          return R + c;
        if (x && (E += R.length - E), ru(g)) {
          if (n.slice(E).search(g)) {
            var P, N = R;
            for (g.global || (g = ys(g.source, vt(_t.exec(g)) + "g")), g.lastIndex = 0; P = g.exec(N); )
              var D = P.index;
            R = R.slice(0, D === i ? E : D);
          }
        } else if (n.indexOf(_n(g), E) != E) {
          var G = R.lastIndexOf(g);
          G > -1 && (R = R.slice(0, G));
        }
        return R + c;
      }
      function hx(n) {
        return n = vt(n), n && ii.test(n) ? n.replace(ae, Wp) : n;
      }
      var dx = Er(function(n, r, a) {
        return n + (a ? " " : "") + r.toUpperCase();
      }), au = ul("toUpperCase");
      function ah(n, r, a) {
        return n = vt(n), r = a ? i : r, r === i ? kp(n) ? jp(n) : Cp(n) : n.match(r) || [];
      }
      var sh = st(function(n, r) {
        try {
          return gn(n, i, r);
        } catch (a) {
          return eu(a) ? a : new rt(a);
        }
      }), gx = le(function(n, r) {
        return An(r, function(a) {
          a = Vn(a), ce(n, a, tu(n[a], n));
        }), n;
      });
      function px(n) {
        var r = n == null ? 0 : n.length, a = V();
        return n = r ? $t(n, function(c) {
          if (typeof c[1] != "function")
            throw new En(f);
          return [a(c[0]), c[1]];
        }) : [], st(function(c) {
          for (var g = -1; ++g < r; ) {
            var v = n[g];
            if (gn(v[0], this, c))
              return gn(v[1], this, c);
          }
        });
      }
      function _x(n) {
        return W_($n(n, y));
      }
      function su(n) {
        return function() {
          return n;
        };
      }
      function vx(n, r) {
        return n == null || n !== n ? r : n;
      }
      var mx = fl(), yx = fl(!0);
      function cn(n) {
        return n;
      }
      function uu(n) {
        return Bf(typeof n == "function" ? n : $n(n, y));
      }
      function xx(n) {
        return Uf($n(n, y));
      }
      function wx(n, r) {
        return Gf(n, $n(r, y));
      }
      var Ax = st(function(n, r) {
        return function(a) {
          return pi(a, n, r);
        };
      }), Ex = st(function(n, r) {
        return function(a) {
          return pi(n, a, r);
        };
      });
      function cu(n, r, a) {
        var c = Ut(r), g = Lo(r, c);
        a == null && !(Ct(r) && (g.length || !c.length)) && (a = r, r = n, n = this, g = Lo(r, Ut(r)));
        var v = !(Ct(a) && "chain" in a) || !!a.chain, x = de(n);
        return An(g, function(E) {
          var R = r[E];
          n[E] = R, x && (n.prototype[E] = function() {
            var P = this.__chain__;
            if (v || P) {
              var N = n(this.__wrapped__), D = N.__actions__ = an(this.__actions__);
              return D.push({ func: R, args: arguments, thisArg: n }), N.__chain__ = P, N;
            }
            return R.apply(n, Ce([this.value()], arguments));
          });
        }), n;
      }
      function Tx() {
        return zt._ === this && (zt._ = Vp), this;
      }
      function fu() {
      }
      function $x(n) {
        return n = ot(n), st(function(r) {
          return jf(r, n);
        });
      }
      var Rx = Ws($t), Cx = Ws(lf), Sx = Ws(hs);
      function uh(n) {
        return Ys(n) ? ds(Vn(n)) : iv(n);
      }
      function bx(n) {
        return function(r) {
          return n == null ? i : Ye(n, r);
        };
      }
      var Ox = hl(), Ix = hl(!0);
      function lu() {
        return [];
      }
      function hu() {
        return !1;
      }
      function Lx() {
        return {};
      }
      function Mx() {
        return "";
      }
      function Px() {
        return !0;
      }
      function Nx(n, r) {
        if (n = ot(n), n < 1 || n > St)
          return [];
        var a = Gt, c = qt(n, Gt);
        r = V(r), n -= Gt;
        for (var g = _s(c, r); ++a < n; )
          r(a);
        return g;
      }
      function kx(n) {
        return it(n) ? $t(n, Vn) : vn(n) ? [n] : an(Sl(vt(n)));
      }
      function Dx(n) {
        var r = ++Yp;
        return vt(n) + r;
      }
      var Fx = Fo(function(n, r) {
        return n + r;
      }, 0), Hx = Us("ceil"), Bx = Fo(function(n, r) {
        return n / r;
      }, 1), Wx = Us("floor");
      function Ux(n) {
        return n && n.length ? Io(n, cn, Cs) : i;
      }
      function Gx(n, r) {
        return n && n.length ? Io(n, V(r, 2), Cs) : i;
      }
      function jx(n) {
        return gf(n, cn);
      }
      function zx(n, r) {
        return gf(n, V(r, 2));
      }
      function Xx(n) {
        return n && n.length ? Io(n, cn, Is) : i;
      }
      function Kx(n, r) {
        return n && n.length ? Io(n, V(r, 2), Is) : i;
      }
      var Yx = Fo(function(n, r) {
        return n * r;
      }, 1), qx = Us("round"), Vx = Fo(function(n, r) {
        return n - r;
      }, 0);
      function Zx(n) {
        return n && n.length ? ps(n, cn) : 0;
      }
      function Jx(n, r) {
        return n && n.length ? ps(n, V(r, 2)) : 0;
      }
      return p.after = xm, p.ary = Hl, p.assign = sy, p.assignIn = Ql, p.assignInWith = Zo, p.assignWith = uy, p.at = cy, p.before = Bl, p.bind = tu, p.bindAll = gx, p.bindKey = Wl, p.castArray = Lm, p.chain = kl, p.chunk = Wv, p.compact = Uv, p.concat = Gv, p.cond = px, p.conforms = _x, p.constant = su, p.countBy = Z1, p.create = fy, p.curry = Ul, p.curryRight = Gl, p.debounce = jl, p.defaults = ly, p.defaultsDeep = hy, p.defer = wm, p.delay = Am, p.difference = jv, p.differenceBy = zv, p.differenceWith = Xv, p.drop = Kv, p.dropRight = Yv, p.dropRightWhile = qv, p.dropWhile = Vv, p.fill = Zv, p.filter = Q1, p.flatMap = em, p.flatMapDeep = rm, p.flatMapDepth = im, p.flatten = Ll, p.flattenDeep = Jv, p.flattenDepth = Qv, p.flip = Em, p.flow = mx, p.flowRight = yx, p.fromPairs = t1, p.functions = yy, p.functionsIn = xy, p.groupBy = om, p.initial = e1, p.intersection = r1, p.intersectionBy = i1, p.intersectionWith = o1, p.invert = Ay, p.invertBy = Ey, p.invokeMap = sm, p.iteratee = uu, p.keyBy = um, p.keys = Ut, p.keysIn = un, p.map = zo, p.mapKeys = $y, p.mapValues = Ry, p.matches = xx, p.matchesProperty = wx, p.memoize = Ko, p.merge = Cy, p.mergeWith = th, p.method = Ax, p.methodOf = Ex, p.mixin = cu, p.negate = Yo, p.nthArg = $x, p.omit = Sy, p.omitBy = by, p.once = Tm, p.orderBy = cm, p.over = Rx, p.overArgs = $m, p.overEvery = Cx, p.overSome = Sx, p.partial = nu, p.partialRight = zl, p.partition = fm, p.pick = Oy, p.pickBy = nh, p.property = uh, p.propertyOf = bx, p.pull = c1, p.pullAll = Pl, p.pullAllBy = f1, p.pullAllWith = l1, p.pullAt = h1, p.range = Ox, p.rangeRight = Ix, p.rearg = Rm, p.reject = dm, p.remove = d1, p.rest = Cm, p.reverse = Js, p.sampleSize = pm, p.set = Ly, p.setWith = My, p.shuffle = _m, p.slice = g1, p.sortBy = ym, p.sortedUniq = w1, p.sortedUniqBy = A1, p.split = ex, p.spread = Sm, p.tail = E1, p.take = T1, p.takeRight = $1, p.takeRightWhile = R1, p.takeWhile = C1, p.tap = U1, p.throttle = bm, p.thru = jo, p.toArray = Vl, p.toPairs = eh, p.toPairsIn = rh, p.toPath = kx, p.toPlainObject = Jl, p.transform = Py, p.unary = Om, p.union = S1, p.unionBy = b1, p.unionWith = O1, p.uniq = I1, p.uniqBy = L1, p.uniqWith = M1, p.unset = Ny, p.unzip = Qs, p.unzipWith = Nl, p.update = ky, p.updateWith = Dy, p.values = Rr, p.valuesIn = Fy, p.without = P1, p.words = ah, p.wrap = Im, p.xor = N1, p.xorBy = k1, p.xorWith = D1, p.zip = F1, p.zipObject = H1, p.zipObjectDeep = B1, p.zipWith = W1, p.entries = eh, p.entriesIn = rh, p.extend = Ql, p.extendWith = Zo, cu(p, p), p.add = Fx, p.attempt = sh, p.camelCase = Uy, p.capitalize = ih, p.ceil = Hx, p.clamp = Hy, p.clone = Mm, p.cloneDeep = Nm, p.cloneDeepWith = km, p.cloneWith = Pm, p.conformsTo = Dm, p.deburr = oh, p.defaultTo = vx, p.divide = Bx, p.endsWith = Gy, p.eq = Pn, p.escape = jy, p.escapeRegExp = zy, p.every = J1, p.find = tm, p.findIndex = Ol, p.findKey = dy, p.findLast = nm, p.findLastIndex = Il, p.findLastKey = gy, p.floor = Wx, p.forEach = Dl, p.forEachRight = Fl, p.forIn = py, p.forInRight = _y, p.forOwn = vy, p.forOwnRight = my, p.get = iu, p.gt = Fm, p.gte = Hm, p.has = wy, p.hasIn = ou, p.head = Ml, p.identity = cn, p.includes = am, p.indexOf = n1, p.inRange = By, p.invoke = Ty, p.isArguments = Ze, p.isArray = it, p.isArrayBuffer = Bm, p.isArrayLike = sn, p.isArrayLikeObject = It, p.isBoolean = Wm, p.isBuffer = Pe, p.isDate = Um, p.isElement = Gm, p.isEmpty = jm, p.isEqual = zm, p.isEqualWith = Xm, p.isError = eu, p.isFinite = Km, p.isFunction = de, p.isInteger = Xl, p.isLength = qo, p.isMap = Kl, p.isMatch = Ym, p.isMatchWith = qm, p.isNaN = Vm, p.isNative = Zm, p.isNil = Qm, p.isNull = Jm, p.isNumber = Yl, p.isObject = Ct, p.isObjectLike = Ot, p.isPlainObject = wi, p.isRegExp = ru, p.isSafeInteger = ty, p.isSet = ql, p.isString = Vo, p.isSymbol = vn, p.isTypedArray = $r, p.isUndefined = ny, p.isWeakMap = ey, p.isWeakSet = ry, p.join = a1, p.kebabCase = Xy, p.last = Cn, p.lastIndexOf = s1, p.lowerCase = Ky, p.lowerFirst = Yy, p.lt = iy, p.lte = oy, p.max = Ux, p.maxBy = Gx, p.mean = jx, p.meanBy = zx, p.min = Xx, p.minBy = Kx, p.stubArray = lu, p.stubFalse = hu, p.stubObject = Lx, p.stubString = Mx, p.stubTrue = Px, p.multiply = Yx, p.nth = u1, p.noConflict = Tx, p.noop = fu, p.now = Xo, p.pad = qy, p.padEnd = Vy, p.padStart = Zy, p.parseInt = Jy, p.random = Wy, p.reduce = lm, p.reduceRight = hm, p.repeat = Qy, p.replace = tx, p.result = Iy, p.round = qx, p.runInContext = $, p.sample = gm, p.size = vm, p.snakeCase = nx, p.some = mm, p.sortedIndex = p1, p.sortedIndexBy = _1, p.sortedIndexOf = v1, p.sortedLastIndex = m1, p.sortedLastIndexBy = y1, p.sortedLastIndexOf = x1, p.startCase = rx, p.startsWith = ix, p.subtract = Vx, p.sum = Zx, p.sumBy = Jx, p.template = ox, p.times = Nx, p.toFinite = ge, p.toInteger = ot, p.toLength = Zl, p.toLower = ax, p.toNumber = Sn, p.toSafeInteger = ay, p.toString = vt, p.toUpper = sx, p.trim = ux, p.trimEnd = cx, p.trimStart = fx, p.truncate = lx, p.unescape = hx, p.uniqueId = Dx, p.upperCase = dx, p.upperFirst = au, p.each = Dl, p.eachRight = Fl, p.first = Ml, cu(p, function() {
        var n = {};
        return Yn(p, function(r, a) {
          mt.call(p.prototype, a) || (n[a] = r);
        }), n;
      }(), { chain: !1 }), p.VERSION = o, An(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n) {
        p[n].placeholder = p;
      }), An(["drop", "take"], function(n, r) {
        lt.prototype[n] = function(a) {
          a = a === i ? 1 : Bt(ot(a), 0);
          var c = this.__filtered__ && !r ? new lt(this) : this.clone();
          return c.__filtered__ ? c.__takeCount__ = qt(a, c.__takeCount__) : c.__views__.push({
            size: qt(a, Gt),
            type: n + (c.__dir__ < 0 ? "Right" : "")
          }), c;
        }, lt.prototype[n + "Right"] = function(a) {
          return this.reverse()[n](a).reverse();
        };
      }), An(["filter", "map", "takeWhile"], function(n, r) {
        var a = r + 1, c = a == yt || a == Pt;
        lt.prototype[n] = function(g) {
          var v = this.clone();
          return v.__iteratees__.push({
            iteratee: V(g, 3),
            type: a
          }), v.__filtered__ = v.__filtered__ || c, v;
        };
      }), An(["head", "last"], function(n, r) {
        var a = "take" + (r ? "Right" : "");
        lt.prototype[n] = function() {
          return this[a](1).value()[0];
        };
      }), An(["initial", "tail"], function(n, r) {
        var a = "drop" + (r ? "" : "Right");
        lt.prototype[n] = function() {
          return this.__filtered__ ? new lt(this) : this[a](1);
        };
      }), lt.prototype.compact = function() {
        return this.filter(cn);
      }, lt.prototype.find = function(n) {
        return this.filter(n).head();
      }, lt.prototype.findLast = function(n) {
        return this.reverse().find(n);
      }, lt.prototype.invokeMap = st(function(n, r) {
        return typeof n == "function" ? new lt(this) : this.map(function(a) {
          return pi(a, n, r);
        });
      }), lt.prototype.reject = function(n) {
        return this.filter(Yo(V(n)));
      }, lt.prototype.slice = function(n, r) {
        n = ot(n);
        var a = this;
        return a.__filtered__ && (n > 0 || r < 0) ? new lt(a) : (n < 0 ? a = a.takeRight(-n) : n && (a = a.drop(n)), r !== i && (r = ot(r), a = r < 0 ? a.dropRight(-r) : a.take(r - n)), a);
      }, lt.prototype.takeRightWhile = function(n) {
        return this.reverse().takeWhile(n).reverse();
      }, lt.prototype.toArray = function() {
        return this.take(Gt);
      }, Yn(lt.prototype, function(n, r) {
        var a = /^(?:filter|find|map|reject)|While$/.test(r), c = /^(?:head|last)$/.test(r), g = p[c ? "take" + (r == "last" ? "Right" : "") : r], v = c || /^find/.test(r);
        g && (p.prototype[r] = function() {
          var x = this.__wrapped__, E = c ? [1] : arguments, R = x instanceof lt, P = E[0], N = R || it(x), D = function(ct) {
            var ht = g.apply(p, Ce([ct], E));
            return c && G ? ht[0] : ht;
          };
          N && a && typeof P == "function" && P.length != 1 && (R = N = !1);
          var G = this.__chain__, Y = !!this.__actions__.length, Z = v && !G, at = R && !Y;
          if (!v && N) {
            x = at ? x : new lt(this);
            var J = n.apply(x, E);
            return J.__actions__.push({ func: jo, args: [D], thisArg: i }), new Tn(J, G);
          }
          return Z && at ? n.apply(this, E) : (J = this.thru(D), Z ? c ? J.value()[0] : J.value() : J);
        });
      }), An(["pop", "push", "shift", "sort", "splice", "unshift"], function(n) {
        var r = _o[n], a = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", c = /^(?:pop|shift)$/.test(n);
        p.prototype[n] = function() {
          var g = arguments;
          if (c && !this.__chain__) {
            var v = this.value();
            return r.apply(it(v) ? v : [], g);
          }
          return this[a](function(x) {
            return r.apply(it(x) ? x : [], g);
          });
        };
      }), Yn(lt.prototype, function(n, r) {
        var a = p[r];
        if (a) {
          var c = a.name + "";
          mt.call(xr, c) || (xr[c] = []), xr[c].push({ name: r, func: a });
        }
      }), xr[Do(i, I).name] = [{
        name: "wrapper",
        func: i
      }], lt.prototype.clone = h_, lt.prototype.reverse = d_, lt.prototype.value = g_, p.prototype.at = G1, p.prototype.chain = j1, p.prototype.commit = z1, p.prototype.next = X1, p.prototype.plant = Y1, p.prototype.reverse = q1, p.prototype.toJSON = p.prototype.valueOf = p.prototype.value = V1, p.prototype.first = p.prototype.head, ui && (p.prototype[ui] = K1), p;
    }, vr = zp();
    Ge ? ((Ge.exports = vr)._ = vr, us._ = vr) : zt._ = vr;
  }).call(ye);
})(Da, Da.exports);
var dk = Da.exports;
const zg = (t) => Array.isArray(t) && t.every((e) => typeof e == "string"), gk = (t, e) => zg(t) ? hc().domain(t).range([0, e]).paddingInner(0.1).paddingOuter(0) : xe().domain(t).range([e, 0]).clamp(!0).nice(), pk = (t, e) => zg(t) ? hc().domain(t).range([0, e]).paddingInner(0.1).paddingOuter(0) : xe().domain(t).range([0, e]).clamp(!0).nice(), _k = (t) => {
  const { min: e, max: i } = t.reduce(
    (o, s) => o.min === void 0 || s < o.min ? { ...o, min: s } : o.max === void 0 || s > o.max ? { ...o, max: s } : o,
    { min: void 0, max: void 0 }
  );
  return { min: e || 0, max: i || 0 };
}, vk = (t) => (e, i) => {
  if (e)
    return t.map((l) => l.category);
  const o = t.flatMap(({ value: l, endValue: h }) => h ? [l, h] : [l]), s = i || o, { min: u, max: f } = _k(s);
  return [u, f];
}, mk = (t, e) => e != null && e.width ? e.width : e != null && e.label ? Cu.NUMERICAL_WITH_LABEL : t ? Cu.CATEGORICAL : Cu.NUMERICAL_WITHOUT_LABEL, yk = (t, e) => e != null && e.height ? e.height : e != null && e.label ? Ru.NUMERICAL_WITH_LABEL : t ? Ru.CATEGORICAL : Ru.NUMERICAL_WITHOUT_LABEL, xk = (t, e) => {
  if (e.length * Zd > t) {
    const i = dk.floor(t / Zd) - Yt.STROKE_WIDTH * 2;
    return `${e.slice(0, i)}...`;
  }
  return e;
}, wk = ({ axisSetup: t, yAxisWidth: e, canvasHeight: i, scale: o }) => {
  const u = Dt().colours.visualisations.base.chartLines.axis, f = Gg(Dc.X, !1, t);
  return /* @__PURE__ */ w.jsxs("g", { transform: `translate(${e}, ${Ur})`, children: [
    /* @__PURE__ */ w.jsx(
      jg,
      {
        scale: o,
        orient: Kt.left,
        ...f,
        tickFormat: (l) => typeof l == "string" ? xk(e, l) : l
      }
    ),
    (t == null ? void 0 : t.label) && /* @__PURE__ */ w.jsx(
      "g",
      {
        transform: `translate(${-(e - Wi.CATEGORICAL + Yt.LENGTH)}, ${i})`,
        children: /* @__PURE__ */ w.jsx(Gn, { variant: "bodyMedium", as: "text", transform: "rotate(-90)", textAnchor: "start", fill: u, children: t.label })
      }
    )
  ] });
}, Ak = ({
  axisSetup: t,
  xAxisHeight: e,
  yAxisWidth: i,
  chartHeight: o,
  scale: s
}) => {
  const f = Dt().colours.visualisations.base.chartLines.axis, l = Gg(Dc.Y, !0, t);
  return /* @__PURE__ */ w.jsxs("g", { transform: `translate(${i + Ur}, ${o - e})`, children: [
    /* @__PURE__ */ w.jsx(
      jg,
      {
        scale: s,
        orient: Kt.bottom,
        tickValues: t == null ? void 0 : t.notches,
        ...l
      }
    ),
    (t == null ? void 0 : t.label) && /* @__PURE__ */ w.jsx("g", { transform: `translate(0, ${Ur + Wi.NUMERICAL})`, children: /* @__PURE__ */ w.jsx(Gn, { variant: "bodyMedium", as: "text", textAnchor: "start", fill: f, children: t.label }) })
  ] });
}, Ek = ({
  data: t,
  leftAxis: e,
  bottomAxis: i,
  chartHeight: o,
  chartWidth: s = ik,
  barSize: u,
  chartOrientation: f = "VERTICAL"
}) => {
  const l = f === "VERTICAL", h = yk(l, i), d = mk(!l, e), _ = vk(t), y = _(l, i == null ? void 0 : i.notches), m = _(!l, e == null ? void 0 : e.notches), T = ck(t.length, h, u, o), S = s - uc - d, b = T + uc + h, M = pk(y, S), I = gk(m, T);
  return /* @__PURE__ */ w.jsxs("svg", { viewBox: `0 0 ${s} ${b}`, className: "w-full", children: [
    /* @__PURE__ */ w.jsx(
      wk,
      {
        canvasHeight: T,
        xAxisHeight: h,
        yAxisWidth: d,
        axisSetup: e,
        scale: I
      }
    ),
    /* @__PURE__ */ w.jsx(
      Ak,
      {
        chartHeight: b,
        xAxisHeight: h,
        yAxisWidth: d,
        axisSetup: i,
        scale: M
      }
    ),
    /* @__PURE__ */ w.jsx("g", { transform: `translate(${d + Ur}, ${Ur})`, children: t.map((C) => /* @__PURE__ */ w.jsx(
      "rect",
      {
        stroke: "none",
        ...uk(M, I, C, T, l)
      },
      C.id
    )) })
  ] });
};
const bk = {
  Radar: Wa,
  LegendRadar: Q2,
  SimplifiedRadar: t$,
  ResponsiveRadar: n$,
  PitchViz: m$,
  EventMarkerLayer: IP,
  EventArrowLayer: MP,
  FallbackLayer: DP,
  CustomShapeLayer: kN,
  GridSelectionLayer: FP,
  GridLinesLayer: HP,
  Spoke: NN,
  Heatmap: Dg,
  SelectionLayer: Eg,
  isPointWithinRect: XP,
  isArrowWithinRect: KP,
  JumpToWrapper: DN,
  GridBumpersLayer: FN,
  PitchSelectionLayer: JP,
  PitchHeatmapLayer: HN,
  PositionSelectionLayer: WN,
  BOX_PLUS_CHANNELS_GRID_ZONES: QP,
  BOX_PLUS_CHANNELS_GRID_LINES: tN,
  BOX_PLUS_CHANNELS_GRID_ZONE_GROUPS: nN,
  AttackingDirectionArrow: XN,
  Legend: KN,
  GradientBar: ZN,
  GradientDots: JN,
  ColouredMarkers: Wg,
  ClassifiedMarkers: tk,
  ColouredArrowMarkers: nk,
  useXGScale: ek,
  BarChart: Ek,
  useGradient: Ya
};
export {
  XN as AttackingDirectionArrow,
  tN as BOX_PLUS_CHANNELS_GRID_LINES,
  QP as BOX_PLUS_CHANNELS_GRID_ZONES,
  nN as BOX_PLUS_CHANNELS_GRID_ZONE_GROUPS,
  Ek as BarChart,
  tk as ClassifiedMarkers,
  nk as ColouredArrowMarkers,
  Wg as ColouredMarkers,
  kN as CustomShapeLayer,
  MP as EventArrowLayer,
  IP as EventMarkerLayer,
  DP as FallbackLayer,
  ZN as GradientBar,
  JN as GradientDots,
  FN as GridBumpersLayer,
  Sk as GridColoursLayer,
  HP as GridLinesLayer,
  FP as GridSelectionLayer,
  Dg as Heatmap,
  DN as JumpToWrapper,
  KN as Legend,
  Q2 as LegendRadar,
  HN as PitchHeatmapLayer,
  JP as PitchSelectionLayer,
  m$ as PitchViz,
  WN as PositionSelectionLayer,
  Wa as Radar,
  n$ as ResponsiveRadar,
  Eg as SelectionLayer,
  t$ as SimplifiedRadar,
  NN as Spoke,
  bk as default,
  KP as isArrowWithinRect,
  XP as isPointWithinRect,
  Ya as useGradient,
  ek as useXGScale
};
